/**
 * Traductions complètes — toutes les clés y compris garde-robe voyage
 * Langues : fr, en, es, it, de, pt, ar, ru, tr, + fallbacks
 */

export const translations = {

/* ══════════════════════════════════════════════════════════
 *  FRANÇAIS
 * ══════════════════════════════════════════════════════════ */
fr: {
  nav_home:'Home', nav_looks:'Looks', nav_wardrobe:'Dressing',
  nav_catalog:'Catalogue', nav_favorites:'Favoris', nav_looks_ia:'Looks IA',
  nav_alerts:'Alertes', nav_profile:'Profil', nav_travel:'Voyage',
  good_morning:'Bonjour', good_afternoon:'Bon après-midi', good_evening:'Bonsoir', guest:'Invité',
  occ_evening:'Soirée', occ_dinner:'Dîner', occ_casual:'Sortie',
  occ_work:'Travail', occ_date:'Rendez-vous', occ_travel:'Voyage',
  look_of_day:'Look du jour', suggestions:'Suggestions',
  compatibility:'Compatibilité', perfect:'Parfait', excellent:'Excellent', good:'Bien',
  ai_tip:'Conseil IA', complete_outfit:'Compléter la tenue', see_all:'Voir tout',
  missing_pieces:'À acheter', full_wardrobe:'✓ Tout dans le dressing', to_buy:'À acheter',
  budget:'Budget', no_limit:'Sans limite', no_looks_budget:'Aucun look dans ce budget',
  remove_filter:'Supprimer le filtre', all_occasions:'Toutes',
  my_wardrobe:'Garde-robe', pieces:'pièces', search_item:'Chercher une pièce...',
  add_item:'+ Ajouter', all_categories:'Tout', all_partners:'Tous',
  cat_dresses:'Robes', cat_tops:'Hauts', cat_jackets:'Vestes',
  cat_bottoms:'Bas', cat_shoes:'Chaussures', cat_bags:'Sacs',
  cat_accessories:'Accessoires', cat_jewelry:'Bijoux',
  cat_swimwear:'Maillots', cat_sportswear:'Sport',
  travel_wardrobe:'Garde-robe voyage', my_trips:'Mes voyages',
  new_trip:'Nouveau voyage', trip_name:'Nom du voyage',
  destination:'Destination', departure:'Départ', return_date:'Retour',
  packed_items:'Pièces emballées', outfit_suggestions:'Tenues suggérées',
  weather_dest:'Météo à destination', add_to_bag:'Ajouter à la valise',
  whats_in_my_bag:'Dans ma valise', travel_looks:'Looks voyage',
  pack_light:'Voyager léger', dont_forget:'À ne pas oublier',
  trip_style:'Style du voyage', days_count:'jours',
  my_cart:'Mon panier', subtotal:'Sous-total', shipping:'Livraison',
  free_shipping:'Offerte', total:'Total', secure_payment:'Paiement sécurisé',
  order_now:'Commander', delivery_address:'Adresse de livraison',
  empty_cart:'Panier vide',
  alerts_stock:'Alertes & Stock', notifications:'Notifications',
  my_alerts:'Mes alertes', mark_all_read:'Tout lire',
  back_in_stock:'De retour en stock !', price_drop:'Baisse de prix',
  low_stock:'Stock limité', view_item:'Voir l\'article →', add_to_cart:'Ajouter au panier',
  watch_item:'Surveiller', in_stock:'En stock', out_of_stock:'Hors stock',
  my_profile:'Mon profil', member_since:'Membre depuis',
  settings:'Paramètres', language:'Langue', currency:'Devise',
  region:'Région', sign_out:'Se déconnecter', follow_us:'Suivez-nous',
  loading:'Chargement...', cancel:'Annuler', confirm:'Confirmer',
  save:'Enregistrer', edit:'Modifier', delete:'Supprimer',
  close:'Fermer', back:'Retour', search:'Rechercher',
  filter:'Filtrer', sort:'Trier', share:'Partager',
  // ═══ Profil — sections + paramètres ═══
  my_account:'MON COMPTE', my_style_ai:'MON STYLE IA',
  rewards:'RÉCOMPENSES', quick_access:'ACCÈS RAPIDE',
  region_language:'RÉGION & LANGUE', settings_caps:'PARAMÈTRES',
  my_earnings:'MES GAINS', subscription:'ABONNEMENT',
  looks_created:'Looks créés', purchases:'Achats',
  push_notifications:'Notifications push', integrated_weather:'Météo intégrée',
  dark_mode:'Mode sombre', daily_prefs:'Préférences du jour',
  edit_profile:'Modifier le profil', restore_purchases:'Restaurer les achats',
  delete_account:'Supprimer mon compte', terms_conditions:'Conditions d\'utilisation',
  privacy_policy:'Politique de confidentialité', terms_of_sale:'Conditions de vente', help_support:'Aide & support',
  legal:'Légal', upgrade:'Passer Premium', current_plan:'Plan actuel',
  free_plan:'Gratuit', basic_plan:'Basic', premium_plan:'Premium', gold_plan:'Gold',
  my_preferences:'Mes préférences', favorites:'Favoris', saved_items:'Articles sauvegardés', cashback_earnings:'Mes crédits',
  sign_out_q:'Voulez-vous vous déconnecter ?',
  formality:'Formalité', dominant_palette:'Palette dominante', detected_styles:'Styles détectés', top_category:'Top catégorie', avg_price:'Prix moyen',
  style_empty_title:'Profil non encore analysé', style_empty_desc:'Ajoutez des articles à votre dressing, IA analysera automatiquement votre style.', go_to_wardrobe:'Aller au dressing →',
  ai_stylist:'STYLISTE IA', your_wardrobe:'Votre garde-robe', view_all:'Voir tout', categories:'Catégories', ai_analyzed:'Analysés IA', boost_style:'Pour booster votre style', create_wardrobe:'Créer mon dressing', create_wardrobe_desc:'Ajoutez vos vêtements pour des suggestions personnalisées', trending_week:'TENDANCES DE LA SEMAINE', trending_subtitle:'Ce qui est trending', complete_outfits:'TENUES COMPLÈTES', stylist_selection:'Sélection styliste IA', stylist_selection_desc:'Looks IA composés depuis le catalogue', loading_outfits:'Chargement des tenues en cours…', discover_outfit:'DÉCOUVRIR LA TENUE', collapse:'Réduire', catalog_caps:'CATALOGUE', view_full_catalog:'Voir le catalogue complet', navigation_caps:'NAVIGATION', quick_nav:'Accès rapide', bought_add_to_wardrobe:'J\'ai acheté → Ajouter au dressing',
  delete_account_q1:'Cette action est irréversible. Toutes vos données (dressing, voyages, looks, alertes, abonnement) seront supprimées définitivement.', delete_account_q2:'Confirmer la suppression définitive de votre compte ?', delete_confirm:'Supprimer', delete_account_error:'La suppression a échoué. Réessayez plus tard ou contactez le support.',
  // v1.12.273 — Phase B i18n : WardrobeScreen MyTenue
  my_pieces:'Mes pièces',
  tooltip_create_new_look:'Créer un nouveau look à partir de vos pièces',
  tooltip_add_item_photo_or_url:'Ajouter un article à votre dressing — photo ou import depuis une URL',
  wardrobe_fully_analyzed:'Dressing entièrement analysé · {count} articles',
  ai_analysis_in_progress:'Analyse IA en cours',
  one_item_pending_analysis:'1 article en attente d\'analyse',
  items_pending_analysis:'{count} articles en attente d\'analyse',
  analyzed_label:'analysés',
  remaining_label:'restants',
  auto_analysis_background:'⏳ Auto-analyse en arrière-plan',
  one_personal_look:'1 look personnalisé',
  personal_looks_count:'{count} looks personnalisés',
  create_own_looks_hint:'Créez vos propres looks avec vos articles + suggestions shopping',
  tooltip_create_complete_look:'Créer un look complet — sélectionnez vos pièces et l\'IA suggère des compléments shopping',
  create_first_look_desc:'Créez votre premier look en sélectionnant des articles de votre dressing et laissez l\'IA suggérer des pièces complémentaires à shopper.',
  tooltip_regenerate_shopping_suggestions:'Régénérer les suggestions shopping pour ce look',
  my_look_default:'Mon look',
  complete_or_replace:'Compléter ou remplacer',
  more_items_short:'Plus\nd\'articles',
  generate_more_items:'Générer plus\nd\'articles',
  no_valid_suggestions_yet:'Aucune suggestion valide pour le moment',
  generate_suggestions:'Générer des suggestions',
  delete_this_look_q:'Supprimer ce look ?',
  action_irreversible:'Cette action est irréversible.',
  delete_this_look:'Supprimer ce look',
  ai_analysis_in_progress_dots:'Analyse IA en cours…\nLes détails apparaîtront ici une fois l\'analyse terminée.',
  used_in_looks_count:'Utilisé dans {count} look(s)',
  create_a_look:'Créer un look',
  confirm_remove_from_wardrobe:'Retirer « {name} » de votre garde-robe ?\nCette action est irréversible.',
  look_created_title:'✨ Look créé !',
  look_created_msg:'Votre look « {name} » a été enregistré avec {items} article(s) et {suggestions} suggestion(s).',
  permission_camera_required:'Autorisez l\'accès à la caméra',
  permission_gallery_required:'Autorisez l\'accès à la galerie',
  photo_required:'Photo requise',
  photo_required_msg:'Prenez une photo, choisissez-en une dans la galerie ou utilisez une URL.',
  add_a_piece:'Ajouter une pièce',
  take_a_photo:'Prendre une photo',
  photograph_your_item:'Photographier votre article',
  from_gallery:'Depuis la galerie',
  choose_existing_photo:'Choisir une photo existante',
  from_url:'Depuis une URL',
  instagram_facebook_article_link:'Lien Instagram, Facebook ou article',
  ai_will_detect_item_details:'🤖 L\'IA détectera le nom et les caractéristiques de l\'article.',
  category:'Catégorie',
  pseudo_optional:'Pseudo (optionnel)',
  pseudo_helper:'Un surnom personnel pour le retrouver facilement (recherche par nom IA + pseudo).',
  item_analyzed_title:'✨ Article analysé',
  item_analyzed_msg:'{name}\n→ {detected}\n\nL\'IA a identifié ses caractéristiques pour affiner vos suggestions de looks.',
  perfect_excl:'Parfait !',
  // v1.12.266 — Phase B i18n : modals AddOutfit + CalendarDayDetail
  add_outfit_title:'Ajouter une tenue', source_outfit_of_day:'Tenue du jour', source_my_looks:'Mes Looks', source_ai_looks:'Looks IA', source_manual_photo:'Photo manuelle', manual_photo_desc:'Importer une photo + ajouter occasion / notes', back_arrow:'← Retour', save_this_look:'Enregistrer ce look', save_this_ai_look:'Enregistrer ce look IA', confirm_and_add:'Confirmer & ajouter', delete_outfit_title:'Supprimer la tenue', outfit_worn:'Tenue portée', notes:'Notes', location:'Lieu', delete_this_outfit:'🗑  Supprimer cette tenue', permission_required:'Permission requise', permission_photos_required:'Autorisez l\'accès aux photos pour continuer.', photo_selection_failed:'Sélection photo impossible', outfit_already_exists:'Une tenue existe déjà', replace:'Remplacer', cannot_save_outfit:'Impossible d\'enregistrer la tenue', cannot_delete:'Impossible de supprimer', ai_recommendation:'recommandation IA', alternatives:'alternatives', no_look_created:'Aucun look créé pour l\'instant', no_ai_look_generated:'Aucun look IA généré (visitez l\'onglet Looks)', for_which_day:'Pour quel jour ?', select_date_worn:'Sélectionnez la date où vous portez ou avez porté cette tenue.', outfit_to_add:'Tenue à ajouter', selected_outfit:'Tenue sélectionnée', outfit_of_day_proposed:'Tenue du jour proposée', ai_recommendation_of_day:'Recommandation IA du jour', regenerate_arrow:'↻ Régénérer', for:'Pour :', no_ai_look_yet_hint:'Aucun look IA pour l\'instant. Ouvrez l\'onglet Looks IA pour en générer.', search_placeholder_full:'Rechercher (nom, marque, pseudo, pièce…)', filter_by_item:'Filtrer par article', clear_filter:'✕ Effacer', all:'Tout', no_look_matches_search:'Aucun look ne correspond à votre recherche.', displayed:'affichés', select_a_look:'Sélectionnez un look', no_personalised_look:'Aucun look personnalisé créé.', outfit_photo_optional:'Photo de la tenue (optionnel)', tap_to_import:'Toucher pour importer', occasion:'Occasion', notes_placeholder:'Ex : fonctionnait bien, à reporter…', saving_ellipsis:'Enregistrement…', added_from:'Ajouté depuis :',
  // ═══ AddByUrlModal + CreateLookModal — i18n ═══
  add_from_url_title:'Ajouter depuis une URL', add_url_subtitle:'Collez l\'URL d\'un article pour l\'ajouter à votre dressing',
  add_url_hint_main:'💡 Collez le lien d\'un article sur un site e-commerce de mode (Sézane, Nike, Chanel, Dior, Louis Vuitton, La Redoute…). On récupère l\'image automatiquement.',
  add_url_hint_social_label:'Pour Instagram ou Facebook', add_url_hint_social_text:' : faites clic droit sur la photo → "Copier l\'adresse de l\'image", puis utilisez la',
  add_url_hint_method2_label:'Méthode 2', add_url_hint_method2_field:'(champ "URL image").',
  paste_link_here:'Coller le lien ici…', search_button:'RECHERCHER',
  site_blocked_paste_image_link:'Site bloqué ? Coller l\'URL de l\'image', method2_badge:'MÉTHODE 2', image_url_label:'URL de l\'image',
  url_step_web_1:'Allez sur le site (Zara, etc.) dans un autre onglet',
  url_step_web_2:'Clic droit sur l\'image du produit',
  url_step_web_3:'Choisissez "Copier l\'adresse de l\'image" (ou "Copy image address")',
  url_step_web_4:'Revenez ici et collez l\'URL ci-dessous',
  url_step_native_1:'Allez sur le site dans Safari (Zara, etc.)',
  url_step_native_2:'Appui long sur l\'image du produit',
  url_step_native_3:'Choisissez "Copier l\'image"',
  url_step_native_4:'Revenez ici et collez ci-dessous',
  category_caps:'CATÉGORIE', add_via_image_button:'AJOUTER VIA IMAGE', or_add_by_photo:'Ou ajouter par photo 📸',
  preview_caps:'APERÇU', pseudo_optional_caps:'PSEUDO (OPTIONNEL)', pseudo_placeholder:'Ex : Mon préféré, Pull cosy hiver…',
  add_to_wardrobe_button:'AJOUTER AU DRESSING', try_another_url:'Essayer une autre URL',
  paste_url_error:'Collez une URL d\'un article (Zara, Sézane, Nike, Louis Vuitton…)',
  url_must_http:'L\'URL doit commencer par http:// ou https://',
  site_blocks_use_method2:'Ce site bloque l\'extraction automatique. Utilisez la Méthode 2 ↓',
  instagram_guide:'Instagram bloque l\'extraction automatique des posts. Pour ajouter cette photo : ouvrez le post dans votre navigateur, faites clic droit sur la photo → "Copier l\'adresse de l\'image", et collez-la dans le champ "URL image" ci-dessous.',
  facebook_guide:'Facebook bloque l\'extraction automatique des posts. Pour ajouter cette photo : ouvrez la photo en grand dans votre navigateur, faites clic droit → "Copier l\'adresse de l\'image", et collez-la dans le champ "URL image" ci-dessous.',
  site_blocks_paste_image_below:'Ce site bloque l\'extraction. Collez l\'URL de l\'image ci-dessous (Méthode 2).',
  site_unavailable_paste_image:'Site indisponible. Collez l\'URL de l\'image ci-dessous.',
  site_blocks_complete_manually:'Ce site bloque l\'extraction automatique. Complétez manuellement le prix et la photo.',
  network_error_paste_image:'Erreur réseau. Collez l\'URL de l\'image ci-dessous.',
  item_already_in_wardrobe:'⚠️ Article déjà dans votre dressing',
  you_already_have:'Vous avez déjà :', add_anyway_question:'Voulez-vous l\'ajouter quand même ? (par ex. taille différente)',
  add_anyway:'Ajouter quand même', similar_item:'Article similaire', size_paren:'(taille {size})',
  paste_image_url:'Collez l\'URL de l\'image (clic droit sur l\'image → copier l\'URL)',
  image_url_must_http:'L\'URL image doit commencer par http(s)://',
  brand_protected_title:'🛡️ Site très protégé',
  brand_protected_message:'Cette marque (Louis Vuitton, Hermès, etc.) bloque même nos systèmes anti-bot avancés.\n\nSolution simple :\n1. Revenez sur Safari\n2. Appui long sur l\'image\n3. "Ajouter aux Photos"\n4. Revenez ici → bouton 📸 Photo\n5. Choisissez l\'image depuis votre galerie',
  understood:'Compris', add_by_photo:'📸 Ajouter par photo',
  brand_protected_save_image:'Marque trop protégée. Sauvegardez l\'image dans Photos puis utilisez 📸 Photo.',
  session_expired:'Session expirée. Reconnectez-vous.',
  error_status_retry:'Erreur {status}. Réessayez.', network_error_retry:'Erreur réseau. Réessayez.',
  cat_coats:'Manteaux',
  occ_sport:'Sport', occ_ceremony:'Cérémonie', occ_weekend:'Week-end',
  occ_casual_desc:'Tenue décontractée au quotidien', occ_evening_desc:'Sortie le soir, dîner, événement',
  occ_work_desc:'Tenue professionnelle', occ_sport_desc:'Activité physique',
  occ_ceremony_desc:'Mariage, événement formel', occ_weekend_desc:'Balade, brunch, loisirs',
  occ_travel_desc:'Voyage, déplacement, escapade', occ_date_desc:'Sortie en duo, dîner romantique',
  more:'Plus', edit:'Modifier', your_look:'Mon look', temp_label:'Température', occasion_label:'Occasion', select_at_least_one_item:'Sélectionnez au moins un article pour continuer', zoom:'Zoom', badge_trending:'TENDANCE', from_catalog:'depuis catalogue',
  profile_privacy_notice:'Vos informations sont confidentielles et utilisées uniquement pour personnaliser votre expérience Mytenue.',
  not_clothing_title:'Pas un vêtement',
  not_clothing_msg:'L\'IA n\'a pas détecté de vêtement sur cette photo. Veuillez utiliser une image d\'un vêtement, chaussure, sac ou accessoire mode.',
  category_corrected_title:'Catégorie corrigée',
  category_corrected_msg:'L\'IA a corrigé la catégorie : "{user}" → "{ai}". L\'article est ajouté avec la bonne catégorie.',
  login_required:'Connexion requise', login_to_enable_reminders:'Connectez-vous pour activer les rappels.',
  mobile_only:'Disponible sur mobile uniquement', reminders_mobile_only:'Les rappels quotidiens nécessitent l\'application iOS ou Android.',
  cannot_enable_reminder:'Impossible d\'activer le rappel.',
  loading_in_progress:'Chargement en cours',
  catalog_still_loading:'Le catalogue est encore en chargement. Veuillez réessayer dans quelques secondes.',
  error:'Erreur', cannot_generate_suggestions:'Impossible de générer les suggestions pour le moment.',
  detail_label:'Détail :', try_restart_app:'Essayez de redémarrer l\'app ou de vous reconnecter.',
  alternatives_to_your_items:'Alternatives à vos articles', to_complete_your_look:'Pour compléter votre look',
  create_look_caps:'CRÉER UN LOOK',
  step_choose_items:'Choisir des articles', step_choose_occasion:'Choisir l\'occasion', step_complete_look:'Compléter le look',
  select_1_to_4_intro:'Sélectionnez', select_1_to_4_emphasis:'1 à 4 articles', select_1_to_4_outro:'de votre dressing pour créer un look.',
  // ═══ Source mode (Dressing / Catalogue / Mix) ═══
  source_mode_wardrobe:'Mon Dressing',
  source_mode_catalog:'Catalogue',
  source_mode_mix:'Mix',
  source_mode_label:'Source des articles',
  // v1.12.276 — WebSidebar footer (page hors connexion)
  sidebar_signin:'Se connecter',
  sidebar_guest_account:'Compte invité',
  sidebar_edited_by:'🇫🇷 Édité par MYTENUE (SASU)',
  sidebar_address:'17 rue Benoît Malon, 92150 Suresnes',
  sidebar_terms:'CGU',
  sidebar_privacy:'Confidentialité',
  sidebar_cgv:'CGV',
  sidebar_my_profile:'Mon profil',
  sidebar_sign_out:'Se déconnecter',
  // v1.12.278
  search_to_see_more:'Recherche pour voir plus',
  // v1.12.275 — RequireAuth (gates "Connecte-toi" sur les onglets gated)
  require_auth_cta:'Se connecter',
  require_auth_hint:'Inscription gratuite · Sans engagement',
  require_auth_default_title:'Espace personnel',
  require_auth_default_body:'Connectez-vous pour accéder à cette section.',
  require_auth_looks_title:'Vos looks personnalisés',
  require_auth_looks_body:'Connectez-vous pour générer des tenues à partir de votre dressing et du catalogue MyTenue.',
  require_auth_wardrobe_title:'Votre garde-robe',
  require_auth_wardrobe_body:'Connectez-vous pour ajouter vos vêtements et organiser votre dressing.',
  require_auth_travel_title:'Mode voyage',
  require_auth_travel_body:'Connectez-vous pour planifier vos valises avec MyTenue.',
  require_auth_favorites_title:'Vos favoris',
  require_auth_favorites_body:'Connectez-vous pour retrouver vos coups de cœur.',
  require_auth_profile_title:'Votre profil',
  require_auth_profile_body:'Connectez-vous pour gérer votre compte, vos commandes et vos préférences.',
  // v1.12.271 — UX refonte : tabs Dressing/Catalogue + selection cumulée
  tab_wardrobe:'👗 Dressing',
  tab_catalog:'🛍️ Catalogue',
  // v1.12.296 — choix des partenaires préférés
  daily_prefs_q_partners:'Quels partenaires préfères-tu ?',
  partner_tous:'TOUS',
  partner_iqueens:'iQueens',
  partner_suit:'Suit Negozi',
  partner_ann:'Ann Demeulemeester',
  partner_coutr:'COUTR',
  partner_drestige:'DRESTIGE',
  partner_tamaris:'Tamaris',
  partner_desigual:'Desigual',
  optional:'optionnel',
  // v1.12.291 — onglet Favoris dans Create Look
  tab_favorites:'❤️ Favoris',
  favorites_empty_title:'Aucun favori',
  favorites_empty_desc:'Ajoute des produits du catalogue à tes favoris pour les retrouver ici.',
  your_selection_header:'Mes articles sélectionnés',
  your_selection_empty:'Aucun article sélectionné — choisis dans le Dressing ou le Catalogue',
  badge_replace:'🔄 Remplace',
  badge_match:'✅ Match',
  ai_picks_per_category:'L’IA propose plusieurs alternatives par catégorie — pick celle que tu préfères',
  tap_to_swap:'Tap pour ajouter / remplacer',
  sources_from:'Sources : {wardrobe_count} du dressing · {catalog_count} du catalogue',
  empty_catalog_mode:'Aucun article catalogue dans cette catégorie',
  empty_wardrobe_mode:'Votre dressing est vide pour cette catégorie. Essayez \'Catalogue\' ou \'Mix\'.',
  items_selected_plural:'articles sélectionnés', item_selected_singular:'article sélectionné',
  ai_will_complete_look:'💡 L\'IA complétera ce look avec des articles adaptés',
  wardrobe_empty:'Dressing vide', add_items_first:'Ajouter des articles à votre dressing.',
  search_by_name_brand_pseudo:'Rechercher par nom, marque ou pseudo…',
  items_word_plural:'articles', item_word_singular:'article', filtered_suffix:'filtré',
  no_results:'Aucun résultat', change_search_or_category:'Modifiez votre recherche ou changez de catégorie.',
  search_in_my_looks_placeholder:'Rechercher (nom, catégorie, couleur, article…)',
  what_kind_of_look:'Quel type de look voulez-vous créer ?',
  ai_created_complete_look:'✨ L\'IA a créé un look complet autour de votre article',
  your_items_plus_ai:'Vos articles + suggestions IA pour compléter',
  your_items:'Vos articles', ai_suggestions_to_complete:'Suggestions IA pour compléter',
  stylist_advice_intro:'✨ Avis styliste : voici ce qui manque à votre look et les meilleurs articles partenaires pour compléter',
  essential_tag:'ESSENTIEL', searching_items_dots:'Recherche d\'articles…', more_items:'Plus d\'articles',
  next_arrow:'Suivant →', loading_catalog:'Catalogue…', loading_generation:'Génération…',
  generate_look:'Générer le look ✨', save_this_look_check:'Enregistrer ce look ✓',
  // ═══ v1.12.73 — Option A : score final, name suggestions, next actions ═══
  final_score_title:'Score final',
  final_score_subtitle:'Évaluation locale du look — banques style/couleur/matière',
  grade_label:'Note',
  grade_exceptional:'Exceptionnel',
  grade_excellent:'Excellent',
  grade_very_good:'Très bon',
  grade_good:'Bon',
  grade_decent:'Correct',
  grade_acceptable:'Acceptable',
  grade_needs_work:'À retravailler',
  grade_poor:'Faible',
  score_style_match:'Style',
  score_color_harmony:'Couleur',
  score_material_compat:'Matière',
  score_ai_vision:'Vision IA',
  score_context:'Contexte',
  badge_best_match:'★ BEST MATCH',
  badge_color_harmony:'Harmonie',
  badge_style_match:'Style',
  badge_fav_color:'Couleur favorite',
  badge_from_wardrobe:'Dressing',
  strengths_label:'Points forts',
  improvements_label:'À améliorer',
  // v1.12.269 — détails des conflits dans le breakdown
  conflict_material_label:'Matière incompatible',
  conflict_color_label:'Couleurs qui jurent',
  conflict_style_label:'Style hors-occasion',
  conflict_material_line:'{a} ({aMat} · {aFam}) + {b} ({bMat} · {bFam}) — peu compatibles',
  conflict_material_line_same_family:'{a} et {b} ({aFam}) — à équilibrer',
  conflict_color_line:'{a} ({aCol}) + {b} ({bCol}) — peu harmonieuses',
  conflict_style_line:'{item} colle plutôt à {actual} ({actualScore}/100) qu’à {wanted} ({wantedScore}/100)',
  conflict_missing_material:'Matière manquante sur : {names}',
  conflict_missing_color:'Couleur manquante sur : {names}',
  conflict_missing_occasion:'Tags d’occasion manquants sur : {names}',
  conflict_severity_high:'élevé',
  conflict_severity_medium:'modéré',
  fam_chic:'chic',
  fam_casual:'casual',
  fam_sport:'sport',
  fam_neutral:'neutre',
  fam_warm:'chaude',
  fam_cool:'froide',
  fam_earth:'terre',
  fam_bright:'vive',
  fam_pastel:'pastel',
  suggest_names_label:'Suggestions de noms',
  enter_look_name:'Nom du look',
  save_look_action:'Enregistrer le look',
  next_actions_title:'Que faire avec ce look ?',
  next_action_tryon:'✨ Essayage virtuel',
  // v1.12.282 — confirmation enregistrement + bouton voir mes looks
  look_saved_banner_title:'✓ Look enregistré',
  look_saved_banner_body:'Retrouve-le dans Garde-robe › Mes Looks',
  next_action_view_my_looks:'👗 Voir mes looks',
  sign_in_to_save_look_title:'Connecte-toi pour enregistrer ton look',
  sign_in_to_save_look_body:'Crée un compte gratuit pour sauvegarder tes looks dans ton dressing et les retrouver à tout moment.',
  // v1.12.283 — gate try-on (auth + abonnement)
  tryon_signin_title:'Connecte-toi pour essayer ce look',
  tryon_signin_body:'L’essayage virtuel nécessite un compte pour générer ton mannequin et conserver tes essayages.',
  tryon_subscribe_title:'Passe à l’offre premium',
  tryon_subscribe_body:'L’essayage virtuel est inclus dans les formules Basic, Premium et Gold. Active ton abonnement pour essayer ce look sur ton mannequin.',
  tryon_subscribe_cta:'Voir les abonnements',
  // v1.12.285 — favoris depuis Sélection styliste
  add_to_favorites_title:'Ajouter aux favoris',
  add_outfit_to_favorites_confirm:'Ce look et ses {count} pièces seront ajoutés à tes favoris. Continuer ?',
  confirm_add:'Ajouter',
  view_my_favorites:'❤️ Voir mes favoris',
  next_action_save:'💝 Enregistrer dans Mes Looks',
  next_action_saved:'💝 Enregistré ✓',
  next_action_calendar:'📅 Ajouter au calendrier',
  next_action_share:'📤 Partager',
  next_action_buy:'🛍️ Acheter les pièces manquantes',
  name_error_required:'Veuillez saisir un nom',
  name_error_too_short:'Nom trop court (3 caractères minimum)',
  name_error_too_long:'Nom trop long (50 caractères maximum)',
  name_error_only_digits:'Le nom ne peut pas être uniquement des chiffres',
  name_error_forbidden:'Mot non autorisé dans le nom',
  name_error_already_used:'Ce nom est déjà utilisé',
  weighted_label:'pondéré',
  // ═══ HomeScreen — i18n complet (v1.12.270+) ═══
  your_stylist_ai_caps:'VOTRE STYLISTE IA',
  outfit_calendar_tooltip:'Mon calendrier de tenues — suivez vos tenues au quotidien',
  outfit_calendar_label:'Calendrier de tenues',
  daily_prefs_tooltip:'Régler vos préférences du jour — style, occasion, budget',
  daily_short:'Du jour',
  outfit_of_day_section:'Tenue du jour',
  from_your_wardrobe:'De votre dressing',
  closest_to_taste:'Le plus proche de vos goûts',
  no_matching_outfit:'ℹ️ Aucune tenue ne matche exactement vos préférences — voici le look le plus proche.',
  not_enough_items:'Pas assez d\'articles',
  add_items_for_outfit:'Ajoutez des articles à votre dressing pour qu\'on puisse vous proposer une tenue (Haut + Bas + Chaussures, ou Robe + Chaussures).',
  add_an_item_caps:'+ AJOUTER UN ARTICLE',
  piece_caps:'PIÈCE',
  main_piece_caps:'PIÈCE PRINCIPALE',
  cat_accessories_short:'Access.',
  hide_accessories_caps:'↑ MASQUER ACCESSOIRES',
  view_accessories_jewelry_caps:'↓ VOIR {count} ACCESSOIRES & BIJOUX',
  view_accessories_jewelry:'Voir accessoires & bijoux',
  try_on_caps:'ESSAI',
  try_on:'Essai',
  try_on_outfit_tooltip:'Essayer cette tenue sur un mannequin (ou votre photo perso)',
  add_outfit_to_calendar_tooltip:'Ajouter cette tenue à mon calendrier',
  add_to_wardrobe_cta:'Ajouter dans le dressing',
  // v1.12.309 — CTA dressing vide sur l'accueil propose de composer un look depuis le catalogue
  empty_wardrobe_compose_from_catalog:'Compose ton premier look depuis notre catalogue, ajoute des pièces à ton dressing au fil de l\'eau.',
  diversified_by_category:'diversifié par catégorie',
  see:'Voir {count}',
  generating_stylist_selection:'Génération de votre sélection styliste…',
  badge_chic:'CHIC',
  badge_casual:'CASUAL',
  badge_office:'BUREAU',
  badge_sport:'SPORT',
  badge_feminine:'FÉMININ',
  badge_boho:'BOHÈME',
  badge_street:'STREET',
  badge_minimal:'MINIMAL',
  badge_evening:'SOIRÉE',
  badge_date:'RENDEZ-VOUS',
  badge_brunch:'BRUNCH',
  badge_travel:'VOYAGE',
  badge_beach:'PLAGE',
  badge_structured:'STRUCTURÉ',
  savings_label:'-{amount} € d\'économie',
  items_added_to_favorites:'{count} articles ajoutés aux favoris.',
  loading_caps:'CHARGEMENT…',
  see_more_outfits_caps:'↓ VOIR {count} TENUES DE PLUS',
  outfits_word:'tenues',
  daily_selection_caps:'SÉLECTION DU JOUR',
  daily_display:'Affiche du jour',
  for_occasion:'pour {occasion}',
  style_label:'style {styles}',
  styles_word:'styles',
  cashback:'Crédit Mytenue',
  quick_daily_prefs_sub:'Style, occasion, budget',
  quick_wardrobe_sub:'Gérer mes articles',
  quick_looks_sub:'Tenues du jour',
  quick_catalog_sub:'Découvrir',
  quick_travel_sub:'Planifier',
  quick_favorites_sub:'Articles sauvés',
  color_label:'Couleur :',
  view_on:'Voir sur {partner}',
  partner:'Partenaire',
  my_look:'Mon look',
  login_required:'Connexion requise',
  login_required_for_tryon:'Connectez-vous pour utiliser l\'essai virtuel.',
  login_required_for_flatlay:'Connectez-vous pour générer un Flat-Lay de votre tenue.',
  sign_in:'Se connecter',
  regenerate:'Régénérer',
  // ═══ CatalogScreen (MyTenue) — i18n complet ═══
  filters_caps:'FILTRES', boutique_badge:'🛍️ BOUTIQUE',
  all_partners:'Tous les partenaires', articles_count:'articles',
  no_results_found:'Aucun article', no_awin_results:'Aucun résultat AWIN pour cette recherche',
  try_other_filters:'Essayez d\'autres filtres',
  price:'Prix', brand:'Marque', color:'Couleur',
  sort_relevance:'Pertinence', sort_price_asc:'Prix ↑', sort_price_desc:'Prix ↓',
  sort_discount:'% Promo', sort_rating:'★ Note',
  only_favorites:'❤️ Mes favoris uniquement', reset_filters:'Réinitialiser les filtres',
  cat_all:'Tout', brand_all:'Toutes', color_all:'Toutes',
  gender_all:'Tous', gender_woman:'Femme', gender_man:'Homme',
  search_catalog_placeholder:'Rechercher (robe noire, manteau...)',
  trending_this_week:'Tendances cette semaine',
  ac_brand:'marque', ac_color:'couleur', ac_category:'catégorie',
  bought_prefix:'🛍  J\'ai acheté :',
  // Sub-categories (chips dynamiques)
  sub_all:'Tout',
  sub_shirts:'Chemises', sub_tshirts:'T-shirts', sub_pulls:'Pulls', sub_sweatshirts:'Sweatshirts',
  sub_hoodies:'Hoodies', sub_crop_tops:'Crop tops', sub_polos:'Polos',
  sub_pants:'Pantalons', sub_tracksuits:'Survêtements', sub_joggings:'Joggings',
  sub_jeans:'Jeans', sub_skirts:'Jupes', sub_shorts:'Shorts',
  sub_bermudas:'Bermudas', sub_leggings:'Leggings',
  sub_blazers:'Blazers', sub_suits:'Costumes', sub_bombers:'Bombers',
  sub_puffers:'Doudounes', sub_trenches:'Trenchs', sub_windbreaker:'Coupe-vent',
  sub_raincoat:'Imperméables', sub_ski_jacket:'Vestes ski', sub_leather:'Cuir',
  sub_cardigans:'Cardigans', sub_peacoats:'Cabans', sub_parkas:'Parkas',
  sub_overcoats:'Pardessus', sub_duffle:'Duffle coats',
  sub_sneakers:'Sneakers', sub_heels:'Talons', sub_ankle_boots:'Bottines',
  sub_boots:'Boots', sub_sandals:'Sandales', sub_loafers:'Mocassins', sub_flats:'Ballerines',
  sub_chelsea:'Chelsea boots', sub_derbies:'Derbies',
  sub_short_dress:'Courtes', sub_midi_dress:'Mi-longues', sub_long_dress:'Longues',
  sub_shirt_dress:'Robe chemise', sub_sleeveless:'Sans manches', sub_aline:'Trapèze',
  sub_handbag:'À main', sub_crossbody:'Bandoulière', sub_backpack:'À dos',
  sub_tote:'Cabas', sub_clutch:'Pochettes', sub_belt_bag:'Banane',
  sub_rings:'Bagues', sub_necklaces:'Colliers', sub_earrings:'Boucles d\'oreilles',
  sub_bracelets:'Bracelets', sub_pendants:'Pendentifs',
  sub_watches:'Montres', sub_belts:'Ceintures', sub_caps:'Casquettes',
  sub_hats:'Chapeaux', sub_scarves:'Foulards', sub_glasses:'Lunettes',
  // ═══ ProfileScreen — i18n complet (rappels, cashback, abonnement, mannequin, à propos) ═══
  daily_reminder_outfit:'Rappel quotidien Tenue du jour ({time})',
  available_for_withdrawal:'Disponible au retrait',
  pending_caps:'EN ATTENTE',
  validated_caps:'VALIDÉ',
  withdrawn_caps:'RETIRÉ',
  paid_caps:'PAYÉ',
  cancelled_caps:'ANNULÉ',
  min_to_withdraw:'Minimum {amount}€ pour retirer',
  recent_orders:'DERNIÈRES COMMANDES ({count})',
  validated:'Validé',
  pending:'En attente',
  paid:'Payé',
  cancelled:'Annulé',
  clicks:'Clics',
  clicks_caps:'CLICS',
  purchases_caps:'ACHATS',
  partner_products:'produits partenaires',
  confirmed_orders:'commandes confirmées',
  accumulated_cashback:'CRÉDIT ACCUMULÉ',
  withdraw_via_paypal:'💳 RETIRER VIA PAYPAL',
  withdrawal_of:'Retrait de {amount} € via PayPal',
  paypal_email_prompt:'Saisissez votre email PayPal pour recevoir le paiement (3-5 jours ouvrés) :',
  paypal_email_label:'Email PayPal',
  confirm_withdrawal:'CONFIRMER LE RETRAIT',
  cashback_rate_info:'💡 Votre taux de crédit Mytenue actuel est de {rate} (tier {tier}). Passez en Gold pour obtenir {goldRate} de crédit Mytenue.',
  sign_in_to_view_earnings:'Connectez-vous pour voir vos gains',
  cashback_label:'Crédit Mytenue',
  paypal_email_required:'Email PayPal requis',
  paypal_email_required_msg:'Entrez un email PayPal valide pour recevoir vos gains.',
  amount_insufficient:'Montant insuffisant',
  amount_insufficient_msg:'Vous devez avoir au moins {min}€ disponibles pour retirer. Actuellement : {available}€.',
  request_sent:'✓ Demande envoyée',
  withdrawal_request_sent:'Votre demande de retrait de {amount}€ a été enregistrée. Vous recevrez le paiement sous 3-5 jours ouvrés.',
  request_failed:'Demande impossible pour le moment.',
  monthly_price:'Mensuel — {price}€/mois',
  yearly_price:'Annuel — {price}€/mois',
  yearly:'Annuel',
  monthly:'Mensuel',
  renewal_on:'🔄 Renouvellement le {date}',
  renewal_on_with_time:'🔄 Renouvellement le {date} à {time} (dans {days} j)',
  renewal_in_min:'🔄 Renouvellement dans {min} min',
  renewal_in_hours:'🔄 Renouvellement dans {hours} (à {time})',
  renewal_tomorrow:'🔄 Renouvellement demain à {time}',
  expired_on:'⚠️ Expiré le {date} — passez en formule active',
  cancelled_expires_on:'⚠️ Annulé · Expire le {date}',
  expired_caps:'⚠️  EXPIRÉ',
  usage_today:'Utilisation aujourd\'hui',
  feature_unlimited_wardrobe:'Dressing illimité',
  feature_wardrobe_items:'Dressing : {count} articles',
  feature_unlimited_ai:'Analyses IA illimitées',
  feature_ai_per_day:'{count} analyses IA / jour',
  feature_unlimited_looks:'Looks illimités',
  feature_looks_per_day:'{count} looks / jour',
  feature_unlimited_tryons:'Essais illimités',
  feature_tryon_per_week:'{count} essai / semaine',
  feature_tryons_per_month:'{count} essais / mois',
  feature_unlimited_travel:'Voyages illimités',
  feature_travel_count:'{count} voyages',
  feature_cashback_percent:'{percent}% crédit Mytenue sur vos achats',
  feature_vip_support:'Support VIP & early access',
  usage_label_wardrobe:'Dressing',
  usage_label_ai:'Analyses IA',
  usage_label_looks:'Looks générés',
  usage_label_tryons:'Try-ons',
  usage_unit_pieces:'pièces',
  usage_unit_per_day:'/ j',
  usage_unit_looks:'looks',
  usage_unit_per_month:'/ mois',
  usage_unit_per_week:'/ sem.',
  switch_to_yearly:'Passer à l\'annuel',
  switch_to_yearly_sub:'{yearly}€/an facturé · soit {price}€/mois',
  switch_to_monthly:'Passer au mensuel',
  switch_to_monthly_sub:'{price}€/mois · sans engagement annuel',
  change_plan:'＋ Changer de formule',
  change_plan_sub:'Voir Basic, Premium et Gold',
  resubscribe:'🔄 Se réabonner',
  resubscribe_sub:'Réactiver Basic, Premium ou Gold',
  cancel_subscription:'Se désabonner',
  manage_subscription:'Gérer mon abonnement',
  subscription_cancelled_access_until:'Abonnement annulé — accès jusqu\'à expiration',
  no_engagement:'Sans engagement · Annulable à tout moment',
  free_plan_no_payment:'Plan gratuit',
  no_payment_required:'Aucun paiement requis pour le plan gratuit.',
  payment_unavailable:'Paiement indisponible',
  payment_success_title:'Paiement réussi',
  payment_success_body:'Votre abonnement est actif. Bienvenue !',
  payment_cancelled_title:'Paiement annulé',
  payment_cancelled_body:'Aucun montant n\'a été débité. Vous pouvez réessayer quand vous voulez.',
  current_plan_label:'Plan actuel',
  already_on_plan:'Vous êtes déjà sur ce plan.',
  change_formula_q:'Changer de formule ?',
  change_formula_msg:'Vous êtes actuellement sur {oldPlan}.\n\nEn passant à {newPlan}, votre abonnement actuel sera automatiquement remplacé. {prorataMsg}\n\nVous ne paierez jamais 2 abonnements en même temps.',
  prorata_apple:'Apple appliquera un prorata sur la différence.',
  prorata_google:'Google Play appliquera un prorata sur la différence.',
  continue:'Continuer',
  purchase_unavailable:'Achats indisponibles',
  purchase_unavailable_msg:'Les achats in-app ne sont pas encore configurés sur cette plateforme. Veuillez réessayer plus tard.',
  purchase_failed:'Achat impossible',
  purchase_failed_msg:'Le paiement n\'a pas pu aboutir. Réessayez plus tard ou contactez le support.',
  unsubscribe_title:'Se désabonner',
  unsubscribe_msg:'Votre abonnement Premium restera actif jusqu\'au {date}.\n\nAprès cette date, votre compte basculera automatiquement sur la formule gratuite.\n\nVous pouvez réactiver votre abonnement à tout moment avant l\'expiration.',
  end_of_period:'la fin de la période en cours',
  subscription_cancelled_title:'Abonnement annulé',
  subscription_cancelled_msg:'Votre accès Premium reste actif jusqu\'au {date}.\n\nAucun prélèvement supplémentaire ne sera effectué.',
  cancel_failed_endpoint:'Service de désabonnement temporairement indisponible. Une mise à jour est en cours côté serveur. Réessayez dans quelques minutes ou contactez le support.',
  cancel_failed_unauthorized:'Votre session a expiré. Reconnectez-vous puis réessayez.',
  cancel_failed_network:'Pas de connexion internet. Vérifiez votre réseau et réessayez.',
  cancel_failed_server:'Erreur côté serveur. Réessayez dans un instant.\n\n({err})',
  cancel_failed_default:'Impossible de désactiver l\'abonnement.\n\n{err}',
  cancel_failed_default_no_err:'Réessayez dans un instant ou contactez le support.',
  unexpected_error:'Erreur inattendue',
  next_renewal_on:'\n\nProchain renouvellement : {date}',
  plan_modified:'Plan modifié',
  plan_change_yearly:'Passage annuel — {price}€/mois',
  plan_change_monthly:'Passage mensuel — {price}€/mois',
  cannot_modify_plan:'Impossible de modifier le plan.',
  current_plan_btn:'Plan courant',
  switch_to_yearly_btn:'Passer en annuel',
  switch_to_monthly_btn:'Passer en mensuel',
  choose:'Choisir',
  active_caps:'✓ ACTIF',
  popular:'Populaire',
  per_month:'€/mois',
  per_year:'soit {amount}€/an',
  test_mode_back_to_free:'[MODE TEST] Repasser en Free ?',
  test_mode_back_to_free_msg:'Cette action est uniquement pour tester. Vous redeviendrez free instantanément.',
  test_back_to_free:'[Test] Repasser en Free',
  expired_subscription_title:'Abonnement expiré',
  expired_subscription_with_label:'Votre abonnement {plan}{dateMsg}.',
  expired_subscription_no_label:'Votre abonnement{dateMsg}.',
  ended_on:' a pris fin le {date}',
  has_expired:' a expiré',
  expired_subscription_desc:'Vous êtes actuellement sur le plan gratuit. Choisissez une formule ci-dessous pour réactiver les fonctionnalités premium.',
  renew_subscription:'Renouveler mon abonnement',
  limit_reached:'Limite atteinte. {when} ou passe à un plan supérieur.',
  reset_tomorrow:'Reset demain à 00:00',
  tryon_subscribers_only:'L\'essayage virtuel sur mannequin est réservé aux abonnés (Basic, Premium ou Gold). Choisissez une formule pour l\'utiliser.',
  premium_caps:'✨ PREMIUM',
  subscribers_caps:'✨ ABONNÉS',
  my_mannequin_caps:'MON MANNEQUIN',
  your_personal_photo:'Votre photo perso',
  mannequin_usage_explanation:'Utilisée pour générer des essayages qui vous ressemblent.',
  delete_personal_photo:'Supprimer ma photo perso',
  delete_photo_q:'Supprimer ma photo ?',
  delete_photo_msg:'Votre photo ne sera plus utilisée pour les essayages virtuels et sera effacée de nos serveurs.\n\n⚠️ Limitation : 1 photo perso / 7 jours. Si vous avez uploadé votre photo récemment, vous devrez attendre la fin de la fenêtre de 7 j pour en créer une nouvelle.',
  photo_deleted:'Photo supprimée',
  item_removed_success:'Article supprimé du dressing',
  photo_deleted_msg:'Votre photo perso a bien été effacée.',
  delete_failed:'Échec : {err}',
  about_caps:'À PROPOS',
  export_my_data:'Exporter mes données (RGPD)',
  cookie_preferences:'Préférences cookies',
  cookies:'Cookies',
  cookies_banner_next_load:'Le bandeau cookies sera proposé au prochain chargement.',
  export_loading_title:'Export en cours…',
  export_loading_msg:'Téléchargement de vos données personnelles.',
  export_ready:'Export prêt',
  export_ready_msg:'Téléchargé : {wardrobe} articles, {looks} looks, {tryons} essayages.',
  export_failed:'Échec de l\'export : {err}',
  export_session_required:'Connexion requise',
  export_session_required_msg:'Reconnectez-vous pour exporter vos données.',
  export_share_title:'Export MyTenue',
  developed_with:'Développé avec ❤️',
  member_since_count:'Membre depuis {date}',
  member_since_with_logins:'Membre depuis {date} · {count} connexions',
  complete_profile_caps:'⚠️ COMPLÉTER LE PROFIL',
  apple_badge:' APPLE',
  google_badge:'G GOOGLE',
  badge_man:'♂ HOMME',
  badge_woman:'♀ FEMME',
  badge_all_genders:'◎ TOUS',
  diversity:'Diversité',
  ai_analyzed_count:'🤖 Analysé par IA · {analyzed}/{total} articles',
  edit_profile_sub:'Identité, morphologie, tailles…',
  preferences_sub:'Style, occasion, budget',
  admin_dashboard:'Dashboard Admin',
  admin_dashboard_sub:'Stats, retraits & utilisateurs',
  language_label:'Langue',
  saving_request:'Demande envoyée',
  permission_required_reminders:'Activez les notifications dans les réglages système pour recevoir les rappels quotidiens.',
  delete_action:'Supprimer',
  // v1.12.273 — Profile / month abbreviations FR
  month_jan_short:'janv.',
  month_feb_short:'févr.',
  month_mar_short:'mars',
  month_apr_short:'avr.',
  month_may_short:'mai',
  month_jun_short:'juin',
  month_jul_short:'juil.',
  month_aug_short:'août',
  month_sep_short:'sept.',
  month_oct_short:'oct.',
  month_nov_short:'nov.',
  month_dec_short:'déc.',
  // ═══ WardrobeScreen + FavoritesScreen + WardrobePhotoGuideModal — i18n ═══
  my_pieces:'Mes pièces', my_creations_caps:'✨ MES CRÉATIONS', my_looks:'Mes looks',
  create_new_look:'CRÉER UN NOUVEAU LOOK', create_btn:'Créer', create_a_look:'Créer un look',
  cat_watches:'Montres',
  wardrobe_fully_analyzed:'Dressing entièrement analysé · {count} articles',
  ai_analysis_in_progress:'Analyse IA en cours',
  items_pending_analysis_one:'1 article en attente d\'analyse',
  items_pending_analysis_other:'{count} articles en attente d\'analyse',
  analyzed_label:'analysés', remaining_label:'restants',
  search_placeholder_short:'Rechercher...',
  add_an_item:'Ajouter une pièce',
  take_photo:'Prendre une photo', take_photo_desc:'Photographier votre article',
  from_gallery:'Depuis la galerie', from_gallery_desc:'Choisir une photo existante',
  from_url_choice:'Depuis une URL', from_url_desc:'Lien Instagram, Facebook ou article',
  ai_will_detect:'🤖 L\'IA va détecter le nom et les caractéristiques de l\'article.',
  category_label:'Catégorie',
  pseudo_optional:'Pseudo (optionnel)',
  pseudo_placeholder_short:'Ex: Mon préféré, Pull cosy hiver...',
  pseudo_helper:'Un surnom personnel pour le retrouver facilement (recherche par nom IA + pseudo).',
  add_to_my_wardrobe:'Ajouter à ma garde-robe',
  empty_wardrobe_title:'Dressing vide',
  add_items_before_creating_look:'Ajouter des articles à votre dressing avant de créer un look.',
  no_look_created_title:'Aucun look créé',
  create_first_look_desc:'Créez votre premier look en sélectionnant des articles de votre dressing et laissez l\'IA suggérer des pièces complémentaires à shopper.',
  create_your_own_looks_desc:'Créez vos propres looks avec vos articles + suggestions shopping',
  personalized_look_one:'{count} look personnalisé',
  personalized_look_other:'{count} looks personnalisés',
  complete_or_replace_n:'🛍️ Compléter ou remplacer ({count})',
  collapse_arrow:'↑ Réduire',
  view_more_n:'+ Voir {count}',
  more_items_short:'Plus\nd\'articles',
  generate_more_items:'Générer plus\nd\'articles',
  no_valid_suggestion_yet:'Aucune suggestion valide pour le moment',
  generate_suggestions_btn:'Générer des suggestions',
  delete_this_look_q:'Supprimer ce look ?',
  irreversible_action:'Cette action est irréversible.',
  delete_this_look_btn:'🗑  Supprimer ce look',
  better_replacement_badge:'↺ MIEUX',
  replaces_lc:'Remplace {category}', replaces_your_lc:'Remplace votre {category}',
  used_in_n_looks:'Utilisé dans {count} look(s)',
  ai_analysis_running_label:'Analyse IA en cours...\nLes détails apparaîtront ici une fois l\'analyse terminée.',
  remove_from_wardrobe_q:'Retirer "{name}" de votre garde-robe ?\nCette action est irréversible.',
  cannot_delete_msg:'Impossible de supprimer : {error}',
  look_created_check:'✨ Look créé !',
  look_saved_msg:'Votre look "{name}" a été enregistré avec {itemsCount} article(s) et {suggestionsCount} suggestion(s).',
  catalog_unavailable_title:'Catalogue indisponible',
  catalog_unavailable_msg:'Impossible de charger le catalogue. Vérifiez votre connexion et réessayez.',
  ai_analysis_failed_msg:'L\'analyse IA n\'a pas pu aboutir (réseau lent ou serveur surchargé). Réessayez dans quelques instants.',
  not_clothing_msg:'L\'IA n\'a pas détecté de vêtement sur cette photo. Veuillez choisir une photo d\'un vêtement, chaussure, sac ou accessoire mode.',
  name_mismatch_title:'Le nom ne correspond pas',
  name_mismatch_msg:'Vous avez saisi "{userName}" mais l\'IA a détecté {detectedType} sur la photo.\n\nQue souhaitez-vous faire ?',
  use_suggestion_btn:'Utiliser "{name}"', keep_user_name_btn:'Garder "{name}"',
  detected_type_other:'autre chose',
  category_confirm_title:'Catégorie à confirmer',
  category_confirm_msg:'Vous avez choisi la catégorie "{userCategory}" mais l\'IA a détecté un article de catégorie "{detectedCategory}" sur la photo.\n\nQue souhaitez-vous faire ?',
  use_category_btn:'Utiliser "{name}"', keep_category_btn:'Garder "{name}"',
  cant_save_image_msg:'Impossible d\'enregistrer la photo. {error}',
  image_save_failed_msg:'La photo n\'a pas pu être enregistrée. Réessayez avec une autre photo.',
  cant_add_item_msg:'L\'article n\'a pas pu être ajouté.',
  permission_camera_msg:'Autorisez l\'accès à la caméra',
  permission_gallery_msg:'Autorisez l\'accès à la galerie',
  photo_required_title:'Photo requise',
  photo_required_msg:'Prends une photo, choisis-en une dans la galerie ou utilise une URL.',
  item_analyzed_title:'✨ Article analysé',
  item_analyzed_msg:'{name}\n→ {detected}\n\nL\'IA a détecté ses caractéristiques pour améliorer vos suggestions de looks.',
  perfect_btn:'Parfait !', undefined_color:'couleur indéterminée',
  tooltip_create_look_btn:'Créer un nouveau look à partir de vos pièces',
  tooltip_add_item_btn:'Ajouter un article à votre dressing — photo ou import depuis une URL',
  tooltip_add_to_calendar:'Ajouter ce look à mon calendrier',
  tooltip_refresh_suggs:'Régénérer les suggestions shopping pour ce look',
  tooltip_create_complete_look:'Créer un look complet — sélectionnez vos pièces et l\'IA suggère des compléments shopping',
  // ═══ FavoritesScreen ═══
  favorites_caps:'✨ FAVORIS',
  my_favorites_subtitle:'Mes coups de cœur',
  articles_label:'Articles', brands_label:'Marques', value_label:'Valeur',
  no_favorites_title:'Aucun favori',
  no_favorites_desc:'Ajoutez des articles à vos favoris en tapant sur le cœur de chaque produit.',
  explore_catalog_btn:'Explorer le catalogue',
  remove_from_favorites_q:'Retirer des favoris ?',
  remove_btn:'Retirer',
  // ═══ WardrobePhotoGuideModal ═══
  optimal_photos_title:'📸 Photos optimales',
  photo_guide_intro:'Pour que notre IA reconnaisse correctement vos articles (catégorie, couleur, matière, style), prenez des photos claires et nettes.',
  important_label:'⚠️ Important',
  photo_guide_warning_part1:'Si la photo est floue, mal cadrée ou non conforme, l\'IA peut ',
  photo_guide_warning_emphasis1:'rejeter l\'analyse',
  photo_guide_warning_part2:'. Vous perdrez alors ',
  photo_guide_warning_emphasis2:'1 utilisation de votre compteur d\'analyses IA quotidien',
  photo_guide_warning_part3:' sans avoir d\'article ajouté à votre dressing.',
  to_do_label:'✓ À FAIRE', to_avoid_label:'✗ À ÉVITER',
  photo_rule_ok_1:'Fond uni clair (mur blanc, drap, papier)',
  photo_rule_ok_2:'Lumière naturelle ou plafonnier blanc',
  photo_rule_ok_3:'Un seul article dans le cadre',
  photo_rule_ok_4:'Photo prise droit (pas en biais)',
  photo_rule_ok_5:'Article entier visible (pas coupé)',
  photo_rule_ok_6:'Article porté possible : il doit rester le sujet principal, entièrement visible et non masqué par d\'autres vêtements ou accessoires (visage hors cadre conseillé)',
  photo_rule_bad_1:'Plusieurs articles superposés sur la photo',
  photo_rule_bad_2:'Article masqué par une veste, un sac ou un autre vêtement',
  photo_rule_bad_3:'Cintres apparents, étiquettes ou packaging visibles',
  photo_rule_bad_4:'Fond très chargé ou avec motifs',
  photo_rule_bad_5:'Photo très sombre, floue ou de mauvaise qualité',
  category_examples_caps:'EXEMPLES PAR CATÉGORIE',
  why_important_title:'🤖 Pourquoi c\'est important',
  why_important_text:'Une bonne photo permet à IA de détecter automatiquement la catégorie, la couleur dominante, la matière et le style — vous évitant de tout saisir manuellement et améliorant la qualité des suggestions de tenues.',
  dont_show_again:'Ne plus afficher ce guide',
  understood_add_item_cta:'J\'AI COMPRIS, AJOUTER UN ARTICLE',
  cat_tip_tops_f:'Chemise/blouse sur ghost mannequin (sans visage). Manches dépliées, col visible.',
  cat_tip_tops_m:'Chemise sur ghost mannequin (sans visage). Manches dépliées, col visible.',
  cat_tip_bottoms:'UN seul pantalon/jean posé à plat sur fond blanc. Jambes alignées.',
  cat_tip_dresses:'Robe sur ghost mannequin sans visage. Toute la longueur visible.',
  cat_tip_jackets:'Veste/blazer COURT (< hanche) sur ghost mannequin sans visage.',
  cat_tip_coats_f:'Manteau LONG (≥ mi-cuisse) — trench, caban, parka — sur ghost mannequin.',
  cat_tip_coats_m:'Manteau LONG (≥ mi-cuisse) sur ghost mannequin sans visage.',
  cat_tip_shoes:'Une seule chaussure de profil sur fond blanc.',
  cat_tip_bags:'Sac seul, posé droit. Anses ou bandoulière visibles.',
  cat_tip_jewelry:'Plan rapproché sur fond blanc. Détails et finition visibles.',
  cat_tip_accessories_f:'Écharpe / chapeau / ceinture seule, étalée sur fond blanc.',
  cat_tip_accessories_m:'Cravate / écharpe / ceinture seule, étalée sur fond blanc.',

  // Profile — Cashback section
  cashback_accumulated:'CRÉDIT ACCUMULÉ',
  available_for_withdrawal:'Disponible au retrait',
  pending_caps:'⏳ EN ATTENTE',
  validated_caps:'✓ VALIDÉ',
  withdrawn_caps:'💸 RETIRÉ',
  min_to_withdraw:'Minimum {amount}€ pour retirer',
  recent_orders_caps:'DERNIÈRES COMMANDES',
  validated:'✓ Validé',
  pending:'⏳ En attente',
  clicks_caps:'CLICS',
  purchases_caps:'ACHATS',
  partner_products:'produits partenaires',
  confirmed_orders:'commandes confirmées',
  login_to_see_earnings:'Connectez-vous pour voir vos gains',

  // Profile — Subscription section
  monthly_price:'Mensuel — {price}€/mois',
  yearly_price:'Annuel — {price}€/mois',
  renewal_on:'🔄 Renouvellement le {date}',
  usage_today:'Utilisation aujourd\'hui',
  feat_unlimited_wardrobe:'Dressing illimité',
  feat_unlimited_ai:'Analyses IA illimitées',
  feat_unlimited_looks:'Looks illimités',
  feat_unlimited_tryons:'Essais illimités',
  feat_tryons_per_month:'{count} essais / mois',
  feat_tryons_per_week:'{count} essai / semaine',
  feat_unlimited_travel:'Voyages illimités',
  feat_trips_count:'{count} voyages',
  feat_cashback_percent:'{percent}% crédit Mytenue sur vos achats',
  feat_vip_support:'Support VIP & early access',
  feat_wardrobe_count:'Dressing : {count} articles',
  feat_ai_per_day:'{count} analyses IA / jour',
  feat_looks_per_day:'{count} looks / jour',
  usage_wardrobe:'Dressing',
  usage_ai:'Analyses IA',
  usage_looks_gen:'Looks générés',
  usage_tryons:'Try-ons + Flat-lay',
  usage_unit_pieces:'pièces',
  usage_unit_per_day:'/ j',
  usage_unit_looks:'looks',
  usage_unit_per_month:'/ mois',
  usage_unit_per_week:'/ sem.',

  // Profile — Mannequin section
  my_mannequin_caps:'MON MANNEQUIN',
  your_personal_photo:'Votre photo perso',
  mannequin_explanation:'Utilisée pour générer des essayages qui vous ressemblent.',
  delete_personal_photo:'Supprimer ma photo perso',

  // Profile — About section
  about_caps:'À PROPOS',
  export_my_data:'Exporter mes données (RGPD)',
  cookie_preferences:'Préférences cookies',
  developed_with:'Développé avec ❤️',

  // Profile — Daily reminder
  daily_reminder_at:'📅  Rappel quotidien Tenue du jour ({time})',

  // v1.12.274 — Phase B i18n : LooksScreen MyTenue
  stylist_selection_caps:'SÉLECTION STYLISTE IA',
  your_looks:'Vos looks',
  ai_looks_from_wardrobe:'Looks générés par IA depuis votre dressing',
  style_elegant:'Élégant',
  style_casual:'Casual',
  style_minimal:'Minimaliste',
  style_boho:'Bohème',
  style_evening:'Soirée',
  style_sport:'Sport',
  style_office:'Bureau',
  style_chic:'Chic',
  view_n_accessories:'Voir {count} accessoires & bijoux',
  hide_accessories_jewels:'Masquer accessoires & bijoux',
  score_exceptional:'Exceptionnel',
  score_excellent:'Excellent',
  score_good:'Bien',
  score_decent:'Correct',
  score_to_improve:'À améliorer',
  outfit_n_pieces:'Tenue {count} pièces',
  ai_analyzed_status:'IA · {done}/{total} analysé',

  // v1.12.275 — Phase B i18n : ProfileScreen MyTenue (subscription / gender / renewal)
  status_paid:'💸 Payé',
  status_cancelled:'✕ Annulé',
  portal_unavailable:'Portail indisponible',
  stripe_error:'Erreur Stripe',
  reconnect_to_export:'Reconnectez-vous pour exporter vos données.',
  export_in_progress:'Export en cours…',
  downloading_personal_data:'Téléchargement de vos données personnelles.',
  export_downloaded_summary:'Téléchargé : {items} articles, {looks} looks, {tryons} essayages.',

  // v1.12.276 — Phase B i18n : CalendarScreen MyTenue
  filter_looks_by_items_tooltip:'Filtrer les looks par articles spécifiques de votre dressing',
  my_calendar_title:'📅 Mon calendrier',
  my_calendar_short:'Mon calendrier',
  login_required:'Connexion requise',
  calendar_login_desc:'Pour suivre vos tenues au quotidien et garder un historique de vos looks, connectez-vous à votre compte MyTenue.',
  sign_in_caps:'SE CONNECTER',
  month_progress_one:'{percent}% du mois ({count} tenue)',
  month_progress_other:'{percent}% du mois ({count} tenues)',
  tier_history_limit:'Plan {tier} : historique limité à {days} jours',
  calendar_help_tap_day:'✨ Cliquez sur un jour pour voir la tenue ou en ajouter une.',
  // Weekday letters (Mon → Sun)
  wd_mon:'L', wd_tue:'M', wd_wed:'M', wd_thu:'J', wd_fri:'V', wd_sat:'S', wd_sun:'D',
  // First-time onboarding banner
  first_time_here:'💡 Première fois ici ?',
  calendar_onboarding_desc:'Ajoutez les looks que vous aimez à votre calendrier de tenues pour suivre ce que vous portez chaque jour et recevoir des stats personnalisées.',
  calendar_benefit_avoid_repetitions:'✓ Évite les répétitions involontaires',
  calendar_benefit_personal_stats:'✓ Stats personnalisées sur vos préférences',
  calendar_benefit_history_inspiration:'✓ Inspiration depuis votre historique',
  calendar_benefit_weather_sync:'✓ Synchronisé avec la météo',
  understood_cta:'Compris !',
  // Stats panel
  stats_for_month:'Stats {month}',
  stats_for_month_default:'Stats du mois',
  days_tracked_total:'{tracked}/{total} jours · {percent}%',
  days_tracked_label:'Jours suivis',
  average_rating:'Note moyenne',
  top_occasion_label:'Top occasion',
  favorite_occasions:'Occasions favorites',
  most_worn_pieces:'Pièces les plus portées',
  days_tracked_this_month:'📊 {count} jours suivis ce mois',
  outfit_percentage_for_occasion:'✨ {percent}% de vos tenues sont pour {occasion}',
  // Teaser free tier
  stats_of_month:'Stats du mois',
  stats_teaser_upgrade:'Passez à Basic pour voir vos stats : jours suivis, occasions favorites, pièces les plus portées.',

  // v1.12.277 — Phase B i18n : CompleteProfileScreen MyTenue
  edit_profile_title:'Modifier mon profil',
  personalization_caps:'✨ PERSONNALISATION',
  your_information:'Vos informations',
  info_helps_personalization:'Ces informations nous permettent de personnaliser vos suggestions et de vous proposer le bon catalogue.',
  first_name:'Prénom',
  last_name:'Nom',
  gender:'Genre',
  date_of_birth:'Date de naissance',
  age_adapts_styles:'Nous adaptons les coupes, styles et tendances à votre tranche d\'âge.',
  morphology:'Morphologie',
  morphology_explanation:'Pour adapter les coupes et tailles à votre morphologie.',
  height_cm:'Taille (cm)',
  weight_kg:'Poids (kg)',
  silhouette:'Silhouette',
  // Silhouettes — femmes
  silhouette_hourglass:'Sablier',
  silhouette_inverted_triangle:'Triangle inversé',
  silhouette_triangle:'Triangle',
  silhouette_rectangle:'Rectangle',
  silhouette_round:'Arrondi',
  silhouette_apple:'Pomme',
  silhouette_pear:'Poire',
  // Silhouettes — hommes
  silhouette_v:'V (athlétique)',
  silhouette_rectangle_m:'Rectangle',
  silhouette_inverted_triangle_m:'Triangle inversé',
  silhouette_trapezoidal:'Trapézoïdal',
  silhouette_oval:'Ovale',
  // Silhouette hints (descriptions sous chaque silhouette)
  sil_hint_hourglass:'Épaules ≈ hanches, taille marquée',
  sil_hint_pear:'Hanches plus larges que les épaules',
  sil_hint_rectangle:'Peu de courbes, taille peu marquée',
  sil_hint_apple:'Buste/ventre généreux, jambes fines',
  sil_hint_inverted_triangle:'Épaules plus larges que les hanches',
  sil_hint_slim_m:'Carrure fine, peu de muscles apparents',
  sil_hint_athletic_m:'Carrure marquée, musculature visible',
  sil_hint_average_m:'Carrure moyenne, proportions classiques',
  sil_hint_broad_m:'Carrure large, ossature forte',
  sil_hint_full_m:'Buste imposant, ventre marqué',
  // Sizes
  clothing_sizes:'Tailles vestimentaires',
  sizes_prefilled_from_morphology:'Pré-remplies depuis votre morphologie. Ajustez si besoin.',
  tops_label_with_examples:'Hauts (t-shirt, chemise, pull...)',
  bottoms_label_with_examples_eu:'Bas (pantalon, jean...) • Taille UE',
  jacket_coat_label:'Veste / manteau',
  shoes_eu_label:'Chaussures (UE)',
  no_changes:'Aucune modification',
  fix_errors:'Corriger les erreurs',

  // v1.12.278 — Phase B i18n : OnboardingScreen MyTenue
  skip:'Passer',
  step_x_of_y:'Étape {current} sur {total}',
  onboarding_welcome:'Bienvenue !',
  onboarding_intro_desc:'Faisons connaissance pour vous proposer le meilleur du style.',
  onboarding_recap_title:'✓ Vos infos d’identité',
  onboarding_recap_hint:'Tout est bon ! Cliquez sur Suivant pour continuer.',
  gender_other:'Autre',
  first_name_placeholder:'Votre prénom',
  last_name_placeholder:'Votre nom',
  email_label:'Email',
  apple_relay_email_hint:'Apple a masqué votre email. Indiquez celui que vous voulez utiliser. Un code de vérification sera envoyé à cette adresse.',
  email_placeholder:'vous@exemple.com',
  email_verified:'✓ Email vérifié',
  send_verification_code:'Envoyer le code de vérification',
  sending_code:'Envoi du code…',
  six_digit_code_received:'Code à 6 chiffres reçu par email :',
  verify:'Vérifier',
  resend:'Renvoyer',
  invalid_email_format:'Format email invalide',
  too_many_requests_retry_in:'Trop de demandes. Réessayez dans {seconds}s.',
  apple_relay_blocked:'Cet email Apple est masqué. Utilisez un email réel.',
  error_status:'Erreur {status}',
  network_error_short:'Erreur réseau',
  code_must_be_6_digits:'Le code doit contenir 6 chiffres',
  incorrect_code_attempts_left:'Code incorrect. {count} essai(s) restant(s).',
  code_expired_request_new:'Code expiré. Demandez un nouveau code.',
  too_many_attempts_request_new:'Trop d’essais. Demandez un nouveau code.',
  email_changed_resend_code:'Email modifié depuis l’envoi du code. Renvoyez le code.',
  your_date_of_birth:'Votre date de naissance',
  select_birth_date:'Sélectionner votre date de naissance',
  date_format_placeholder:'AAAA-MM-JJ',
  minimum_age_required:'Vous devez avoir au moins 15 ans pour utiliser MyTenue (16 ans dans l’UE hors France).',
  minimum_age_gdpr_hint:'Âge minimum requis : 15 ans (conforme RGPD).',
  validate:'Valider',
  your_morphology:'Votre morphologie',
  your_sizes:'Vos tailles',
  finish:'Terminer',
  skip_onboarding_title:'Passer l’onboarding ?',
  skip_onboarding_msg:'Vous pourrez compléter votre profil plus tard depuis l’écran Profil. Certaines fonctionnalités (suggestions de tailles, looks personnalisés) seront limitées tant que le profil n’est pas complet.',
  continue_form:'Continuer le formulaire',
  skip_for_now:'Passer pour l’instant',
  cannot_save_profile:'Impossible d’enregistrer.',
  unknown_error:'inconnu',

  // v1.12.279 — Phase B i18n : Style chips étendus (LooksScreen)
  style_urban:'Urbain', style_romantic:'Romantique', style_vintage:'Vintage', style_edgy:'Edgy', style_preppy:'Preppy',
  style_feminine:'Féminin', style_structured:'Structuré', style_date:'Rendez-vous', style_brunch:'Brunch',
  style_travel:'Voyage', style_beach:'Plage', style_ceremony:'Cérémonie', style_weekend:'Week-end',
  // v1.12.279 — Phase B i18n : TryOnModal MyTenue
  tryon_choose_pieces:'Choisir les pièces',
  tryon_create_my_mannequin:'Créer mon mannequin',
  tryon_upload_in_progress:'Envoi en cours',
  tryon_choose_mannequin:'Choisir un mannequin',
  tryon_generating_in_progress:'Génération en cours',
  tryon_result:'Résultat',
  tryon_quota_reached:'Quota atteint',
  tryon_attempts_this_month:'{used}/{limit} essais ce mois',
  tryon_max_reached_title:'Maximum atteint',
  tryon_max_reached_msg:'Vous pouvez essayer {max} pièces maximum à la fois. Décochez une pièce d’abord.',
  tryon_no_piece_title:'Aucune pièce',
  tryon_no_piece_msg:'Sélectionnez au moins 1 pièce pour l’essai.',
  tryon_no_piece_selected:'Aucune pièce sélectionnée',
  tryon_generic_error:'Erreur lors de l’essai',
  tryon_check_pieces_intro:'Cochez les pièces que vous souhaitez essayer sur le mannequin',
  tryon_max_suffix:'{max} maximum',
  tryon_no_wearable_in_outfit:'Aucune pièce essayable dans cette tenue.',
  tryon_no_wearable_hint:'L’essai virtuel nécessite des vêtements (robes, hauts, bas, vestes, chaussures).',
  not_tryable_label:'Non essayables :',
  tryon_choose_mannequin_intro:'Choisissez un mannequin pour visualiser cette tenue. La génération prend 15-30 secondes.',
  continue_btn:'Continuer',
  my_mannequin:'Mon mannequin',
  your_silhouette:'votre silhouette',
  personal_mannequin_action_msg:'Que souhaitez-vous faire avec votre photo personnelle ?',
  failed_label:'Échec',
  upload_failed_label:'Échec de l’envoi',
  consent_required_title:'Consentement requis',
  consent_required_msg:'Cochez la case pour autoriser le stockage de votre photo.',
  permission_camera_required:'Autorisez l’accès à la caméra dans les Réglages.',
  permission_gallery_required:'Autorisez l’accès à la galerie dans les Réglages.',
  share_outfit_message:'Découvrez cette tenue sur Outfit !',
  create_personal_mannequin_title:'Créez votre mannequin personnel',
  create_personal_mannequin_desc:'Pour des essayages qui vous ressemblent vraiment (silhouette, taille, visage), prenez une photo de vous en pied — face caméra, fond clair, vêtements ajustés.',
  photo_tips_title:'Conseils pour une bonne photo',
  photo_tip_full_body:'Prenez la photo en pied (de la tête aux pieds)',
  photo_tip_stand_straight:'Tenez-vous droit, bras le long du corps',
  photo_tip_plain_bg:'Privilégiez un fond uni et bien éclairé',
  photo_tip_fitted_clothes:'Vêtements près du corps (évitez les amples)',
  photo_tip_one_person:'Une seule personne sur la photo',
  photo_storage_consent:'J’accepte que ma photo soit envoyée à notre prestataire d’IA Google (Vertex AI), traitée pour générer mes essayages virtuels et stockée de façon chiffrée sur nos serveurs (UE). Je peux la supprimer à tout moment depuis mon profil.',
  take_a_photo:'Prendre une photo',
  choose_from_gallery:'Choisir dans la galerie',
  continue_without_my_photo:'Continuer sans ma photo (mannequin standard)',
  uploading_your_photo:'Envoi de votre photo...',
  secured_and_encrypted:'Sécurisé et chiffré. Quelques secondes…',
  mannequin_default:'Mannequin par défaut',
  mannequin_slim:'Mince',
  mannequin_athletic:'Athlétique',
  mannequin_curvy:'Curvy',
  mannequin_tall:'Tall',
  mannequin_petite:'Petite',
  mannequin_plus_size:'Plus size',
  hair_blonde:'blonde',
  hair_brunette:'brune',
  loading_stage_pending:'Préparation...',
  loading_stage_created:'Démarrage de la génération...',
  loading_stage_processing:'Génération en cours...',
  loading_stage_completed:'Finalisation...',
  tryon_ai_dressing:'Notre IA habille votre mannequin avec {count} pièce(s).',
  tryon_wait_polling:'Patientez 15-60 secondes.',
  generated_by:'Généré par {provider}',
  outfit_items_label:'Articles de cette tenue',
  other_mannequin:'Autre mannequin',
  modify_pieces:'Modifier les pièces',
  your_plan:'votre formule',
  quota_gold_reached:'Quota Gold atteint',
  quota_used_all:'Vous avez utilisé l’intégralité de vos {limit} essais.',
  quota_tier_reached:'Quota {tier} atteint',
  quota_used_this_month_upgrade:'Vous avez utilisé vos {limit} essais de ce mois.\n\nPassez à {nextTier} pour plus d’essais immédiatement.',
  upgrade_to:'Passer à {tier}',
  quota_weekly_reached:'Quota hebdomadaire atteint',
  quota_used_weekly_subscribe:'Vous avez utilisé votre essai de la semaine.\n\nAbonnez-vous pour en débloquer plus.',
  see_subscriptions:'Voir les abonnements',
  tryons_used:'Try-ons utilisés',
  renewal_label:'Renouvellement : {date}',
  item_fallback:'Article',
  start_try_on:'Lancer l’essai',
  generate:'Générer',
  // v1.12.280 — Phase B i18n : DailyPreferencesModal MyTenue
  daily_prefs_today_badge:'✨ AUJOURD\'HUI',
  daily_prefs_hero_title:'Comment vous habiller ?',
  daily_prefs_hero_sub:'Quelques secondes pour personnaliser vos suggestions du jour.',
  daily_prefs_q_style:'Quel style ?',
  daily_prefs_q_occasion:'Pour quelle occasion ?',
  daily_prefs_q_budget:'Budget max par pièce ?',
  daily_prefs_q_categories:'Que recherchez-vous ?',
  daily_prefs_max_2:'(2 choix max)',
  daily_prefs_budget_hint:'Limite appliquée à chaque article individuellement',
  daily_prefs_cta:'VOIR MES RECOMMANDATIONS',
  daily_prefs_footer:'Vos préférences sont mémorisées pour la durée de votre session.',
  daily_prefs_title:'Mes préférences',
  daily_prefs_subtitle:'Personnalisez votre tenue du jour',
  preferred_style:'Style préféré',
  preferred_colors:'Couleurs préférées',
  preferred_brands:'Marques préférées',
  mood:'Humeur',
  climate:'Climat',
  reset:'Réinitialiser',
  apply:'Appliquer',
  budget_under_50:'< 50€',
  budget_under_150:'< 150€',
  budget_under_500:'< 500€',
  budget_over_500:'> 500€',
  budget_no_limit:'Pas de limite',
  budget_per_piece:'la pièce',
  budget_unlimited:'Illimité',
  occ_vacation:'Vacances',
  occ_daily:'Quotidien',
  occ_cocktail:'Cocktail',
  occ_wedding:'Mariage',
  style_streetwear:'Streetwear',
  // v1.12.281 — Phase B i18n : Travel MyTenue
  travel_required_fields_title:'Champs requis',
  travel_required_fields_msg:'Nom du voyage et destination sont obligatoires',
  travel_delete_trip_title:'Supprimer le voyage',
  travel_delete_trip_msg:'Supprimer "{name}" ? Les articles emportés seront retirés de ce voyage. Votre dressing reste intact.',
  travel_premium_badge:'✈️ VOYAGE',
  travel_premium_feature_title:'Fonctionnalité Premium',
  travel_premium_exclusive:'✨ EXCLUSIF PREMIUM',
  travel_premium_hero_title:'Planifiez vos voyages avec l\'IA',
  travel_premium_hero_desc_p1:'Le module Voyage est inclus dans l\'abonnement',
  travel_premium_hero_desc_p2:'Créez vos valises, générez des looks adaptés à la destination et à la météo.',
  travel_premium_feat_1:'Organisation intelligente de valise',
  travel_premium_feat_2:'Looks adaptés à la météo locale',
  travel_premium_feat_3:'Suggestions articles à shopper',
  travel_premium_feat_4:'Variations de looks illimitées',
  travel_premium_cta:'VOIR LES ABONNEMENTS',
  travel_premium_pricing:'À partir de 5,99€/mois · annulation libre',
  // v1.12.268 — Trip styles + weather profiles
  trip_style_beach:'Plage', trip_style_city:'City break', trip_style_mountain:'Montagne', trip_style_business:'Voyage d\'affaires', trip_style_wedding:'Mariage / Gala', trip_style_backpacker:'Backpacker', trip_style_luxury:'Luxe / Resort', trip_style_safari:'Safari / Nature',
  weather_hot_dry:'Chaud et sec', weather_hot_humid:'Chaud et humide', weather_temperate:'Tempéré', weather_cold:'Froid', weather_very_cold:'Très froid', weather_rainy:'Pluvieux', weather_tropical:'Tropical',
  travel_topbar_badge:'✈️ MES VOYAGES',
  travel_wardrobe_title:'Garde-robe voyage',
  travel_hero_title:'Votre styliste de voyage',
  travel_hero_sub:'Créez une valise virtuelle adaptée à votre destination et recevez des looks personnalisés par IA',
  travel_stats_trips:'Voyages',
  travel_stats_items:'Articles',
  travel_stats_ready:'Prêts',
  travel_no_trips_yet:'Aucun voyage pour le moment',
  travel_destinations_count:'{n} destination{s}',
  travel_first_trip_title:'Premier voyage ?',
  travel_first_trip_desc:'Créez votre premier voyage et laissez Claude vous aider à préparer votre valise idéale.',
  travel_first_trip_cta:'＋ Créer un voyage',
  travel_new_trip_card_sub:'Préparez votre prochaine destination',
  travel_pieces_short:'pièces',
  travel_connection_required:'Connexion requise',
  travel_connection_required_msg:'Connectez-vous pour utiliser le try-on virtuel.',
  travel_ai_limit_reached:'Limite IA atteinte ({current}/{limit} aujourd\'hui). Revenez demain ou passe en {nextTier}.',
  travel_ai_no_tips:'Aucune astuce retournée',
  travel_ai_cooldown:'Patiente {min} minute{s} avant de relancer une génération.',
  travel_ai_not_connected:'Non connecté. Reconnectez-vous pour utiliser l\'IA.',
  travel_ai_session_expired:'Session expirée. Reconnectez-vous pour continuer.',
  travel_ai_error:'Impossible de récupérer les conseils IA. Vérifiez votre connexion et réessayez.',
  travel_max_packed_title:'Limite de valise atteinte ({max})',
  travel_max_packed_some:'Vous pouvez encore ajouter {n} article{s}. Passez en Premium pour étendre la limite.',
  travel_max_packed_full:'Votre valise est pleine. Passez en Premium ou Gold pour ajouter plus d\'articles.',
  travel_weather_range:'Entre {min}°C et {max}°C',
  travel_hub_badge_bag:'🧳 MA VALISE',
  travel_hub_badge_looks:'✈️ LOOKS VOYAGE',
  travel_hub_your_items:'Vos articles',
  travel_hub_your_outfits:'Vos tenues',
  travel_hub_packed_summary:'{n} article{s} emporté{s} · {dest}',
  travel_hub_packed_summary_max:'{n}/{max} article{s} emporté{s} · {dest}',
  travel_hub_select_what:'Sélectionnez ce que vous emportez',
  travel_add:'Ajouter',
  travel_empty_bag_title:'Valise vide',
  travel_empty_bag_desc:'Appuyez sur + pour ajouter des vêtements de votre dressing. Au moins 3 articles pour générer des looks.',
  travel_empty_bag_cta:'＋ Ajouter depuis le dressing',
  travel_missing_in_bag:'🧳 Il manque dans votre valise :',
  travel_searching_items:'Recherche d\'articles...',
  travel_cat_for_trip:'{cat} pour ce voyage ({n}{plus})',
  travel_view_more:'Voir\nplus',
  travel_view_details:'Voir détails ↗',
  travel_trending_items:'🛍️ Articles tendance pour ce voyage',
  travel_looks_count_summary:'{n} look{s} générés à partir de {p} article{ps}',
  travel_generation_in_progress:'Génération en cours…',
  travel_add_more_items:'Ajoutez encore {n} article{s} pour générer des looks',
  travel_add_clothes_to_bag:'Ajoutez des vêtements à votre valise',
  travel_regen_a11y:'Regénérer les looks',
  travel_avg_score:'Score moyen',
  travel_go_to_bag:'Aller à la valise →',
  travel_generating_looks:'Génération des looks…',
  travel_add_more_for_variety:'Ajoutez encore {n} article{s} pour générer des looks variés.',
  travel_minimum_combo_hint:'Pour des combinaisons réussies, votre valise doit contenir au moins un Haut + un Bas (ou une Robe) + des Chaussures.\n\nSinon, cliquez sur le bouton ↻ pour relancer.',
  travel_relaunch_generation:'↻  Relancer la génération',
  travel_looks_with_bag:'Looks avec votre valise',
  travel_outfits_count:'{n} tenue{s}',
  travel_outfits_with_label:' · {label}',
  travel_outfits_all_owned:' · 100% avec vos articles emportés',
  travel_filter_all:'Tout',
  travel_no_outfits_for_filter:'Aucune tenue {label} n\'a été générée avec votre valise.',
  travel_more_items_hint:'Ajoutez plus de vêtements dans votre valise pour obtenir plus de suggestions.',
  travel_looks_to_shop:'Looks à shopper',
  travel_looks_to_shop_sub:'Complétez votre valise pour ce voyage',
  travel_catalog_compatible_title:'Catalogue voyage (compatible)',
  travel_catalog_compatible_sub:'{n} articles · {temp}°C · {style}',
  travel_essentials_dest:'Essentiels {dest}',
  travel_articles_to_shop:'articles à shopper pour compléter votre valise',
  travel_cart_label:'PANIER',
  travel_discover_articles:'Découvrir les {n} articles à shopper',
  travel_checklist_badge:'🧳 CHECKLIST VOYAGE',
  travel_checklist_progress:'{checked} / {total} prêt',
  travel_checklist_done:'✨ Tout est prêt pour le départ !',
  travel_checklist_almost:'Presque prêt ! Plus que quelques items.',
  travel_checklist_more:'Il reste des choses à préparer.',
  travel_weather_forecast_badge:'MÉTÉO PRÉVUE · {dest}',
  travel_over_n_days:'Sur {n} jour{s}',
  travel_missing_in_suitcase:'Manques dans la valise',
  travel_missing_for_days:'Pour {n} jour{s}, il te manque :',
  travel_see_shopping_suggestions:'Voir les suggestions à shopper →',
  travel_rule_for_days:'📏 Règle pour {n} jour{s}',
  travel_rule_tops:'hauts',
  travel_rule_bottoms:'bas',
  travel_rule_pairs:'paires',
  travel_rule_footer:'+ 1 veste polyvalente · 1 accessoire signature',
  travel_ai_tips_badge:'✨ BONS PLANS IA',
  travel_ai_tips_title:'Conseils personnalisés',
  travel_ai_tips_sub:'Claude analyse votre voyage et te donne des astuces',
  travel_ai_tips_refresh:'↻ Actualiser',
  travel_ai_tips_generate_btn:'Générer',
  travel_ai_tips_cooldown_short:'⏱ {min} min',
  travel_ai_tips_empty:'Cliquez sur "Générer" pour obtenir 6 conseils malins sur votre valise, bons plans et astuces locales.',
  travel_my_dressing:'Mon dressing',
  travel_n_selected:'{n} article{s} sélectionné{s}',
  travel_add_n:'Ajouter',
  travel_dressing_empty:'Dressing vide',
  travel_dressing_empty_desc:'Ajoutez des vêtements dans votre dressing pour les emporter en voyage',
  travel_dressing_limited_badge:'🔒 DRESSING LIMITÉ',
  travel_dressing_limited_msg:'Votre dressing contient {total} articles, limités à {max} selon votre abonnement.',
  travel_upgrade_short:'Upgrade',
  travel_search_placeholder:'Rechercher (nom, pseudo)…',
  travel_n_articles:'{n} article{s}',
  travel_deselect_all:'Désélectionner tout',
  travel_select_all:'Tout sélectionner',
  travel_add_n_to_bag:'Ajouter {n} article{s} à la valise',
  travel_form_badge_edit:'✎ MODIFIER LE VOYAGE',
  travel_form_badge_new:'✨ NOUVEAU VOYAGE',
  travel_form_title_edit:'Modifier les détails',
  travel_form_title_new:'Préparez votre valise',
  travel_form_step_name:'Nom du voyage',
  travel_form_name_placeholder:'Ex : Été à Bali, Week-end à New York...',
  travel_form_step_destination:'Destination',
  travel_form_dest_placeholder:'Chercher une ville ou un pays...',
  travel_form_step_dates:'Dates du voyage',
  travel_form_label_departure:'DÉPART',
  travel_form_label_return:'RETOUR',
  travel_form_pick_date:'Choisir une date',
  travel_form_n_days:'{n} jour{s}',
  travel_form_duration:'Durée du séjour',
  travel_form_calculating:'Calcul en cours...',
  travel_form_estimated_temp:'Température estimée',
  travel_form_step_styles:'Style(s) de voyage',
  travel_form_step_styles_sub:'Sélectionnez un ou plusieurs styles (ex: plage + city break)',
  travel_form_save:'Enregistrer',
  travel_form_create:'Créer le voyage',
  travel_date_departure_title:'Date de départ',
  travel_date_return_title:'Date de retour',
  travel_temp_estimated:'{temp}°C estimé',

  // v1.12.282 — Phase B i18n : Auth screens MyTenue
  auth_tagline:'Votre styliste personnel',
  auth_section_label:'Connexion',
  sign_in:'Se connecter',
  sign_up:'S\'inscrire',
  sign_in_cta:'Se connecter',
  sign_up_cta:'Créer un compte',
  continue_with_google:'Continuer avec Google',
  continue_with_apple:'Continuer avec Apple',
  divider_or:'OU',
  password:'Mot de passe',
  confirm_password:'Confirmer le mot de passe',
  forgot_password_q:'Mot de passe oublié ?',
  forgot_password_title:'Mot de passe oublié',
  no_account_yet:'Pas encore de compte ?',
  create_account_link:'Créer un compte',
  already_have_account:'Déjà un compte ?',
  show_password:'Afficher',
  hide_password:'Masquer',
  password_placeholder:'Au moins 8 caractères',
  password_retype_placeholder:'Retapez le mot de passe',
  signup_first_name_placeholder:'Sofia',
  signup_last_name_placeholder:'Dupont',
  signup_title:'Créer un compte',
  signup_subtitle:'Rejoignez MyTenue avec votre email',
  signup_submit_cta:'Créer mon compte',
  signup_legal_intro:'J\'accepte les',
  signup_legal_terms_link:'conditions d\'utilisation',
  signup_legal_and:'et la',
  signup_legal_privacy_link:'politique de confidentialité',
  // Features bullets (login screen)
  feature_personalized_ai_looks:'✨ Looks IA personnalisés',
  feature_virtual_tryon:'📸 Try-on virtuel',
  feature_partner_cashback:'🛍️ Crédit Mytenue partenaires',
  feature_smart_wardrobe_title:'Dressing intelligent',
  feature_smart_wardrobe_desc:'Photographiez, l\'IA organise par catégorie et style.',
  feature_ai_looks_title:'Looks générés par IA',
  feature_ai_looks_desc:'Tenues à partir de votre dressing + catalogue.',
  feature_travel_mode_title:'Mode voyage',
  feature_travel_mode_desc:'Valise composée selon destination, météo et durée.',
  // v1.12.853 — Login feature: Try-On + Flat-Lay aide au shopping
  feature_tryon_flatlay_title:'Essayage virtuel & Flat-Lay',
  feature_tryon_flatlay_desc:'Essayez les articles avant achat et visualisez vos tenues en flat-lay pour acheter mieux.',
  // Verification / Confirm email
  verification_code:'Code de vérification',
  resend_code:'Renvoyer le code',
  resending_code:'Envoi en cours…',
  verify_email_title:'Vérifiez votre email',
  verify_email_subtitle:'Nous avons envoyé un code à 6 chiffres à',
  verify_email_missing:'— email manquant —',
  verify_email_help:'Saisissez-le ci-dessous pour activer votre compte.',
  verify_email_help_text:'Vous ne recevez rien ? Vérifiez vos spams. Le code expire au bout de 24 h.',
  verify_validate_cta:'Valider',
  verify_back_link:'← Retour',
  code_resent_at:'Code renvoyé à {time}',
  account_verified_title:'Compte vérifié ✓',
  account_verified_msg:'Votre adresse {email} est maintenant active !\n\nConnectez-vous avec votre email et votre mot de passe pour accéder à MyTenue.',
  // Forgot password
  forgot_step1_subtitle:'Entrez votre email pour recevoir un code de réinitialisation.',
  forgot_step2_subtitle:'Saisissez le code reçu par email et choisissez un nouveau mot de passe.',
  forgot_send_code_cta:'Envoyer le code',
  forgot_code_label:'Code reçu par email',
  forgot_new_password_label:'Nouveau mot de passe',
  forgot_reset_cta:'Réinitialiser',
  forgot_change_email_link:'← Changer d\'email',
  back_to_signin:'Retour à la connexion',
  code_sent_title:'Code envoyé ✉',
  code_sent_msg:'Un code à 6 chiffres a été envoyé à votre email.\nVérifiez votre boîte de réception (et les spams).',
  password_changed_title:'Mot de passe modifié ✓',
  password_changed_msg:'Votre mot de passe a été mis à jour. Connectez-vous avec le nouveau pour accéder à MyTenue.',
  account_not_found_title:'Compte introuvable',
  account_not_found_msg:'Aucun compte n\'existe avec {email}.\n\nVoulez-vous créer un nouveau compte avec cet email ?',
  account_exists_title:'Compte déjà existant',
  account_exists_msg:'Un compte existe déjà avec {email}.\n\nQue souhaitez-vous faire ?',
  signup_failed_title:'Échec',
  signup_failed_msg:'Création de compte impossible.',
  signup_email_sent_title:'Email envoyé ✉',
  signup_email_sent_msg:'Compte créé !\n\nUn email de vérification avec un code à 6 chiffres a été envoyé à :\n{email}\n\nVérifiez votre boîte de réception (et les spams), puis saisissez le code dans l\'écran suivant pour activer votre compte.',
  enter_code_cta:'Saisir le code',
  later_cta:'Plus tard',
  retry_cta:'Réessayer',
  account_not_confirmed_title:'Compte non vérifié',
  account_not_confirmed_msg:'Saisissez le code reçu par email pour activer votre compte.',
  signin_failed_title:'Connexion impossible',
  apple_signin_failed_title:'Connexion Apple impossible',
  apple_signin_unknown_error:'Erreur inconnue lors de l\'échange avec le serveur.',
  apple_unavailable_title:'Non disponible',
  apple_unavailable_msg:'Sign In with Apple est réservé à iOS 13+. Utilisez Google sur Android.',
  apple_module_missing_title:'Module manquant',
  apple_module_missing_msg:'expo-apple-authentication n\'est pas installé. Faites un dev-build EAS (Expo Go ne supporte pas ce module).',
  apple_ios13_required:'Sign In with Apple nécessite iOS 13 ou supérieur.',
  config_missing_title:'Configuration manquante',
  config_missing_msg:'Configurez AWS_CONFIG.oauth.domain dans aws_config.js\n\nAllez dans Cognito Console → App clients → Hosted UI',
  error_title:'Erreur',
  favorites_signin_required:'Connectez-vous pour ajouter à vos favoris.',
  favorites_save_failed:'Impossible d\'enregistrer les favoris. Réessayez ou reconnectez-vous.',
  email_missing_msg:'Email manquant. Recommencez l\'inscription.',
  invalid_code_title:'Code invalide',
  invalid_code_msg:'Saisissez le code à 6 chiffres reçu par email.',
  verify_failed_title:'Vérification échouée',
  verify_failed_msg:'Code incorrect ou expiré.',
  code_expired_title:'Code expiré',
  code_expired_msg:'Ce code n\'est plus valide.\nDemandez un nouveau code.',
  wrong_code_title:'Code incorrect',
  wrong_code_msg:'Le code saisi ne correspond pas.\nVérifiez votre email et réessayez.',
  code_resent_title:'Code renvoyé',
  code_resent_msg:'Vérifiez votre boîte mail.',
  resend_failed_msg:'Impossible de renvoyer le code.',
  new_code_sent_msg:'Nouveau code envoyé. Vérifiez votre boîte mail.',
  // Inline errors
  err_invalid_credentials:'Identifiants incorrects. Vérifiez votre email et mot de passe.',
  err_empty_credentials:'Saisissez votre email et votre mot de passe.',
  err_invalid_email_format:'Format d\'email invalide. Exemple : prenom@exemple.com',
  err_account_not_confirmed:'Compte non vérifié. Saisissez le code reçu par email.',
  err_first_name_required:'Prénom requis',
  err_last_name_required:'Nom requis',
  err_email_required:'Email requis',
  err_email_invalid:'Email invalide',
  err_password_min_length:'Au moins 8 caractères',
  err_password_lowercase:'Au moins une minuscule',
  err_password_uppercase:'Au moins une majuscule',
  err_password_digit:'Au moins un chiffre',
  err_password_required:'Mot de passe requis',
  err_passwords_mismatch:'Les mots de passe ne correspondent pas',
  err_confirm_password:'Confirmez votre mot de passe',
  err_accept_cgu:'Acceptez les conditions d\'utilisation',
  err_account_not_found:'Aucun compte trouvé avec cet email.',
  err_send_code_failed:'Impossible d\'envoyer le code.',
  err_code_required:'Code requis',
  err_code_6_digits:'Code à 6 chiffres requis',
  err_code_expired_short:'Code expiré, demandez-en un nouveau',
  err_code_incorrect_short:'Code incorrect, vérifiez votre email',
  err_reset_failed:'Échec de la réinitialisation',
  // Legal block (login)
  legal_acceptance_text:'En continuant vous acceptez nos conditions\nd\'utilisation et notre politique de confidentialité.',
  legal_terms_link:'Conditions d\'utilisation',
  legal_privacy_link:'Politique de confidentialité',
  legal_publisher:'🇫🇷 Édité par MYTENUE (SASU) · 17 rue Benoît Malon, 92150 Suresnes',
  legal_siret:'SIREN 105 776 215 · contact@mytenue.com',
},

/* ══════════════════════════════════════════════════════════
 *  ENGLISH
 * ══════════════════════════════════════════════════════════ */
en: {
  nav_home:'Home', nav_looks:'Looks', nav_wardrobe:'Wardrobe',
  nav_catalog:'Catalog', nav_favorites:'Favorites', nav_looks_ia:'AI Looks',
  nav_alerts:'Alerts', nav_profile:'Profile', nav_travel:'Travel',
  good_morning:'Good morning', good_afternoon:'Good afternoon', good_evening:'Good evening', guest:'Guest',
  occ_evening:'Evening', occ_dinner:'Dinner', occ_casual:'Going out',
  occ_work:'Work', occ_date:'Date', occ_travel:'Travel',
  look_of_day:'Look of the day', suggestions:'Suggestions',
  compatibility:'Compatibility', perfect:'Perfect', excellent:'Excellent', good:'Good',
  ai_tip:'AI Tip', complete_outfit:'Complete the outfit', see_all:'See all',
  missing_pieces:'To buy', full_wardrobe:'✓ All from wardrobe', to_buy:'To buy',
  budget:'Budget', no_limit:'No limit', no_looks_budget:'No looks in this budget',
  remove_filter:'Remove filter', all_occasions:'All',
  my_wardrobe:'My Wardrobe', pieces:'items', search_item:'Search items...',
  add_item:'+ Add', all_categories:'All', all_partners:'All partners',
  cat_dresses:'Dresses', cat_tops:'Tops', cat_jackets:'Jackets',
  cat_bottoms:'Bottoms', cat_shoes:'Shoes', cat_bags:'Bags',
  cat_accessories:'Accessories', cat_jewelry:'Jewelry',
  cat_swimwear:'Swimwear', cat_sportswear:'Sportswear',
  travel_wardrobe:'Travel Wardrobe', my_trips:'My Trips',
  new_trip:'New Trip', trip_name:'Trip name',
  destination:'Destination', departure:'Departure', return_date:'Return',
  packed_items:'Packed items', outfit_suggestions:'Outfit suggestions',
  weather_dest:'Weather at destination', add_to_bag:'Add to bag',
  whats_in_my_bag:'In my bag', travel_looks:'Travel looks',
  pack_light:'Pack light', dont_forget:'Don\'t forget',
  trip_style:'Trip style', days_count:'days',
  my_cart:'My Cart', subtotal:'Subtotal', shipping:'Shipping',
  free_shipping:'Free', total:'Total', secure_payment:'Secure Payment',
  order_now:'Order now', delivery_address:'Delivery address',
  empty_cart:'Your cart is empty',
  alerts_stock:'Alerts & Stock', notifications:'Notifications',
  my_alerts:'My Alerts', mark_all_read:'Mark all read',
  back_in_stock:'Back in stock!', price_drop:'Price drop',
  low_stock:'Low stock', view_item:'View item →', add_to_cart:'Add to cart',
  watch_item:'Watch', in_stock:'In stock', out_of_stock:'Out of stock',
  my_profile:'My Profile', member_since:'Member since',
  settings:'Settings', language:'Language', currency:'Currency',
  region:'Region', sign_out:'Sign out', follow_us:'Follow us',
  loading:'Loading...', cancel:'Cancel', confirm:'Confirm',
  save:'Save', edit:'Edit', delete:'Delete',
  close:'Close', back:'Back', search:'Search',
  filter:'Filter', sort:'Sort', share:'Share',
  my_account:'MY ACCOUNT', my_style_ai:'MY STYLE AI',
  rewards:'REWARDS', quick_access:'QUICK ACCESS',
  region_language:'REGION & LANGUAGE', settings_caps:'SETTINGS',
  my_earnings:'MY EARNINGS', subscription:'SUBSCRIPTION',
  looks_created:'Looks created', purchases:'Purchases',
  push_notifications:'Push notifications', integrated_weather:'Integrated weather',
  dark_mode:'Dark mode', daily_prefs:'Today\'s preferences',
  edit_profile:'Edit profile', restore_purchases:'Restore purchases',
  delete_account:'Delete my account', terms_conditions:'Terms & Conditions',
  privacy_policy:'Privacy Policy', terms_of_sale:'Terms of Sale', help_support:'Help & support',
  legal:'Legal', upgrade:'Upgrade to Premium', current_plan:'Current plan',
  free_plan:'Free', basic_plan:'Basic', premium_plan:'Premium', gold_plan:'Gold',
  my_preferences:'My preferences', favorites:'Favorites', saved_items:'Saved items', cashback_earnings:'My credits',
  sign_out_q:'Do you want to sign out?',
  formality:'Formality', dominant_palette:'Dominant palette', detected_styles:'Detected styles', top_category:'Top category', avg_price:'Avg. price',
  style_empty_title:'Profile not analyzed yet', style_empty_desc:'Add items to your wardrobe — AI will automatically analyze your style.', go_to_wardrobe:'Go to wardrobe →',
  ai_stylist:'AI STYLIST', your_wardrobe:'Your wardrobe', view_all:'View all', categories:'Categories', ai_analyzed:'AI analyzed', boost_style:'To boost your style', create_wardrobe:'Create my wardrobe', create_wardrobe_desc:'Add clothes for personalized suggestions', trending_week:'THIS WEEK\'S TRENDS', trending_subtitle:'What\'s trending', complete_outfits:'COMPLETE OUTFITS', stylist_selection:'AI Stylist Selection', stylist_selection_desc:'AI-curated looks from the catalog', loading_outfits:'Loading outfits…', discover_outfit:'DISCOVER OUTFIT', collapse:'Collapse', catalog_caps:'CATALOG', view_full_catalog:'View full catalog', navigation_caps:'NAVIGATION', quick_nav:'Quick access', bought_add_to_wardrobe:'Purchased → Add to wardrobe',
  create:'Create', add:'Add', ai_analyzing:'AI analyzing', auto_analysis_bg:'Auto-analysis in background', shopping_ai_caps:'AI SHOPPING', no_suggestions_yet:'No suggestions yet', no_suggestions_desc:'Add more items to your wardrobe so AI can generate looks to complete', looks_to_shop:'Looks to shop', looks_to_shop_desc:'Complete your looks with 5 to 10 curated items', claude_analyzing:'Claude is analyzing your combinations…', cart_caps:'CART', owned:'Owned', view_more_suggestions:'See 10 more suggestions', searching_items:'Searching items…', more_combinations:'More combinations', search_more_partners:'Search more partner items', my_creations_caps:'MY CREATIONS', my_looks:'My looks', create_new_look:'CREATE A NEW LOOK',
  delete_account_q1:'This action cannot be undone. All your data (wardrobe, trips, looks, alerts, subscription) will be permanently deleted.', delete_account_q2:'Confirm permanent deletion of your account?', delete_confirm:'Delete', delete_account_error:'Deletion failed. Please try again later or contact support.',
  // v1.12.273 — Phase B i18n : WardrobeScreen MyTenue
  my_pieces:'My pieces',
  tooltip_create_new_look:'Compose a new look from your pieces',
  tooltip_add_item_photo_or_url:'Add a piece to your wardrobe — by photo or URL import',
  wardrobe_fully_analyzed:'Wardrobe fully analysed · {count} pieces',
  ai_analysis_in_progress:'AI analysis in progress',
  one_item_pending_analysis:'1 piece awaiting analysis',
  items_pending_analysis:'{count} pieces awaiting analysis',
  analyzed_label:'analysed',
  remaining_label:'remaining',
  auto_analysis_background:'⏳ Auto-analysis running in the background',
  one_personal_look:'1 signature look',
  personal_looks_count:'{count} signature looks',
  create_own_looks_hint:'Compose your own looks with your pieces and curated shopping suggestions',
  tooltip_create_complete_look:'Compose a complete look — select your pieces and let the AI suggest the finishing touches',
  create_first_look_desc:'Compose your first look by selecting pieces from your wardrobe — the AI will suggest the perfect complements to shop.',
  tooltip_regenerate_shopping_suggestions:'Refresh the shopping suggestions for this look',
  my_look_default:'My look',
  complete_or_replace:'Complete or replace',
  more_items_short:'More\npieces',
  generate_more_items:'Generate more\npieces',
  no_valid_suggestions_yet:'No suggestions available yet',
  generate_suggestions:'Generate suggestions',
  delete_this_look_q:'Delete this look?',
  action_irreversible:'This action cannot be undone.',
  delete_this_look:'Delete this look',
  ai_analysis_in_progress_dots:'AI analysis in progress…\nDetails will appear here once the analysis is complete.',
  used_in_looks_count:'Worn in {count} look(s)',
  create_a_look:'Compose a look',
  confirm_remove_from_wardrobe:'Remove « {name} » from your wardrobe?\nThis action cannot be undone.',
  look_created_title:'✨ Look saved',
  look_created_msg:'Your look « {name} » has been saved with {items} piece(s) and {suggestions} suggestion(s).',
  permission_camera_required:'Please grant camera access',
  permission_gallery_required:'Please grant gallery access',
  photo_required:'Photo required',
  photo_required_msg:'Take a photo, choose one from your gallery, or paste a URL.',
  add_a_piece:'Add a piece',
  take_a_photo:'Take a photo',
  photograph_your_item:'Capture your piece',
  from_gallery:'From the gallery',
  choose_existing_photo:'Choose an existing photo',
  from_url:'From a URL',
  instagram_facebook_article_link:'Instagram, Facebook or product link',
  ai_will_detect_item_details:'🤖 The AI will identify the name and details of your piece.',
  category:'Category',
  pseudo_optional:'Alias (optional)',
  pseudo_helper:'A personal nickname to find it quickly (search uses both AI name and alias).',
  item_analyzed_title:'✨ Piece analysed',
  item_analyzed_msg:'{name}\n→ {detected}\n\nThe AI has identified its details to refine your look suggestions.',
  perfect_excl:'Perfect!',
  // v1.12.266 — Phase B i18n : modals AddOutfit + CalendarDayDetail
  add_outfit_title:'Add an outfit', source_outfit_of_day:'Outfit of the day', source_my_looks:'My Looks', source_ai_looks:'AI Looks', source_manual_photo:'Manual photo', manual_photo_desc:'Import a photo and add occasion or notes', back_arrow:'← Back', save_this_look:'Save this look', save_this_ai_look:'Save this AI look', confirm_and_add:'Confirm and add', delete_outfit_title:'Delete outfit', outfit_worn:'Outfit worn', notes:'Notes', location:'Location', delete_this_outfit:'🗑  Delete this outfit', permission_required:'Permission required', permission_photos_required:'Please grant photo access to continue.', photo_selection_failed:'Could not select photo', outfit_already_exists:'An outfit already exists', replace:'Replace', cannot_save_outfit:'Could not save the outfit', cannot_delete:'Could not delete', ai_recommendation:'AI recommendation', alternatives:'alternatives', no_look_created:'No look created yet', no_ai_look_generated:'No AI look generated yet (visit the Looks tab)', for_which_day:'For which day?', select_date_worn:'Select the date you are wearing or wore this outfit.', outfit_to_add:'Outfit to add', selected_outfit:'Selected outfit', outfit_of_day_proposed:'Suggested outfit of the day', ai_recommendation_of_day:'AI recommendation of the day', regenerate_arrow:'↻ Regenerate', for:'For:', no_ai_look_yet_hint:'No AI look yet. Open the AI Looks tab to generate some.', search_placeholder_full:'Search (name, brand, alias, item…)', filter_by_item:'Filter by item', clear_filter:'✕ Clear', all:'All', no_look_matches_search:'No look matches your search.', displayed:'shown', select_a_look:'Select a look', no_personalised_look:'No personalised look created.', outfit_photo_optional:'Outfit photo (optional)', tap_to_import:'Tap to import', occasion:'Occasion', notes_placeholder:'e.g. worked well, to wear again…', saving_ellipsis:'Saving…', added_from:'Added from:',
  // ═══ AddByUrlModal + CreateLookModal — i18n ═══
  add_from_url_title:'Add from a URL', add_url_subtitle:'Paste an item URL to add it to your wardrobe',
  add_url_hint_main:'💡 Paste a link from a fashion e-commerce site (Sézane, Nike, Chanel, Dior, Louis Vuitton, La Redoute…). The image is fetched automatically.',
  add_url_hint_social_label:'For Instagram or Facebook', add_url_hint_social_text:': right-click the photo → "Copy image address", then use',
  add_url_hint_method2_label:'Method 2', add_url_hint_method2_field:'(the "Image URL" field).',
  paste_link_here:'Paste the link here…', search_button:'SEARCH',
  site_blocked_paste_image_link:'Site blocked? Paste the image URL', method2_badge:'METHOD 2', image_url_label:'Image URL',
  url_step_web_1:'Open the site (Zara, etc.) in another tab',
  url_step_web_2:'Right-click on the product image',
  url_step_web_3:'Choose "Copy image address"',
  url_step_web_4:'Come back here and paste the URL below',
  url_step_native_1:'Open the site in Safari (Zara, etc.)',
  url_step_native_2:'Long-press the product image',
  url_step_native_3:'Choose "Copy image"',
  url_step_native_4:'Come back here and paste below',
  category_caps:'CATEGORY', add_via_image_button:'ADD VIA IMAGE', or_add_by_photo:'Or add by photo 📸',
  preview_caps:'PREVIEW', pseudo_optional_caps:'ALIAS (OPTIONAL)', pseudo_placeholder:'e.g. My favourite, Cosy winter knit…',
  add_to_wardrobe_button:'ADD TO WARDROBE', try_another_url:'Try another URL',
  paste_url_error:'Paste an item URL (Zara, Sézane, Nike, Louis Vuitton…)',
  url_must_http:'The URL must start with http:// or https://',
  site_blocks_use_method2:'This site blocks automatic extraction. Use Method 2 ↓',
  instagram_guide:'Instagram blocks automatic post extraction. To add this photo: open the post in your browser, right-click the photo → "Copy image address", and paste it in the "Image URL" field below.',
  facebook_guide:'Facebook blocks automatic post extraction. To add this photo: open the photo full-size in your browser, right-click → "Copy image address", and paste it in the "Image URL" field below.',
  site_blocks_paste_image_below:'This site blocks extraction. Paste the image URL below (Method 2).',
  site_unavailable_paste_image:'Site unavailable. Paste the image URL below.',
  site_blocks_complete_manually:'This site blocks automatic extraction. Please complete the price and photo manually.',
  network_error_paste_image:'Network error. Paste the image URL below.',
  item_already_in_wardrobe:'⚠️ Item already in your wardrobe',
  you_already_have:'You already have:', add_anyway_question:'Add it anyway? (e.g. a different size)',
  add_anyway:'Add anyway', similar_item:'Similar item', size_paren:'(size {size})',
  paste_image_url:'Paste the image URL (right-click the image → copy URL)',
  image_url_must_http:'The image URL must start with http(s)://',
  brand_protected_title:'🛡️ Highly protected site',
  brand_protected_message:'This brand (Louis Vuitton, Hermès, etc.) blocks even our advanced anti-bot systems.\n\nSimple solution:\n1. Go back to Safari\n2. Long-press the image\n3. "Add to Photos"\n4. Come back here → 📸 Photo button\n5. Choose the image from your gallery',
  understood:'Understood', add_by_photo:'📸 Add by photo',
  brand_protected_save_image:'Brand too protected. Save the image to Photos, then use 📸 Photo.',
  session_expired:'Session expired. Please sign in again.',
  error_status_retry:'Error {status}. Please try again.', network_error_retry:'Network error. Please try again.',
  cat_coats:'Coats',
  occ_sport:'Sport', occ_ceremony:'Ceremony', occ_weekend:'Weekend',
  occ_casual_desc:'Relaxed everyday outfit', occ_evening_desc:'Night out, dinner, event',
  occ_work_desc:'Professional attire', occ_sport_desc:'Physical activity',
  occ_ceremony_desc:'Wedding, formal event', occ_weekend_desc:'Stroll, brunch, leisure',
  occ_travel_desc:'Travel, getaway, trip', occ_date_desc:'Couple outing, romantic dinner',
  more:'More', edit:'Edit', your_look:'Your look', temp_label:'Temperature', occasion_label:'Occasion', select_at_least_one_item:'Select at least one item to continue', zoom:'Zoom', badge_trending:'TRENDING', from_catalog:'from catalog',
  profile_privacy_notice:'Your information is confidential and used only to personalize your Mytenue experience.',
  not_clothing_title:'Not a clothing item',
  not_clothing_msg:'The AI did not detect any clothing in this photo. Please use an image of a clothing item, shoe, bag, or fashion accessory.',
  category_corrected_title:'Category corrected',
  category_corrected_msg:'The AI corrected the category: "{user}" → "{ai}". The item has been added with the right category.',
  login_required:'Login required', login_to_enable_reminders:'Log in to enable reminders.',
  mobile_only:'Mobile only', reminders_mobile_only:'Daily reminders require the iOS or Android app.',
  cannot_enable_reminder:'Cannot enable reminder.',
  category_confirm_title:'Category to confirm',
  category_confirm_msg:'You picked the category "{userCategory}" but the AI detected an item in category "{detectedCategory}" on the photo.\n\nWhat would you like to do?',
  use_category_btn:'Use "{name}"', keep_category_btn:'Keep "{name}"',
  loading_in_progress:'Loading',
  catalog_still_loading:'The catalog is still loading. Please try again in a few seconds.',
  error:'Error', cannot_generate_suggestions:'Unable to generate suggestions right now.',
  detail_label:'Detail:', try_restart_app:'Try restarting the app or signing in again.',
  alternatives_to_your_items:'Alternatives to your items', to_complete_your_look:'To complete your look',
  create_look_caps:'CREATE A LOOK',
  step_choose_items:'Choose items', step_choose_occasion:'Choose the occasion', step_complete_look:'Complete the look',
  select_1_to_4_intro:'Select', select_1_to_4_emphasis:'1 to 4 items', select_1_to_4_outro:'from your wardrobe to create a look.',
  // ═══ Source mode (Wardrobe / Catalog / Mix) ═══
  source_mode_wardrobe:'My Wardrobe',
  source_mode_catalog:'Catalog',
  source_mode_mix:'Mix',
  source_mode_label:'Item source',
  // v1.12.276 — WebSidebar footer (signed-out page)
  sidebar_signin:'Sign in',
  sidebar_guest_account:'Guest account',
  sidebar_edited_by:'🇫🇷 Published by MYTENUE (SASU)',
  sidebar_address:'17 rue Benoît Malon, 92150 Suresnes',
  sidebar_terms:'Terms',
  sidebar_privacy:'Privacy',
  sidebar_cgv:'Terms of Sale',
  sidebar_my_profile:'My profile',
  sidebar_sign_out:'Sign out',
  // v1.12.278
  search_to_see_more:'Search to see more',
  // v1.12.275 — RequireAuth (gates "Sign in" on gated tabs)
  require_auth_cta:'Sign in',
  require_auth_hint:'Free signup · No commitment',
  require_auth_default_title:'Personal space',
  require_auth_default_body:'Sign in to access this section.',
  require_auth_looks_title:'Your personalized looks',
  require_auth_looks_body:'Sign in to generate outfits from your wardrobe and the MyTenue catalog.',
  require_auth_wardrobe_title:'Your wardrobe',
  require_auth_wardrobe_body:'Sign in to add your clothes and organize your wardrobe.',
  require_auth_travel_title:'Travel mode',
  require_auth_travel_body:'Sign in to plan your suitcase with MyTenue.',
  require_auth_favorites_title:'Your favorites',
  require_auth_favorites_body:'Sign in to find your favorite items.',
  require_auth_profile_title:'Your profile',
  require_auth_profile_body:'Sign in to manage your account, orders and preferences.',
  // v1.12.271 — UX refresh: tabs + cumulative selection
  tab_wardrobe:'👗 Wardrobe',
  tab_catalog:'🛍️ Catalog',
  // v1.12.296 — partner preferences
  daily_prefs_q_partners:'Which partners do you prefer?',
  partner_tous:'TOUS',
  partner_iqueens:'iQueens',
  partner_suit:'Suit Negozi',
  partner_ann:'Ann Demeulemeester',
  partner_coutr:'COUTR',
  partner_drestige:'DRESTIGE',
  partner_tamaris:'Tamaris',
  partner_desigual:'Desigual',
  optional:'optional',
  // v1.12.291 — Favorites tab in Create Look
  tab_favorites:'❤️ Favorites',
  favorites_empty_title:'No favorites yet',
  favorites_empty_desc:'Add products from the catalog to your favorites to find them here.',
  your_selection_header:'My selection',
  your_selection_empty:'No items yet — pick from Wardrobe or Catalog',
  badge_replace:'🔄 Replace',
  badge_match:'✅ Match',
  ai_picks_per_category:'AI suggests several alternatives per category — pick your favorite',
  tap_to_swap:'Tap to add / swap',
  sources_from:'Sources: {wardrobe_count} from wardrobe · {catalog_count} from catalog',
  empty_catalog_mode:'No catalog items in this category',
  empty_wardrobe_mode:'Your wardrobe is empty for this category. Try \'Catalog\' or \'Mix\'.',
  items_selected_plural:'items selected', item_selected_singular:'item selected',
  ai_will_complete_look:'💡 AI will complete this look with matching items',
  wardrobe_empty:'Wardrobe empty', add_items_first:'Add items to your wardrobe.',
  search_by_name_brand_pseudo:'Search by name, brand or alias…',
  items_word_plural:'items', item_word_singular:'item', filtered_suffix:'filtered',
  no_results:'No results', change_search_or_category:'Refine your search or change category.',
  search_in_my_looks_placeholder:'Search (name, category, color, item…)',
  what_kind_of_look:'What kind of look would you like to create?',
  ai_created_complete_look:'✨ AI created a complete look around your item',
  your_items_plus_ai:'Your items + AI suggestions to complete',
  your_items:'Your items', ai_suggestions_to_complete:'AI suggestions to complete',
  stylist_advice_intro:'✨ Stylist note: here is what your look needs and the best partner items to complete it',
  essential_tag:'ESSENTIAL', searching_items_dots:'Searching items…', more_items:'More items',
  next_arrow:'Next →', loading_catalog:'Catalog…', loading_generation:'Generating…',
  generate_look:'Generate the look ✨', save_this_look_check:'Save this look ✓',
  // ═══ v1.12.73 — Option A: final score, name suggestions, next actions ═══
  final_score_title:'Final score',
  final_score_subtitle:'Local evaluation of the look — style/color/material banks',
  grade_label:'Grade',
  grade_exceptional:'Exceptional',
  grade_excellent:'Excellent',
  grade_very_good:'Very good',
  grade_good:'Good',
  grade_decent:'Decent',
  grade_acceptable:'Acceptable',
  grade_needs_work:'Needs work',
  grade_poor:'Poor',
  score_style_match:'Style',
  score_color_harmony:'Color',
  score_material_compat:'Material',
  score_ai_vision:'AI vision',
  score_context:'Context',
  badge_best_match:'★ BEST MATCH',
  badge_color_harmony:'Harmony',
  badge_style_match:'Style',
  badge_fav_color:'Favorite color',
  badge_from_wardrobe:'Wardrobe',
  strengths_label:'Strengths',
  improvements_label:'Improvements',
  // v1.12.269 — conflict details in breakdown
  conflict_material_label:'Material conflict',
  conflict_color_label:'Color clash',
  conflict_style_label:'Wrong style for occasion',
  conflict_material_line:'{a} ({aMat} · {aFam}) + {b} ({bMat} · {bFam}) — incompatible',
  conflict_material_line_same_family:'{a} and {b} ({aFam}) — needs balancing',
  conflict_color_line:'{a} ({aCol}) + {b} ({bCol}) — clashing',
  conflict_style_line:'{item} fits {actual} ({actualScore}/100) more than {wanted} ({wantedScore}/100)',
  conflict_missing_material:'Missing material on: {names}',
  conflict_missing_color:'Missing color on: {names}',
  conflict_missing_occasion:'Missing occasion tags on: {names}',
  conflict_severity_high:'high',
  conflict_severity_medium:'medium',
  fam_chic:'chic',
  fam_casual:'casual',
  fam_sport:'sport',
  fam_neutral:'neutral',
  fam_warm:'warm',
  fam_cool:'cool',
  fam_earth:'earth',
  fam_bright:'bright',
  fam_pastel:'pastel',
  suggest_names_label:'Name suggestions',
  enter_look_name:'Look name',
  save_look_action:'Save look',
  next_actions_title:'What to do with this look?',
  next_action_tryon:'✨ Virtual try-on',
  // v1.12.282 — save confirmation + view my looks button
  look_saved_banner_title:'✓ Look saved',
  look_saved_banner_body:'Find it in Wardrobe › My Looks',
  next_action_view_my_looks:'👗 View my looks',
  sign_in_to_save_look_title:'Sign in to save your look',
  sign_in_to_save_look_body:'Create a free account to save your looks in your wardrobe and find them anytime.',
  // v1.12.283 — try-on gate (auth + subscription)
  tryon_signin_title:'Sign in to try this look',
  tryon_signin_body:'Virtual try-on requires an account to generate your mannequin and keep your try-ons.',
  tryon_subscribe_title:'Upgrade to premium',
  tryon_subscribe_body:'Virtual try-on is included in Basic, Premium and Gold plans. Activate your subscription to try this look on your mannequin.',
  tryon_subscribe_cta:'View plans',
  // v1.12.285 — favorites from stylist selection
  add_to_favorites_title:'Add to favorites',
  add_outfit_to_favorites_confirm:'This look and its {count} pieces will be added to your favorites. Continue?',
  confirm_add:'Add',
  view_my_favorites:'❤️ View my favorites',
  next_action_save:'💝 Save to My Looks',
  next_action_saved:'💝 Saved ✓',
  next_action_calendar:'📅 Add to calendar',
  next_action_share:'📤 Share',
  next_action_buy:'🛍️ Buy missing items',
  name_error_required:'Please enter a name',
  name_error_too_short:'Name too short (3 characters minimum)',
  name_error_too_long:'Name too long (50 characters maximum)',
  name_error_only_digits:'Name cannot be digits only',
  name_error_forbidden:'Word not allowed in the name',
  name_error_already_used:'This name is already taken',
  weighted_label:'weighted',
  // ═══ HomeScreen — full i18n (v1.12.270+) ═══
  your_stylist_ai_caps:'YOUR AI STYLIST',
  outfit_calendar_tooltip:'My outfit calendar — track what you wear day by day',
  outfit_calendar_label:'Outfit calendar',
  daily_prefs_tooltip:'Set your preferences for today — style, occasion, budget',
  daily_short:'Today',
  outfit_of_day_section:'Outfit of the day',
  from_your_wardrobe:'From your wardrobe',
  closest_to_taste:'Closest to your taste',
  no_matching_outfit:'ℹ️ No outfit matches your preferences exactly — here is the closest look.',
  not_enough_items:'Not enough items',
  add_items_for_outfit:'Add items to your wardrobe so we can compose an outfit (Top + Bottom + Shoes, or Dress + Shoes).',
  add_an_item_caps:'+ ADD AN ITEM',
  piece_caps:'PIECE',
  main_piece_caps:'KEY PIECE',
  cat_accessories_short:'Access.',
  hide_accessories_caps:'↑ HIDE ACCESSORIES',
  view_accessories_jewelry_caps:'↓ VIEW {count} ACCESSORIES & JEWELRY',
  view_accessories_jewelry:'View accessories & jewelry',
  try_on_caps:'TRY-ON',
  try_on:'Try-on',
  try_on_outfit_tooltip:'Try this outfit on a model (or your own photo)',
  add_outfit_to_calendar_tooltip:'Add this outfit to my calendar',
  add_to_wardrobe_cta:'Add to wardrobe',
  // v1.12.309 — empty wardrobe CTA on Home suggests composing from catalog
  empty_wardrobe_compose_from_catalog:'Compose your first look from our catalog, add pieces to your wardrobe as you go.',
  diversified_by_category:'curated across categories',
  see:'View {count}',
  generating_stylist_selection:'Curating your stylist selection…',
  badge_chic:'CHIC',
  badge_casual:'CASUAL',
  badge_office:'OFFICE',
  badge_sport:'SPORT',
  badge_feminine:'FEMININE',
  badge_boho:'BOHO',
  badge_street:'STREET',
  badge_minimal:'MINIMAL',
  badge_evening:'EVENING',
  badge_date:'DATE',
  badge_brunch:'BRUNCH',
  badge_travel:'TRAVEL',
  badge_beach:'BEACH',
  badge_structured:'STRUCTURED',
  savings_label:'-{amount} € savings',
  items_added_to_favorites:'{count} items added to favorites.',
  loading_caps:'LOADING…',
  see_more_outfits_caps:'↓ VIEW {count} MORE OUTFITS',
  outfits_word:'outfits',
  daily_selection_caps:'TODAY\'S SELECTION',
  daily_display:'Today\'s feature',
  for_occasion:'for {occasion}',
  style_label:'style {styles}',
  styles_word:'styles',
  cashback:'MyTenue Credits',
  quick_daily_prefs_sub:'Style, occasion, budget',
  quick_wardrobe_sub:'Manage my items',
  quick_looks_sub:'Today\'s outfits',
  quick_catalog_sub:'Discover',
  quick_travel_sub:'Plan a trip',
  quick_favorites_sub:'Saved items',
  color_label:'Color:',
  view_on:'View on {partner}',
  partner:'Partner',
  my_look:'My look',
  login_required:'Sign-in required',
  login_required_for_tryon:'Please sign in to use the virtual try-on.',
  login_required_for_flatlay:'Please sign in to generate a Flat-Lay of your outfit.',
  sign_in:'Sign in',
  regenerate:'Regenerate',
  // ═══ CatalogScreen (MyTenue) — i18n complet ═══
  filters_caps:'FILTERS', boutique_badge:'🛍️ SHOP',
  all_partners:'All partners', articles_count:'items',
  no_results_found:'No items', no_awin_results:'No AWIN results for this search',
  try_other_filters:'Try other filters',
  price:'Price', brand:'Brand', color:'Color',
  sort_relevance:'Relevance', sort_price_asc:'Price ↑', sort_price_desc:'Price ↓',
  sort_discount:'% Off', sort_rating:'★ Rating',
  only_favorites:'❤️ My favorites only', reset_filters:'Reset filters',
  cat_all:'All', brand_all:'All', color_all:'All',
  gender_all:'All', gender_woman:'Women', gender_man:'Men',
  search_catalog_placeholder:'Search (black dress, winter coat...)',
  trending_this_week:'Trending this week',
  ac_brand:'brand', ac_color:'color', ac_category:'category',
  bought_prefix:'🛍  I bought:',
  // Sub-categories (dynamic chips)
  sub_all:'All',
  sub_shirts:'Shirts', sub_tshirts:'T-shirts', sub_pulls:'Sweaters', sub_sweatshirts:'Sweatshirts',
  sub_hoodies:'Hoodies', sub_crop_tops:'Crop tops', sub_polos:'Polos',
  sub_pants:'Pants', sub_tracksuits:'Tracksuits', sub_joggings:'Joggers',
  sub_jeans:'Jeans', sub_skirts:'Skirts', sub_shorts:'Shorts',
  sub_bermudas:'Bermudas', sub_leggings:'Leggings',
  sub_blazers:'Blazers', sub_suits:'Suits', sub_bombers:'Bombers',
  sub_puffers:'Puffers', sub_trenches:'Trench coats', sub_windbreaker:'Windbreakers',
  sub_raincoat:'Raincoats', sub_ski_jacket:'Ski jackets', sub_leather:'Leather',
  sub_cardigans:'Cardigans', sub_peacoats:'Peacoats', sub_parkas:'Parkas',
  sub_overcoats:'Overcoats', sub_duffle:'Duffle coats',
  sub_sneakers:'Sneakers', sub_heels:'Heels', sub_ankle_boots:'Ankle boots',
  sub_boots:'Boots', sub_sandals:'Sandals', sub_loafers:'Loafers', sub_flats:'Flats',
  sub_chelsea:'Chelsea boots', sub_derbies:'Derbies',
  sub_short_dress:'Short', sub_midi_dress:'Midi', sub_long_dress:'Long',
  sub_shirt_dress:'Shirt dress', sub_sleeveless:'Sleeveless', sub_aline:'A-line',
  sub_handbag:'Handbag', sub_crossbody:'Crossbody', sub_backpack:'Backpack',
  sub_tote:'Tote', sub_clutch:'Clutch', sub_belt_bag:'Belt bag',
  sub_rings:'Rings', sub_necklaces:'Necklaces', sub_earrings:'Earrings',
  sub_bracelets:'Bracelets', sub_pendants:'Pendants',
  sub_watches:'Watches', sub_belts:'Belts', sub_caps:'Caps',
  sub_hats:'Hats', sub_scarves:'Scarves', sub_glasses:'Sunglasses',
  // ═══ ProfileScreen — i18n complet (reminders, cashback, subscription, mannequin, about) ═══
  daily_reminder_outfit:'Daily Outfit reminder ({time})',
  available_for_withdrawal:'Available for withdrawal',
  pending_caps:'PENDING',
  validated_caps:'VALIDATED',
  withdrawn_caps:'WITHDRAWN',
  paid_caps:'PAID',
  cancelled_caps:'CANCELLED',
  min_to_withdraw:'Minimum €{amount} to withdraw',
  recent_orders:'RECENT ORDERS ({count})',
  validated:'Validated',
  pending:'Pending',
  paid:'Paid',
  cancelled:'Cancelled',
  clicks:'Clicks',
  clicks_caps:'CLICKS',
  purchases_caps:'PURCHASES',
  partner_products:'partner products',
  confirmed_orders:'confirmed orders',
  accumulated_cashback:'ACCUMULATED CREDITS',
  withdraw_via_paypal:'💳 WITHDRAW VIA PAYPAL',
  withdrawal_of:'Withdraw €{amount} via PayPal',
  paypal_email_prompt:'Enter your PayPal email to receive the payment (3-5 business days):',
  paypal_email_label:'PayPal email',
  confirm_withdrawal:'CONFIRM WITHDRAWAL',
  cashback_rate_info:'💡 Your current Mytenue Credit rate is {rate} (tier {tier}). Upgrade to Gold to earn {goldRate} credit.',
  sign_in_to_view_earnings:'Sign in to view your earnings',
  cashback_label:'Crédit Mytenue',
  paypal_email_required:'PayPal email required',
  paypal_email_required_msg:'Enter a valid PayPal email to receive your earnings.',
  amount_insufficient:'Insufficient amount',
  amount_insufficient_msg:'You need at least €{min} available to withdraw. Currently: €{available}.',
  request_sent:'✓ Request sent',
  withdrawal_request_sent:'Your withdrawal request of €{amount} has been recorded. You will receive the payment within 3-5 business days.',
  request_failed:'Request unavailable for now.',
  monthly_price:'Monthly — €{price}/month',
  yearly_price:'Yearly — €{price}/month',
  yearly:'Yearly',
  monthly:'Monthly',
  renewal_on:'🔄 Renewal on {date}',
  renewal_on_with_time:'🔄 Renewal on {date} at {time} (in {days} d)',
  renewal_in_min:'🔄 Renewal in {min} min',
  renewal_in_hours:'🔄 Renewal in {hours} (at {time})',
  renewal_tomorrow:'🔄 Renewal tomorrow at {time}',
  expired_on:'⚠️ Expired on {date} — choose an active plan',
  cancelled_expires_on:'⚠️ Cancelled · Expires on {date}',
  expired_caps:'⚠️  EXPIRED',
  usage_today:'Usage today',
  feature_unlimited_wardrobe:'Unlimited wardrobe',
  feature_wardrobe_items:'Wardrobe: {count} items',
  feature_unlimited_ai:'Unlimited AI analyses',
  feature_ai_per_day:'{count} AI analyses / day',
  feature_unlimited_looks:'Unlimited looks',
  feature_looks_per_day:'{count} looks / day',
  feature_unlimited_tryons:'Unlimited try-ons',
  feature_tryon_per_week:'{count} try-on / week',
  feature_tryons_per_month:'{count} try-ons / month',
  feature_unlimited_travel:'Unlimited travel',
  feature_travel_count:'{count} trips',
  feature_cashback_percent:'{percent}% Mytenue Credits on purchases',
  feature_vip_support:'VIP support & early access',
  usage_label_wardrobe:'Wardrobe',
  usage_label_ai:'AI analyses',
  usage_label_looks:'Looks generated',
  usage_label_tryons:'Try-ons',
  usage_unit_pieces:'items',
  usage_unit_per_day:'/ d',
  usage_unit_looks:'looks',
  usage_unit_per_month:'/ month',
  usage_unit_per_week:'/ week',
  switch_to_yearly:'Switch to yearly',
  switch_to_yearly_sub:'€{yearly}/year billed · i.e. €{price}/mo',
  switch_to_monthly:'Switch to monthly',
  switch_to_monthly_sub:'€{price}/month · no annual commitment',
  change_plan:'＋ Change plan',
  change_plan_sub:'See Basic, Premium and Gold',
  resubscribe:'🔄 Resubscribe',
  resubscribe_sub:'Reactivate Basic, Premium or Gold',
  cancel_subscription:'Cancel subscription',
  manage_subscription:'Manage my subscription',
  subscription_cancelled_access_until:'Subscription cancelled — access until expiration',
  no_engagement:'No commitment · Cancel anytime',
  free_plan_no_payment:'Free plan',
  no_payment_required:'No payment required for the free plan.',
  payment_unavailable:'Payment unavailable',
  payment_success_title:'Payment successful',
  payment_success_body:'Your subscription is active. Welcome!',
  payment_cancelled_title:'Payment cancelled',
  payment_cancelled_body:'No amount was charged. You can try again anytime.',
  current_plan_label:'Current plan',
  already_on_plan:'You are already on this plan.',
  change_formula_q:'Change plan?',
  change_formula_msg:'You are currently on {oldPlan}.\n\nBy switching to {newPlan}, your current subscription will be automatically replaced. {prorataMsg}\n\nYou will never be billed for two subscriptions at the same time.',
  prorata_apple:'Apple will apply a prorated charge for the difference.',
  prorata_google:'Google Play will apply a prorated charge for the difference.',
  continue:'Continue',
  purchase_unavailable:'Purchases unavailable',
  purchase_unavailable_msg:'In-app purchases are not yet configured on this platform. Please try again later.',
  purchase_failed:'Purchase failed',
  purchase_failed_msg:'The payment could not be completed. Please try again later or contact support.',
  unsubscribe_title:'Cancel subscription',
  unsubscribe_msg:'Your Premium subscription will remain active until {date}.\n\nAfter that date, your account will automatically switch to the free plan.\n\nYou can reactivate your subscription at any time before expiration.',
  end_of_period:'the end of the current period',
  subscription_cancelled_title:'Subscription cancelled',
  subscription_cancelled_msg:'Your Premium access remains active until {date}.\n\nNo further charges will be made.',
  cancel_failed_endpoint:'The unsubscribe service is temporarily unavailable. A server-side update is in progress. Please try again in a few minutes or contact support.',
  cancel_failed_unauthorized:'Your session has expired. Please sign in again and try once more.',
  cancel_failed_network:'No internet connection. Please check your network and try again.',
  cancel_failed_server:'Server error. Please try again shortly.\n\n({err})',
  cancel_failed_default:'Could not cancel the subscription.\n\n{err}',
  cancel_failed_default_no_err:'Please try again shortly or contact support.',
  unexpected_error:'Unexpected error',
  next_renewal_on:'\n\nNext renewal: {date}',
  plan_modified:'Plan updated',
  plan_change_yearly:'Switched to yearly — €{price}/month',
  plan_change_monthly:'Switched to monthly — €{price}/month',
  cannot_modify_plan:'Could not modify the plan.',
  current_plan_btn:'Current plan',
  switch_to_yearly_btn:'Switch to yearly',
  switch_to_monthly_btn:'Switch to monthly',
  choose:'Choose',
  active_caps:'✓ ACTIVE',
  popular:'Popular',
  per_month:'€/month',
  per_year:'€{amount}/year',
  test_mode_back_to_free:'[TEST MODE] Switch back to Free?',
  test_mode_back_to_free_msg:'This action is only for testing. You will become free instantly.',
  test_back_to_free:'[Test] Back to Free',
  expired_subscription_title:'Subscription expired',
  expired_subscription_with_label:'Your {plan} subscription{dateMsg}.',
  expired_subscription_no_label:'Your subscription{dateMsg}.',
  ended_on:' ended on {date}',
  has_expired:' has expired',
  expired_subscription_desc:'You are currently on the free plan. Choose a plan below to reactivate the premium features.',
  renew_subscription:'Renew my subscription',
  limit_reached:'Limit reached. {when} or upgrade to a higher plan.',
  reset_tomorrow:'Resets tomorrow at 00:00',
  tryon_subscribers_only:'Virtual try-on on a mannequin is reserved for subscribers (Basic, Premium or Gold). Choose a plan to use it.',
  premium_caps:'✨ PREMIUM',
  subscribers_caps:'✨ SUBSCRIBERS',
  my_mannequin_caps:'MY MANNEQUIN',
  your_personal_photo:'Your personal photo',
  mannequin_usage_explanation:'Used to generate try-ons that look like you.',
  delete_personal_photo:'Delete my personal photo',
  delete_photo_q:'Delete my photo?',
  delete_photo_msg:'Your photo will no longer be used for virtual try-ons and will be erased from our servers.\n\n⚠️ Limit: 1 personal photo / 7 days. If you uploaded your photo recently, you will need to wait until the end of the 7-day window to create a new one.',
  photo_deleted:'Photo deleted',
  item_removed_success:'Item removed from your wardrobe',
  photo_deleted_msg:'Your personal photo has been deleted.',
  delete_failed:'Failed: {err}',
  about_caps:'ABOUT',
  export_my_data:'Export my data (GDPR)',
  cookie_preferences:'Cookie preferences',
  cookies:'Cookies',
  cookies_banner_next_load:'The cookie banner will be shown on next load.',
  export_loading_title:'Exporting…',
  export_loading_msg:'Downloading your personal data.',
  export_ready:'Export ready',
  export_ready_msg:'Downloaded: {wardrobe} items, {looks} looks, {tryons} try-ons.',
  export_failed:'Export failed: {err}',
  export_session_required:'Sign-in required',
  export_session_required_msg:'Please sign in again to export your data.',
  export_share_title:'MyTenue export',
  developed_with:'Developed with ❤️',
  member_since_count:'Member since {date}',
  member_since_with_logins:'Member since {date} · {count} sign-ins',
  complete_profile_caps:'⚠️ COMPLETE PROFILE',
  apple_badge:' APPLE',
  google_badge:'G GOOGLE',
  badge_man:'♂ MEN',
  badge_woman:'♀ WOMEN',
  badge_all_genders:'◎ ALL',
  diversity:'Diversity',
  ai_analyzed_count:'🤖 Analyzed by AI · {analyzed}/{total} items',
  edit_profile_sub:'Identity, body shape, sizes…',
  preferences_sub:'Style, occasion, budget',
  admin_dashboard:'Admin Dashboard',
  admin_dashboard_sub:'Stats, withdrawals & users',
  language_label:'Language',
  saving_request:'Request sent',
  permission_required_reminders:'Enable notifications in your system settings to receive daily reminders.',
  delete_action:'Delete',
  // Profile — month abbreviations EN
  month_jan_short:'Jan',
  month_feb_short:'Feb',
  month_mar_short:'Mar',
  month_apr_short:'Apr',
  month_may_short:'May',
  month_jun_short:'Jun',
  month_jul_short:'Jul',
  month_aug_short:'Aug',
  month_sep_short:'Sep',
  month_oct_short:'Oct',
  month_nov_short:'Nov',
  month_dec_short:'Dec',

  // Profile — Cashback section
  cashback_accumulated:'CREDITS EARNED',
  available_for_withdrawal:'Available to withdraw',
  pending_caps:'⏳ PENDING',
  validated_caps:'✓ VALIDATED',
  withdrawn_caps:'💸 WITHDRAWN',
  min_to_withdraw:'Minimum €{amount} to withdraw',
  recent_orders_caps:'RECENT ORDERS',
  validated:'✓ Validated',
  pending:'⏳ Pending',
  clicks_caps:'CLICKS',
  purchases_caps:'PURCHASES',
  partner_products:'partner products',
  confirmed_orders:'confirmed orders',
  login_to_see_earnings:'Sign in to view your earnings',

  // Profile — Subscription section
  monthly_price:'Monthly — €{price}/month',
  yearly_price:'Yearly — €{price}/month',
  renewal_on:'🔄 Renews on {date}',
  usage_today:'Today\'s usage',
  feat_unlimited_wardrobe:'Unlimited wardrobe',
  feat_unlimited_ai:'Unlimited AI analyses',
  feat_unlimited_looks:'Unlimited looks',
  feat_unlimited_tryons:'Unlimited try-ons',
  feat_tryons_per_month:'{count} try-ons / month',
  feat_tryons_per_week:'{count} try-on / week',
  feat_unlimited_travel:'Unlimited travel',
  feat_trips_count:'{count} trips',
  feat_cashback_percent:'{percent}% Mytenue Credits on purchases',
  feat_vip_support:'VIP support & early access',
  feat_wardrobe_count:'Wardrobe: {count} items',
  feat_ai_per_day:'{count} AI analyses / day',
  feat_looks_per_day:'{count} looks / day',
  usage_wardrobe:'Wardrobe',
  usage_ai:'AI analyses',
  usage_looks_gen:'Looks generated',
  usage_tryons:'Try-ons + Flat-lay',
  usage_unit_pieces:'items',
  usage_unit_per_day:'/ day',
  usage_unit_looks:'looks',
  usage_unit_per_month:'/ month',
  usage_unit_per_week:'/ week',

  // Profile — Mannequin section
  my_mannequin_caps:'MY MANNEQUIN',
  your_personal_photo:'Your personal photo',
  mannequin_explanation:'Used to generate try-ons that look like you.',
  delete_personal_photo:'Delete my personal photo',

  // Profile — About section
  about_caps:'ABOUT',
  export_my_data:'Export my data (GDPR)',
  cookie_preferences:'Cookie preferences',
  developed_with:'Crafted with ❤️',

  // Profile — Daily reminder
  daily_reminder_at:'📅  Daily Outfit reminder ({time})',

  // v1.12.274 — Phase B i18n : LooksScreen MyTenue
  stylist_selection_caps:'AI STYLIST SELECTION',
  your_looks:'Your looks',
  ai_looks_from_wardrobe:'AI-curated looks composed from your wardrobe',
  style_elegant:'Elegant',
  style_casual:'Casual',
  style_minimal:'Minimal',
  style_boho:'Boho',
  style_evening:'Evening',
  style_sport:'Sport',
  style_office:'Office',
  style_chic:'Chic',
  view_n_accessories:'View {count} accessories & jewellery',
  hide_accessories_jewels:'Hide accessories & jewellery',
  score_exceptional:'Exceptional',
  score_excellent:'Excellent',
  score_good:'Refined',
  score_decent:'Decent',
  score_to_improve:'To refine',
  outfit_n_pieces:'{count}-piece outfit',
  ai_analyzed_status:'AI · {done}/{total} analysed',

  // v1.12.274 — Phase B i18n : FavoritesScreen MyTenue
  favorites_caps:'✨ FAVORITES',
  my_favorites_subtitle:'Editor\'s picks',
  articles_label:'Items', brands_label:'Brands', value_label:'Value',
  no_favorites_title:'No favorites yet',
  no_favorites_desc:'Add items to your favorites by tapping the heart on each product.',
  explore_catalog_btn:'Explore the catalog',
  remove_from_favorites_q:'Remove from favorites?',
  remove_btn:'Remove',

  // v1.12.275 — Phase B i18n : ProfileScreen MyTenue (subscription / gender / renewal)
  status_paid:'💸 Paid',
  status_cancelled:'✕ Cancelled',
  portal_unavailable:'Portal unavailable',
  stripe_error:'Stripe error',
  reconnect_to_export:'Sign in again to export your data.',
  export_in_progress:'Export in progress…',
  downloading_personal_data:'Downloading your personal data.',
  export_downloaded_summary:'Downloaded: {items} items, {looks} looks, {tryons} try-ons.',

  // v1.12.276 — Phase B i18n : CalendarScreen MyTenue
  filter_looks_by_items_tooltip:'Filter looks by specific items from your wardrobe',
  my_calendar_title:'📅 My calendar',
  my_calendar_short:'My calendar',
  login_required:'Sign in required',
  calendar_login_desc:'Sign in to your MyTenue account to track your daily outfits and keep a history of your looks.',
  sign_in_caps:'SIGN IN',
  month_progress_one:'{percent}% of the month ({count} outfit)',
  month_progress_other:'{percent}% of the month ({count} outfits)',
  tier_history_limit:'{tier} plan: history limited to {days} days',
  calendar_help_tap_day:'✨ Tap a day to view your outfit or add a new one.',
  // Weekday letters (Mon → Sun)
  wd_mon:'M', wd_tue:'T', wd_wed:'W', wd_thu:'T', wd_fri:'F', wd_sat:'S', wd_sun:'S',
  // First-time onboarding banner
  first_time_here:'💡 First time here?',
  calendar_onboarding_desc:'Add the looks you love to your outfit calendar to track what you wear each day and receive personalized stats.',
  calendar_benefit_avoid_repetitions:'✓ Avoid unintentional repetitions',
  calendar_benefit_personal_stats:'✓ Personalized stats on your preferences',
  calendar_benefit_history_inspiration:'✓ Inspiration from your history',
  calendar_benefit_weather_sync:'✓ Synced with the weather',
  understood_cta:'Got it',
  // Stats panel
  stats_for_month:'{month} stats',
  stats_for_month_default:'Monthly stats',
  days_tracked_total:'{tracked}/{total} days · {percent}%',
  days_tracked_label:'Days tracked',
  average_rating:'Average rating',
  top_occasion_label:'Top occasion',
  favorite_occasions:'Favorite occasions',
  most_worn_pieces:'Most worn pieces',
  days_tracked_this_month:'📊 {count} days tracked this month',
  outfit_percentage_for_occasion:'✨ {percent}% of your outfits are for {occasion}',
  // Teaser free tier
  stats_of_month:'Monthly stats',
  stats_teaser_upgrade:'Upgrade to Basic to view your stats: days tracked, favorite occasions, most worn pieces.',

  // v1.12.277 — Phase B i18n : CompleteProfileScreen MyTenue
  edit_profile_title:'Edit my profile',
  personalization_caps:'✨ PERSONALIZATION',
  your_information:'Your information',
  info_helps_personalization:'This information lets us personalize your suggestions and recommend the right catalog.',
  first_name:'First name',
  last_name:'Last name',
  gender:'Gender',
  date_of_birth:'Date of birth',
  age_adapts_styles:'We tailor cuts, styles, and trends to your age range.',
  morphology:'Body shape',
  morphology_explanation:'To adapt cuts and sizes to your body shape.',
  height_cm:'Height (cm)',
  weight_kg:'Weight (kg)',
  silhouette:'Silhouette',
  // Silhouettes — women
  silhouette_hourglass:'Hourglass',
  silhouette_inverted_triangle:'Inverted triangle',
  silhouette_triangle:'Triangle',
  silhouette_rectangle:'Rectangle',
  silhouette_round:'Round',
  silhouette_apple:'Apple',
  silhouette_pear:'Pear',
  // Silhouettes — men
  silhouette_v:'V-shape (athletic)',
  silhouette_rectangle_m:'Rectangle',
  silhouette_inverted_triangle_m:'Inverted triangle',
  silhouette_trapezoidal:'Trapezoidal',
  silhouette_oval:'Oval',
  // Silhouette hints (descriptions under each silhouette)
  sil_hint_hourglass:'Shoulders ≈ hips, defined waist',
  sil_hint_pear:'Hips wider than shoulders',
  sil_hint_rectangle:'Few curves, soft waistline',
  sil_hint_apple:'Generous torso, slim legs',
  sil_hint_inverted_triangle:'Shoulders wider than hips',
  sil_hint_slim_m:'Slender build, few visible muscles',
  sil_hint_athletic_m:'Defined build, visible musculature',
  sil_hint_average_m:'Average build, classic proportions',
  sil_hint_broad_m:'Broad build, strong frame',
  sil_hint_full_m:'Prominent torso, defined belly',
  // Sizes
  clothing_sizes:'Clothing sizes',
  sizes_prefilled_from_morphology:'Pre-filled from your body shape. Adjust if needed.',
  tops_label_with_examples:'Tops (t-shirt, shirt, sweater...)',
  bottoms_label_with_examples_eu:'Bottoms (pants, jeans...) • EU size',
  jacket_coat_label:'Jacket / coat',
  shoes_eu_label:'Shoes (EU)',
  no_changes:'No changes',
  fix_errors:'Fix errors',

  // v1.12.278 — Phase B i18n : OnboardingScreen MyTenue
  skip:'Skip',
  step_x_of_y:'Step {current} of {total}',
  onboarding_welcome:'Welcome to Mytenue',
  onboarding_intro_desc:'Let’s get to know you so we can offer the very best of style.',
  onboarding_recap_title:'✓ Your identity details',
  onboarding_recap_hint:'All set! Tap Next to continue.',
  gender_other:'Other',
  first_name_placeholder:'Your first name',
  last_name_placeholder:'Your last name',
  email_label:'Email',
  apple_relay_email_hint:'Apple has hidden your email. Enter the one you want to use. A verification code will be sent to that address.',
  email_placeholder:'you@example.com',
  email_verified:'✓ Email verified',
  send_verification_code:'Send verification code',
  sending_code:'Sending code…',
  six_digit_code_received:'6-digit code received by email:',
  verify:'Verify',
  resend:'Resend',
  invalid_email_format:'Invalid email format',
  too_many_requests_retry_in:'Too many requests. Try again in {seconds}s.',
  apple_relay_blocked:'This Apple email is hidden. Please use a real email.',
  error_status:'Error {status}',
  network_error_short:'Network error',
  code_must_be_6_digits:'The code must be 6 digits',
  incorrect_code_attempts_left:'Incorrect code. {count} attempt(s) left.',
  code_expired_request_new:'Code expired. Please request a new code.',
  too_many_attempts_request_new:'Too many attempts. Please request a new code.',
  email_changed_resend_code:'Email changed since the code was sent. Please resend the code.',
  your_date_of_birth:'Your date of birth',
  select_birth_date:'Select your date of birth',
  date_format_placeholder:'YYYY-MM-DD',
  minimum_age_required:'You must be at least 15 years old to use Mytenue (16 in the EU outside France).',
  minimum_age_gdpr_hint:'Minimum age required: 15 years (GDPR-compliant).',
  validate:'Confirm',
  your_morphology:'Your body shape',
  your_sizes:'Your sizes',
  finish:'Finish',
  skip_onboarding_title:'Skip onboarding?',
  skip_onboarding_msg:'You can complete your profile later from the Profile screen. Some features (size suggestions, personalized looks) will be limited until your profile is complete.',
  continue_form:'Continue the form',
  skip_for_now:'Skip for now',
  cannot_save_profile:'Unable to save.',
  unknown_error:'unknown',

  // v1.12.279 — Phase B i18n : Style chips étendus (LooksScreen)
  style_urban:'Urban', style_romantic:'Romantic', style_vintage:'Vintage', style_edgy:'Edgy', style_preppy:'Preppy',
  style_feminine:'Feminine', style_structured:'Structured', style_date:'Date', style_brunch:'Brunch',
  style_travel:'Travel', style_beach:'Beach', style_ceremony:'Ceremony', style_weekend:'Weekend',
  // v1.12.279 — Phase B i18n : TryOnModal MyTenue
  tryon_choose_pieces:'Choose items',
  tryon_create_my_mannequin:'Create my model',
  tryon_upload_in_progress:'Upload in progress',
  tryon_choose_mannequin:'Choose a model',
  tryon_generating_in_progress:'Generating',
  tryon_result:'Result',
  tryon_quota_reached:'Quota reached',
  tryon_attempts_this_month:'{used}/{limit} try-ons this month',
  tryon_max_reached_title:'Maximum reached',
  tryon_max_reached_msg:'You can try {max} items max at once. Uncheck one first.',
  tryon_no_piece_title:'No item',
  tryon_no_piece_msg:'Select at least 1 item for the try-on.',
  tryon_no_piece_selected:'No item selected',
  tryon_generic_error:'Try-on error',
  tryon_check_pieces_intro:'Check the items you want to try on the model',
  tryon_max_suffix:'{max} max',
  tryon_no_wearable_in_outfit:'No try-able item in this outfit.',
  tryon_no_wearable_hint:'Virtual try-on requires clothing (dresses, tops, bottoms, jackets, shoes).',
  not_tryable_label:'Not try-able:',
  tryon_choose_mannequin_intro:'Choose a model to visualize this outfit. Generation takes 15-30 seconds.',
  continue_btn:'Continue',
  my_mannequin:'My model',
  your_silhouette:'Your silhouette',
  personal_mannequin_action_msg:'What would you like to do with your personal photo?',
  failed_label:'Failed',
  upload_failed_label:'Upload failed',
  consent_required_title:'Consent required',
  consent_required_msg:'Check the box to authorize storing your photo.',
  permission_camera_required:'Allow camera access in Settings.',
  permission_gallery_required:'Allow gallery access in Settings.',
  share_outfit_message:'Check out this outfit on Outfit!',
  create_personal_mannequin_title:'Create your personal model',
  create_personal_mannequin_desc:'For try-ons that truly look like you (silhouette, height, face), take a full-body photo — facing the camera, light background, fitted clothes.',
  photo_tips_title:'Tips for a good photo',
  photo_tip_full_body:'Take a full-body photo (head to toe)',
  photo_tip_stand_straight:'Stand straight, arms along your body',
  photo_tip_plain_bg:'Use a plain, well-lit background',
  photo_tip_fitted_clothes:'Wear fitted clothes (avoid loose ones)',
  photo_tip_one_person:'Only one person in the photo',
  photo_storage_consent:'I agree that my photo is sent to our AI provider Google (Vertex AI), processed to generate my virtual try-ons, and stored encrypted on our servers (EU). I can delete it at any time from my profile.',
  take_a_photo:'Take a photo',
  choose_from_gallery:'Choose from gallery',
  continue_without_my_photo:'Continue without my photo (standard model)',
  uploading_your_photo:'Uploading your photo...',
  secured_and_encrypted:'Secured and encrypted. A few seconds…',
  mannequin_default:'Default model',
  mannequin_slim:'Slim',
  mannequin_athletic:'Athletic',
  mannequin_curvy:'Curvy',
  mannequin_tall:'Tall',
  mannequin_petite:'Petite',
  mannequin_plus_size:'Plus size',
  hair_blonde:'blonde',
  hair_brunette:'brunette',
  loading_stage_pending:'Preparing...',
  loading_stage_created:'Starting generation...',
  loading_stage_processing:'Generating...',
  loading_stage_completed:'Finalizing...',
  tryon_ai_dressing:'Our AI is dressing your model with {count} item(s).',
  tryon_wait_polling:'Please wait 15-60 seconds.',
  generated_by:'Generated by {provider}',
  outfit_items_label:'Items in this outfit',
  other_mannequin:'Other model',
  modify_pieces:'Modify items',
  your_plan:'your plan',
  quota_gold_reached:'Gold quota reached',
  quota_used_all:'You have used all {limit} of your try-ons.',
  quota_tier_reached:'{tier} quota reached',
  quota_used_this_month_upgrade:'You have used your {limit} try-ons this month.\n\nUpgrade to {nextTier} for more try-ons right away.',
  upgrade_to:'Upgrade to {tier}',
  quota_weekly_reached:'Weekly quota reached',
  quota_used_weekly_subscribe:'You used your weekly try-on.\n\nSubscribe to unlock more.',
  see_subscriptions:'See subscriptions',
  tryons_used:'Try-ons used',
  renewal_label:'Renewal: {date}',
  item_fallback:'Item',
  start_try_on:'Start try-on',
  generate:'Generate',
  // v1.12.280 — Phase B i18n : DailyPreferencesModal MyTenue
  daily_prefs_today_badge:'✨ TODAY',
  daily_prefs_hero_title:'How do you want to dress?',
  daily_prefs_hero_sub:'A few seconds to personalize your suggestions for today.',
  daily_prefs_q_style:'Which style?',
  daily_prefs_q_occasion:'For which occasion?',
  daily_prefs_q_budget:'Max budget per piece?',
  daily_prefs_q_categories:'What are you looking for?',
  daily_prefs_max_2:'(max 2)',
  daily_prefs_budget_hint:'Limit applied to each item individually',
  daily_prefs_cta:'SEE MY RECOMMENDATIONS',
  daily_prefs_footer:'Your preferences are saved for the duration of your session.',
  daily_prefs_title:'My preferences',
  daily_prefs_subtitle:'Customize your outfit of the day',
  preferred_style:'Preferred style',
  preferred_colors:'Preferred colors',
  preferred_brands:'Preferred brands',
  mood:'Mood',
  climate:'Climate',
  reset:'Reset',
  apply:'Apply',
  budget_under_50:'< €50',
  budget_under_150:'< €150',
  budget_under_500:'< €500',
  budget_over_500:'> €500',
  budget_no_limit:'No limit',
  budget_per_piece:'per piece',
  budget_unlimited:'Unlimited',
  occ_vacation:'Vacation',
  occ_daily:'Everyday',
  occ_cocktail:'Cocktail',
  occ_wedding:'Wedding',
  style_streetwear:'Streetwear',
  // v1.12.281 — Phase B i18n : Travel MyTenue
  travel_required_fields_title:'Required fields',
  travel_required_fields_msg:'Trip name and destination are required',
  travel_delete_trip_title:'Delete trip',
  travel_delete_trip_msg:'Delete "{name}"? Packed items will be removed from this trip. Your wardrobe stays intact.',
  travel_premium_badge:'✈️ TRAVEL',
  travel_premium_feature_title:'Premium feature',
  travel_premium_exclusive:'✨ PREMIUM EXCLUSIVE',
  travel_premium_hero_title:'Plan your trips with AI',
  travel_premium_hero_desc_p1:'The Travel module is included with',
  travel_premium_hero_desc_p2:'Build your suitcase and generate looks tailored to your destination and weather.',
  travel_premium_feat_1:'Smart suitcase organization',
  travel_premium_feat_2:'Looks tailored to local weather',
  travel_premium_feat_3:'Items to shop suggestions',
  travel_premium_feat_4:'Unlimited look variations',
  travel_premium_cta:'SEE SUBSCRIPTIONS',
  travel_premium_pricing:'From €5.99/month · cancel anytime',
  // v1.12.268 — Trip styles + weather profiles
  trip_style_beach:'Beach', trip_style_city:'City break', trip_style_mountain:'Mountain', trip_style_business:'Business trip', trip_style_wedding:'Wedding / Gala', trip_style_backpacker:'Backpacker', trip_style_luxury:'Luxury / Resort', trip_style_safari:'Safari / Nature',
  weather_hot_dry:'Hot and dry', weather_hot_humid:'Hot and humid', weather_temperate:'Temperate', weather_cold:'Cold', weather_very_cold:'Very cold', weather_rainy:'Rainy', weather_tropical:'Tropical',
  travel_topbar_badge:'✈️ MY TRIPS',
  travel_wardrobe_title:'Travel wardrobe',
  travel_hero_title:'Your travel stylist',
  travel_hero_sub:'Build a virtual suitcase for your destination and get looks personalized by AI',
  travel_stats_trips:'Trips',
  travel_stats_items:'Items',
  travel_stats_ready:'Ready',
  travel_no_trips_yet:'No trips yet',
  travel_destinations_count:'{n} destination{s}',
  travel_first_trip_title:'First trip?',
  travel_first_trip_desc:'Create your first trip and let Claude help you pack the perfect suitcase.',
  travel_first_trip_cta:'＋ Create a trip',
  travel_new_trip_card_sub:'Get ready for your next destination',
  travel_pieces_short:'pieces',
  travel_connection_required:'Sign-in required',
  travel_connection_required_msg:'Please sign in to use virtual try-on.',
  travel_ai_limit_reached:'AI limit reached ({current}/{limit} today). Come back tomorrow or upgrade to {nextTier}.',
  travel_ai_no_tips:'No tips returned',
  travel_ai_cooldown:'Wait {min} minute{s} before launching another generation.',
  travel_ai_not_connected:'Not connected. Please sign in again to use AI.',
  travel_ai_session_expired:'Session expired. Please sign in again to continue.',
  travel_ai_error:'Could not fetch AI tips. Check your connection and try again.',
  travel_max_packed_title:'Suitcase limit reached ({max})',
  travel_max_packed_some:'You can still add {n} item{s}. Upgrade to Premium to extend the limit.',
  travel_max_packed_full:'Your suitcase is full. Upgrade to Premium or Gold to add more items.',
  travel_weather_range:'Between {min}°C and {max}°C',
  travel_hub_badge_bag:'🧳 MY SUITCASE',
  travel_hub_badge_looks:'✈️ TRAVEL LOOKS',
  travel_hub_your_items:'Your items',
  travel_hub_your_outfits:'Your outfits',
  travel_hub_packed_summary:'{n} item{s} packed · {dest}',
  travel_hub_packed_summary_max:'{n}/{max} item{s} packed · {dest}',
  travel_hub_select_what:'Pick what you take with you',
  travel_add:'Add',
  travel_empty_bag_title:'Empty suitcase',
  travel_empty_bag_desc:'Tap + to add clothes from your wardrobe. At least 3 items needed to generate looks.',
  travel_empty_bag_cta:'＋ Add from wardrobe',
  travel_missing_in_bag:'🧳 Missing from your suitcase:',
  travel_searching_items:'Searching items...',
  travel_cat_for_trip:'{cat} for this trip ({n}{plus})',
  travel_view_more:'View\nmore',
  travel_view_details:'See details ↗',
  travel_trending_items:'🛍️ Trending items for this trip',
  travel_looks_count_summary:'{n} look{s} generated from {p} item{ps}',
  travel_generation_in_progress:'Generating…',
  travel_add_more_items:'Add {n} more item{s} to generate looks',
  travel_add_clothes_to_bag:'Add clothes to your suitcase',
  travel_regen_a11y:'Regenerate looks',
  travel_avg_score:'Avg. score',
  travel_go_to_bag:'Go to suitcase →',
  travel_generating_looks:'Generating looks…',
  travel_add_more_for_variety:'Add {n} more item{s} to generate varied looks.',
  travel_minimum_combo_hint:'For successful combos, your suitcase needs at least one Top + Bottom (or Dress) + Shoes.\n\nOtherwise tap ↻ to retry.',
  travel_relaunch_generation:'↻  Restart generation',
  travel_looks_with_bag:'Looks with your suitcase',
  travel_outfits_count:'{n} outfit{s}',
  travel_outfits_with_label:' · {label}',
  travel_outfits_all_owned:' · 100% with your packed items',
  travel_filter_all:'All',
  travel_no_outfits_for_filter:'No {label} outfit was generated with your suitcase.',
  travel_more_items_hint:'Add more clothes to your suitcase for more suggestions.',
  travel_looks_to_shop:'Looks to shop',
  travel_looks_to_shop_sub:'Complete your suitcase for this trip',
  travel_catalog_compatible_title:'Travel catalog (matches your trip)',
  travel_catalog_compatible_sub:'{n} items · {temp}°C · {style}',
  travel_essentials_dest:'Essentials {dest}',
  travel_articles_to_shop:'items to shop to complete your suitcase',
  travel_cart_label:'CART',
  travel_discover_articles:'Discover the {n} items to shop',
  travel_checklist_badge:'🧳 TRAVEL CHECKLIST',
  travel_checklist_progress:'{checked} / {total} ready',
  travel_checklist_done:'✨ Everything is ready for departure!',
  travel_checklist_almost:'Almost there! A few items to go.',
  travel_checklist_more:'Still some things to prep.',
  travel_weather_forecast_badge:'WEATHER FORECAST · {dest}',
  travel_over_n_days:'Over {n} day{s}',
  travel_missing_in_suitcase:'Missing from suitcase',
  travel_missing_for_days:'For {n} day{s}, you\'re missing:',
  travel_see_shopping_suggestions:'See shopping suggestions →',
  travel_rule_for_days:'📏 Rule for {n} day{s}',
  travel_rule_tops:'tops',
  travel_rule_bottoms:'bottoms',
  travel_rule_pairs:'pairs',
  travel_rule_footer:'+ 1 versatile jacket · 1 signature accessory',
  travel_ai_tips_badge:'✨ AI TIPS',
  travel_ai_tips_title:'Personalized advice',
  travel_ai_tips_sub:'Claude analyzes your trip and gives you tips',
  travel_ai_tips_refresh:'↻ Refresh',
  travel_ai_tips_generate_btn:'Generate',
  travel_ai_tips_cooldown_short:'⏱ {min} min',
  travel_ai_tips_empty:'Tap "Generate" to get 6 smart tips on your suitcase, deals and local hints.',
  travel_my_dressing:'My wardrobe',
  travel_n_selected:'{n} item{s} selected',
  travel_add_n:'Add',
  travel_dressing_empty:'Empty wardrobe',
  travel_dressing_empty_desc:'Add clothes to your wardrobe to take them on your trip',
  travel_dressing_limited_badge:'🔒 LIMITED WARDROBE',
  travel_dressing_limited_msg:'Your wardrobe holds {total} items, capped at {max} on your subscription.',
  travel_upgrade_short:'Upgrade',
  travel_search_placeholder:'Search (name, alias)…',
  travel_n_articles:'{n} item{s}',
  travel_deselect_all:'Deselect all',
  travel_select_all:'Select all',
  travel_add_n_to_bag:'Add {n} item{s} to suitcase',
  travel_form_badge_edit:'✎ EDIT TRIP',
  travel_form_badge_new:'✨ NEW TRIP',
  travel_form_title_edit:'Edit details',
  travel_form_title_new:'Pack your suitcase',
  travel_form_step_name:'Trip name',
  travel_form_name_placeholder:'E.g. Summer in Bali, Weekend in New York...',
  travel_form_step_destination:'Destination',
  travel_form_dest_placeholder:'Search a city or country...',
  travel_form_step_dates:'Trip dates',
  travel_form_label_departure:'DEPARTURE',
  travel_form_label_return:'RETURN',
  travel_form_pick_date:'Pick a date',
  travel_form_n_days:'{n} day{s}',
  travel_form_duration:'Stay duration',
  travel_form_calculating:'Computing...',
  travel_form_estimated_temp:'Estimated temperature',
  travel_form_step_styles:'Trip style(s)',
  travel_form_step_styles_sub:'Pick one or more styles (e.g. beach + city break)',
  travel_form_save:'Save',
  travel_form_create:'Create trip',
  travel_date_departure_title:'Departure date',
  travel_date_return_title:'Return date',
  travel_temp_estimated:'{temp}°C est.',

  // v1.12.282 — Phase B i18n : Auth screens MyTenue
  auth_tagline:'Your personal stylist',
  auth_section_label:'Sign in',
  sign_in:'Sign in',
  sign_up:'Sign up',
  sign_in_cta:'Sign in',
  sign_up_cta:'Create account',
  continue_with_google:'Continue with Google',
  continue_with_apple:'Continue with Apple',
  divider_or:'OR',
  password:'Password',
  confirm_password:'Confirm password',
  forgot_password_q:'Forgot your password?',
  forgot_password_title:'Forgot password',
  no_account_yet:'No account yet?',
  create_account_link:'Create account',
  already_have_account:'Already have an account?',
  show_password:'Show',
  hide_password:'Hide',
  password_placeholder:'At least 8 characters',
  password_retype_placeholder:'Retype your password',
  signup_first_name_placeholder:'Sofia',
  signup_last_name_placeholder:'Dupont',
  signup_title:'Create your account',
  signup_subtitle:'Join MyTenue with your email',
  signup_submit_cta:'Create my account',
  signup_legal_intro:'I agree to the',
  signup_legal_terms_link:'terms of service',
  signup_legal_and:'and the',
  signup_legal_privacy_link:'privacy policy',
  // Features bullets (login screen)
  feature_personalized_ai_looks:'✨ Personalized AI looks',
  feature_virtual_tryon:'📸 Virtual try-on',
  feature_partner_cashback:'🛍️ Partner credits',
  feature_smart_wardrobe_title:'Smart wardrobe',
  feature_smart_wardrobe_desc:'Snap your clothes, AI sorts them by category and style.',
  feature_ai_looks_title:'AI-generated looks',
  feature_ai_looks_desc:'Outfits built from your wardrobe + catalog.',
  feature_travel_mode_title:'Travel mode',
  feature_travel_mode_desc:'Suitcase tailored to destination, weather and length of trip.',
  // v1.12.853 — Login feature: Try-On + Flat-Lay shopping help
  feature_tryon_flatlay_title:'Virtual Try-On & Flat-Lay',
  feature_tryon_flatlay_desc:'Try items before buying and visualize outfits in flat-lay to shop smarter.',
  // Verification / Confirm email
  verification_code:'Verification code',
  resend_code:'Resend code',
  resending_code:'Sending…',
  verify_email_title:'Verify your email',
  verify_email_subtitle:'We sent a 6-digit code to',
  verify_email_missing:'— missing email —',
  verify_email_help:'Enter it below to activate your account.',
  verify_email_help_text:'Nothing in your inbox? Check your spam folder. The code expires after 24h.',
  verify_validate_cta:'Submit',
  verify_back_link:'← Back',
  code_resent_at:'Code resent at {time}',
  account_verified_title:'Account verified ✓',
  account_verified_msg:'Your email {email} is now active!\n\nSign in with your email and password to access MyTenue.',
  // Forgot password
  forgot_step1_subtitle:'Enter your email to receive a reset code.',
  forgot_step2_subtitle:'Type the code received by email and pick a new password.',
  forgot_send_code_cta:'Send code',
  forgot_code_label:'Code received by email',
  forgot_new_password_label:'New password',
  forgot_reset_cta:'Reset',
  forgot_change_email_link:'← Change email',
  back_to_signin:'Back to sign in',
  code_sent_title:'Code sent ✉',
  code_sent_msg:'A 6-digit code was sent to your email.\nCheck your inbox (and spam folder).',
  password_changed_title:'Password updated ✓',
  password_changed_msg:'Your password has been updated. Sign in with the new one to access MyTenue.',
  account_not_found_title:'Account not found',
  account_not_found_msg:'No account exists with {email}.\n\nWould you like to create a new account with this email?',
  account_exists_title:'Account already exists',
  account_exists_msg:'An account already exists with {email}.\n\nWhat would you like to do?',
  signup_failed_title:'Failed',
  signup_failed_msg:'Cannot create account.',
  signup_email_sent_title:'Email sent ✉',
  signup_email_sent_msg:'Account created!\n\nA 6-digit verification code was sent to:\n{email}\n\nCheck your inbox (and spam), then enter the code on the next screen to activate your account.',
  enter_code_cta:'Enter code',
  later_cta:'Later',
  retry_cta:'Try again',
  account_not_confirmed_title:'Account not verified',
  account_not_confirmed_msg:'Enter the code received by email to activate your account.',
  signin_failed_title:'Sign-in failed',
  apple_signin_failed_title:'Apple sign-in failed',
  apple_signin_unknown_error:'Unknown error during exchange with the server.',
  apple_unavailable_title:'Unavailable',
  apple_unavailable_msg:'Sign In with Apple is iOS 13+ only. Use Google on Android.',
  apple_module_missing_title:'Missing module',
  apple_module_missing_msg:'expo-apple-authentication is not installed. Run a dev-build via EAS (Expo Go does not support this module).',
  apple_ios13_required:'Sign In with Apple requires iOS 13 or higher.',
  config_missing_title:'Missing configuration',
  config_missing_msg:'Set AWS_CONFIG.oauth.domain in aws_config.js\n\nGo to Cognito Console → App clients → Hosted UI',
  error_title:'Error',
  favorites_signin_required:'Sign in to add items to your favorites.',
  favorites_save_failed:'Could not save to favorites. Please try again or sign in.',
  email_missing_msg:'Missing email. Please sign up again.',
  invalid_code_title:'Invalid code',
  invalid_code_msg:'Enter the 6-digit code received by email.',
  verify_failed_title:'Verification failed',
  verify_failed_msg:'Wrong or expired code.',
  code_expired_title:'Code expired',
  code_expired_msg:'This code is no longer valid.\nRequest a new code.',
  wrong_code_title:'Wrong code',
  wrong_code_msg:'The code you entered does not match.\nCheck your email and try again.',
  code_resent_title:'Code resent',
  code_resent_msg:'Check your email.',
  resend_failed_msg:'Could not resend the code.',
  new_code_sent_msg:'New code sent. Check your email.',
  // Inline errors
  err_invalid_credentials:'Wrong credentials. Check your email and password.',
  err_empty_credentials:'Enter your email and password.',
  err_invalid_email_format:'Invalid email format. Example: name@example.com',
  err_account_not_confirmed:'Account not verified. Enter the code received by email.',
  err_first_name_required:'First name required',
  err_last_name_required:'Last name required',
  err_email_required:'Email required',
  err_email_invalid:'Invalid email',
  err_password_min_length:'At least 8 characters',
  err_password_lowercase:'At least one lowercase letter',
  err_password_uppercase:'At least one uppercase letter',
  err_password_digit:'At least one digit',
  err_password_required:'Password required',
  err_passwords_mismatch:'Passwords do not match',
  err_confirm_password:'Confirm your password',
  err_accept_cgu:'Accept the terms of service',
  err_account_not_found:'No account found with this email.',
  err_send_code_failed:'Cannot send code.',
  err_code_required:'Code required',
  err_code_6_digits:'6-digit code required',
  err_code_expired_short:'Code expired, request a new one',
  err_code_incorrect_short:'Wrong code, check your email',
  err_reset_failed:'Reset failed',
  // Legal block (login)
  legal_acceptance_text:'By continuing you agree to our terms of service\nand privacy policy.',
  legal_terms_link:'Terms of service',
  legal_privacy_link:'Privacy policy',
  legal_publisher:'🇫🇷 Published by MYTENUE (SASU) · 17 rue Benoît Malon, 92150 Suresnes, France',
  legal_siret:'SIREN 105 776 215 · contact@mytenue.com',
},

/* ══════════════════════════════════════════════════════════
 *  ESPAÑOL
 * ══════════════════════════════════════════════════════════ */
es: {
  nav_home:'Inicio', nav_looks:'Looks', nav_wardrobe:'Armario',
  nav_alerts:'Alertas', nav_profile:'Perfil', nav_travel:'Viaje',
  good_morning:'Buenos días', good_afternoon:'Buenas tardes', good_evening:'Buenas noches',
  occ_evening:'Noche', occ_dinner:'Cena', occ_casual:'Salida',
  occ_work:'Trabajo', occ_date:'Cita', occ_travel:'Viaje',
  look_of_day:'Look del día', suggestions:'Sugerencias',
  compatibility:'Compatibilidad', perfect:'Perfecto', excellent:'Excelente', good:'Bien',
  ai_tip:'Consejo IA', complete_outfit:'Completar el look', see_all:'Ver todo',
  missing_pieces:'Por comprar', full_wardrobe:'✓ Todo en el armario', to_buy:'Comprar',
  budget:'Presupuesto', no_limit:'Sin límite', no_looks_budget:'No hay looks en este presupuesto',
  remove_filter:'Quitar filtro', all_occasions:'Todas',
  my_wardrobe:'Mi armario', pieces:'prendas', search_item:'Buscar prenda...',
  add_item:'+ Añadir', all_categories:'Todo', all_partners:'Todos',
  cat_dresses:'Vestidos', cat_tops:'Camisetas', cat_jackets:'Chaquetas',
  cat_bottoms:'Pantalones', cat_shoes:'Zapatos', cat_bags:'Bolsos',
  cat_accessories:'Accesorios', cat_jewelry:'Joyería',
  cat_swimwear:'Bañadores', cat_sportswear:'Deporte',
  travel_wardrobe:'Armario de viaje', my_trips:'Mis viajes',
  new_trip:'Nuevo viaje', trip_name:'Nombre del viaje',
  destination:'Destino', departure:'Salida', return_date:'Vuelta',
  packed_items:'Prendas empacadas', outfit_suggestions:'Looks sugeridos',
  weather_dest:'Clima en destino', add_to_bag:'Añadir a la maleta',
  whats_in_my_bag:'En mi maleta', travel_looks:'Looks de viaje',
  pack_light:'Viaja ligero', dont_forget:'No olvides',
  trip_style:'Estilo del viaje', days_count:'días',
  my_cart:'Mi carrito', subtotal:'Subtotal', shipping:'Envío',
  free_shipping:'Gratis', total:'Total', secure_payment:'Pago seguro',
  order_now:'Pedir ahora', delivery_address:'Dirección de entrega',
  empty_cart:'Tu carrito está vacío',
  alerts_stock:'Alertas y stock', notifications:'Notificaciones',
  my_alerts:'Mis alertas', mark_all_read:'Marcar todo leído',
  back_in_stock:'¡De vuelta en stock!', price_drop:'Bajada de precio',
  low_stock:'Poco stock', view_item:'Ver artículo →', add_to_cart:'Añadir al carrito',
  watch_item:'Vigilar', in_stock:'En stock', out_of_stock:'Sin stock',
  my_profile:'Mi perfil', member_since:'Miembro desde',
  settings:'Ajustes', language:'Idioma', currency:'Moneda',
  region:'Región', sign_out:'Cerrar sesión',
  loading:'Cargando...', cancel:'Cancelar', confirm:'Confirmar',
  save:'Guardar', edit:'Editar', delete:'Eliminar',
  close:'Cerrar', back:'Volver', search:'Buscar',
  filter:'Filtrar', sort:'Ordenar', share:'Compartir',
  my_account:'MI CUENTA', my_style_ai:'MI ESTILO IA',
  rewards:'RECOMPENSAS', quick_access:'ACCESO RÁPIDO',
  region_language:'REGIÓN E IDIOMA', settings_caps:'AJUSTES',
  my_earnings:'MIS GANANCIAS', subscription:'SUSCRIPCIÓN',
  looks_created:'Looks creados', purchases:'Compras',
  push_notifications:'Notificaciones push', integrated_weather:'Clima integrado',
  dark_mode:'Modo oscuro', daily_prefs:'Preferencias del día',
  edit_profile:'Editar perfil', restore_purchases:'Restaurar compras',
  delete_account:'Eliminar mi cuenta', terms_conditions:'Términos y condiciones',
  privacy_policy:'Política de privacidad', terms_of_sale:'Condiciones de venta', help_support:'Ayuda y soporte',
  legal:'Legal', upgrade:'Pasar a Premium', current_plan:'Plan actual',
  free_plan:'Gratis', basic_plan:'Basic', premium_plan:'Premium', gold_plan:'Gold',
  my_preferences:'Mis preferencias', favorites:'Favoritos', saved_items:'Artículos guardados', cashback_earnings:'Mis ganancias',
  sign_out_q:'¿Quieres cerrar sesión?',
  formality:'Formalidad', dominant_palette:'Paleta dominante', detected_styles:'Estilos detectados', top_category:'Categoría top', avg_price:'Precio promedio',
  style_empty_title:'Perfil aún sin analizar', style_empty_desc:'Añade artículos a tu armario, AI analizará automáticamente tu estilo.', go_to_wardrobe:'Ir al armario →',
  ai_stylist:'ESTILISTA IA', your_wardrobe:'Tu armario', view_all:'Ver todo', categories:'Categorías', ai_analyzed:'Analizadas por IA', boost_style:'Para potenciar tu estilo', create_wardrobe:'Crear mi armario', create_wardrobe_desc:'Añade tu ropa para sugerencias personalizadas', trending_week:'TENDENCIAS DE LA SEMANA', trending_subtitle:'Lo que está de moda', complete_outfits:'CONJUNTOS COMPLETOS', stylist_selection:'Selección del estilista', stylist_selection_desc:'Descubre looks diseñados para ti', loading_outfits:'Cargando conjuntos…', discover_outfit:'DESCUBRIR EL LOOK', collapse:'Reducir', catalog_caps:'CATÁLOGO', view_full_catalog:'Ver catálogo completo', navigation_caps:'NAVEGACIÓN', quick_nav:'Acceso rápido', bought_add_to_wardrobe:'Comprado → Añadir al armario',
  create:'Create', add:'Add', ai_analyzing:'AI analysis in progress', auto_analysis_bg:'Auto-analysis in background', shopping_ai_caps:'AI SHOPPING', no_suggestions_yet:'No suggestions yet', no_suggestions_desc:'Add more items to your wardrobe so the AI can generate looks to complete', looks_to_shop:'Looks to shop', looks_to_shop_desc:'Complete your looks with 5 to 10 selected items', claude_analyzing:'Claude is analyzing your combos…', cart_caps:'CART', owned:'Owned', view_more_suggestions:'View 10 more suggestions', searching_items:'Searching items…', more_combinations:'More combinations', search_more_partners:'Search more partner items', my_creations_caps:'MY CREATIONS', my_looks:'My looks', create_new_look:'CREATE NEW LOOK',
  delete_account_q1:'Esta acción es irreversible. Todos tus datos (armario, viajes, looks, alertas, suscripción) se eliminarán permanentemente.', delete_account_q2:'¿Confirmar la eliminación permanente de tu cuenta?', delete_confirm:'Eliminar', delete_account_error:'La eliminación falló. Inténtalo más tarde o contacta al soporte.',
},

/* ══════════════════════════════════════════════════════════
 *  ITALIANO
 * ══════════════════════════════════════════════════════════ */
it: {
  nav_home:'Home', nav_looks:'Look', nav_wardrobe:'Guardaroba',
  nav_alerts:'Avvisi', nav_profile:'Profilo', nav_travel:'Viaggio',
  good_morning:'Buongiorno', good_afternoon:'Buon pomeriggio', good_evening:'Buonasera',
  occ_evening:'Serata', occ_dinner:'Cena', occ_casual:'Uscita',
  occ_work:'Lavoro', occ_date:'Appuntamento', occ_travel:'Viaggio',
  look_of_day:'Look del giorno', suggestions:'Suggerimenti',
  compatibility:'Compatibilità', perfect:'Perfetto', excellent:'Eccellente', good:'Bene',
  ai_tip:'Consiglio IA', complete_outfit:'Completa il look', see_all:'Vedi tutto',
  missing_pieces:'Da acquistare', full_wardrobe:'✓ Tutto nel guardaroba', to_buy:'Acquistare',
  budget:'Budget', no_limit:'Senza limite', no_looks_budget:'Nessun look in questo budget',
  remove_filter:'Rimuovi filtro', all_occasions:'Tutte',
  my_wardrobe:'Il mio guardaroba', pieces:'capi', search_item:'Cerca un capo...',
  add_item:'+ Aggiungi', all_categories:'Tutto', all_partners:'Tutti',
  cat_dresses:'Abiti', cat_tops:'Top', cat_jackets:'Giacche',
  cat_bottoms:'Pantaloni', cat_shoes:'Scarpe', cat_bags:'Borse',
  cat_accessories:'Accessori', cat_jewelry:'Gioielli',
  cat_swimwear:'Costumi', cat_sportswear:'Sport',
  travel_wardrobe:'Guardaroba da viaggio', my_trips:'I miei viaggi',
  new_trip:'Nuovo viaggio', trip_name:'Nome del viaggio',
  destination:'Destinazione', departure:'Partenza', return_date:'Ritorno',
  packed_items:'Capi in valigia', outfit_suggestions:'Look suggeriti',
  weather_dest:'Meteo a destinazione', add_to_bag:'Aggiungi alla valigia',
  whats_in_my_bag:'Nella mia valigia', travel_looks:'Look da viaggio',
  pack_light:'Viaggia leggero', dont_forget:'Non dimenticare',
  trip_style:'Stile del viaggio', days_count:'giorni',
  my_cart:'Il mio carrello', subtotal:'Subtotale', shipping:'Spedizione',
  free_shipping:'Gratuita', total:'Totale', secure_payment:'Pagamento sicuro',
  order_now:'Ordina ora', delivery_address:'Indirizzo di consegna',
  empty_cart:'Il carrello è vuoto',
  alerts_stock:'Avvisi e stock', notifications:'Notifiche',
  my_alerts:'I miei avvisi', mark_all_read:'Segna tutto letto',
  back_in_stock:'Di nuovo disponibile!', price_drop:'Calo di prezzo',
  low_stock:'Scorte limitate', view_item:'Vedi articolo →', add_to_cart:'Aggiungi al carrello',
  watch_item:'Monitora', in_stock:'Disponibile', out_of_stock:'Non disponibile',
  my_profile:'Il mio profilo', member_since:'Membro da',
  settings:'Impostazioni', language:'Lingua', currency:'Valuta',
  region:'Regione', sign_out:'Esci',
  loading:'Caricamento...', cancel:'Annulla', confirm:'Conferma',
  save:'Salva', edit:'Modifica', delete:'Elimina',
  close:'Chiudi', back:'Indietro', search:'Cerca',
  filter:'Filtra', sort:'Ordina', share:'Condividi',
  my_account:'IL MIO ACCOUNT', my_style_ai:'IL MIO STILE IA',
  rewards:'RICOMPENSE', quick_access:'ACCESSO RAPIDO',
  region_language:'REGIONE E LINGUA', settings_caps:'IMPOSTAZIONI',
  my_earnings:'I MIEI GUADAGNI', subscription:'ABBONAMENTO',
  looks_created:'Look creati', purchases:'Acquisti',
  push_notifications:'Notifiche push', integrated_weather:'Meteo integrato',
  dark_mode:'Modalità scura', daily_prefs:'Preferenze del giorno',
  edit_profile:'Modifica profilo', restore_purchases:'Ripristina acquisti',
  delete_account:'Elimina il mio account', terms_conditions:'Termini e condizioni',
  privacy_policy:'Informativa sulla privacy', terms_of_sale:'Termini di vendita', help_support:'Aiuto e supporto',
  legal:'Note legali', upgrade:'Passa a Premium', current_plan:'Piano attuale',
  free_plan:'Gratuito', basic_plan:'Basic', premium_plan:'Premium', gold_plan:'Gold',
  my_preferences:'Le mie preferenze', favorites:'Preferiti', saved_items:'Articoli salvati', cashback_earnings:'I miei guadagni',
  sign_out_q:'Vuoi disconnetterti?',
  formality:'Formalità', dominant_palette:'Palette dominante', detected_styles:'Stili rilevati', top_category:'Categoria top', avg_price:'Prezzo medio',
  style_empty_title:'Profilo non ancora analizzato', style_empty_desc:'Aggiungi articoli al tuo armadio, AI analizzerà automaticamente il tuo stile.', go_to_wardrobe:'Vai all\'armadio →',
  ai_stylist:'STYLIST IA', your_wardrobe:'Il tuo armadio', view_all:'Vedi tutto', categories:'Categorie', ai_analyzed:'Analizzati IA', boost_style:'Per esaltare il tuo stile', create_wardrobe:'Crea il mio armadio', create_wardrobe_desc:'Aggiungi i tuoi capi per suggerimenti personalizzati', trending_week:'TENDENZE DELLA SETTIMANA', trending_subtitle:'Cosa è di tendenza', complete_outfits:'OUTFIT COMPLETI', stylist_selection:'Selezione dello stilista', stylist_selection_desc:'Scopri look pensati per te', loading_outfits:'Caricamento outfit…', discover_outfit:'SCOPRI L\'OUTFIT', collapse:'Riduci', catalog_caps:'CATALOGO', view_full_catalog:'Vedi catalogo completo', navigation_caps:'NAVIGAZIONE', quick_nav:'Accesso rapido', bought_add_to_wardrobe:'Acquistato → Aggiungi all\'armadio',
  delete_account_q1:'Questa azione è irreversibile. Tutti i tuoi dati (armadio, viaggi, look, avvisi, abbonamento) saranno eliminati definitivamente.', delete_account_q2:'Confermi l\'eliminazione definitiva del tuo account?', delete_confirm:'Elimina', delete_account_error:'L\'eliminazione è fallita. Riprova più tardi o contatta il supporto.',
},

/* ══════════════════════════════════════════════════════════
 *  DEUTSCH
 * ══════════════════════════════════════════════════════════ */
de: {
  nav_home:'Start', nav_looks:'Looks', nav_wardrobe:'Kleiderschrank',
  nav_alerts:'Alarme', nav_profile:'Profil', nav_travel:'Reise',
  good_morning:'Guten Morgen', good_afternoon:'Guten Tag', good_evening:'Guten Abend',
  occ_evening:'Abend', occ_dinner:'Dinner', occ_casual:'Ausgang',
  occ_work:'Arbeit', occ_date:'Date', occ_travel:'Reise',
  look_of_day:'Look des Tages', suggestions:'Vorschläge',
  compatibility:'Kompatibilität', perfect:'Perfekt', excellent:'Ausgezeichnet', good:'Gut',
  ai_tip:'KI-Tipp', complete_outfit:'Outfit vervollständigen', see_all:'Alle anzeigen',
  missing_pieces:'Zu kaufen', full_wardrobe:'✓ Alles im Schrank', to_buy:'Kaufen',
  budget:'Budget', no_limit:'Kein Limit', no_looks_budget:'Keine Looks in diesem Budget',
  remove_filter:'Filter entfernen', all_occasions:'Alle',
  my_wardrobe:'Mein Kleiderschrank', pieces:'Teile', search_item:'Suche...',
  add_item:'+ Hinzufügen', all_categories:'Alle', all_partners:'Alle Partner',
  cat_dresses:'Kleider', cat_tops:'Oberteile', cat_jackets:'Jacken',
  cat_bottoms:'Hosen', cat_shoes:'Schuhe', cat_bags:'Taschen',
  cat_accessories:'Accessoires', cat_jewelry:'Schmuck',
  cat_swimwear:'Bademode', cat_sportswear:'Sport',
  travel_wardrobe:'Reise-Kleiderschrank', my_trips:'Meine Reisen',
  new_trip:'Neue Reise', trip_name:'Reisename',
  destination:'Ziel', departure:'Abflug', return_date:'Rückkehr',
  packed_items:'Gepackte Teile', outfit_suggestions:'Outfit-Vorschläge',
  weather_dest:'Wetter am Zielort', add_to_bag:'Zum Koffer hinzufügen',
  whats_in_my_bag:'In meinem Koffer', travel_looks:'Reise-Looks',
  pack_light:'Leicht reisen', dont_forget:'Nicht vergessen',
  trip_style:'Reisestil', days_count:'Tage',
  my_cart:'Mein Warenkorb', subtotal:'Zwischensumme', shipping:'Versand',
  free_shipping:'Kostenlos', total:'Gesamt', secure_payment:'Sicheres Bezahlen',
  order_now:'Jetzt bestellen', delivery_address:'Lieferadresse',
  empty_cart:'Dein Warenkorb ist leer',
  alerts_stock:'Alarme & Lager', notifications:'Benachrichtigungen',
  my_alerts:'Meine Alarme', mark_all_read:'Alle als gelesen markieren',
  back_in_stock:'Wieder verfügbar!', price_drop:'Preissenkung',
  low_stock:'Geringer Bestand', view_item:'Artikel ansehen →', add_to_cart:'In den Warenkorb',
  watch_item:'Beobachten', in_stock:'Verfügbar', out_of_stock:'Nicht verfügbar',
  my_profile:'Mein Profil', member_since:'Mitglied seit',
  settings:'Einstellungen', language:'Sprache', currency:'Währung',
  region:'Region', sign_out:'Abmelden',
  loading:'Wird geladen...', cancel:'Abbrechen', confirm:'Bestätigen',
  save:'Speichern', edit:'Bearbeiten', delete:'Löschen',
  close:'Schließen', back:'Zurück', search:'Suchen',
  filter:'Filtern', sort:'Sortieren', share:'Teilen',
  my_account:'MEIN KONTO', my_style_ai:'MEIN STIL KI',
  rewards:'BELOHNUNGEN', quick_access:'SCHNELLZUGRIFF',
  region_language:'REGION & SPRACHE', settings_caps:'EINSTELLUNGEN',
  my_earnings:'MEINE EINNAHMEN', subscription:'ABONNEMENT',
  looks_created:'Looks erstellt', purchases:'Käufe',
  push_notifications:'Push-Benachrichtigungen', integrated_weather:'Integriertes Wetter',
  dark_mode:'Dunkelmodus', daily_prefs:'Tagespräferenzen',
  edit_profile:'Profil bearbeiten', restore_purchases:'Käufe wiederherstellen',
  delete_account:'Konto löschen', terms_conditions:'Nutzungsbedingungen',
  privacy_policy:'Datenschutzerklärung', terms_of_sale:'Verkaufsbedingungen', help_support:'Hilfe & Support',
  legal:'Rechtliches', upgrade:'Upgrade auf Premium', current_plan:'Aktueller Plan',
  free_plan:'Kostenlos', basic_plan:'Basic', premium_plan:'Premium', gold_plan:'Gold',
  my_preferences:'Meine Präferenzen', favorites:'Favoriten', saved_items:'Gespeicherte Artikel', cashback_earnings:'Meine Einnahmen',
  sign_out_q:'Möchten Sie sich abmelden?',
  formality:'Formalität', dominant_palette:'Dominante Palette', detected_styles:'Erkannte Stile', top_category:'Top-Kategorie', avg_price:'Durchschn. Preis',
  style_empty_title:'Profil noch nicht analysiert', style_empty_desc:'Fügen Sie Artikel zu Ihrer Garderobe hinzu — AI analysiert Ihren Stil automatisch.', go_to_wardrobe:'Zur Garderobe →',
  ai_stylist:'KI-STYLIST', your_wardrobe:'Deine Garderobe', view_all:'Alle anzeigen', categories:'Kategorien', ai_analyzed:'KI-analysiert', boost_style:'Style aufwerten', create_wardrobe:'Meine Garderobe erstellen', create_wardrobe_desc:'Füge deine Kleidung für personalisierte Vorschläge hinzu', trending_week:'TRENDS DER WOCHE', trending_subtitle:'Was gerade trendet', complete_outfits:'KOMPLETTE OUTFITS', stylist_selection:'Stylist-Auswahl', stylist_selection_desc:'Entdecke für dich gestaltete Looks', loading_outfits:'Outfits laden…', discover_outfit:'OUTFIT ENTDECKEN', collapse:'Einklappen', catalog_caps:'KATALOG', view_full_catalog:'Vollständigen Katalog anzeigen', navigation_caps:'NAVIGATION', quick_nav:'Schnellzugriff', bought_add_to_wardrobe:'Gekauft → Zur Garderobe',
  create:'Crear', add:'Añadir', ai_analyzing:'Análisis IA en curso', auto_analysis_bg:'Análisis automático en segundo plano', shopping_ai_caps:'COMPRAS IA', no_suggestions_yet:'Aún sin sugerencias', no_suggestions_desc:'Añade más artículos a tu armario para que la IA genere looks por completar', looks_to_shop:'Looks por comprar', looks_to_shop_desc:'Completa tus looks con 5 a 10 artículos seleccionados', claude_analyzing:'Claude está analizando tus combinaciones…', cart_caps:'CARRITO', owned:'Tengo', view_more_suggestions:'Ver 10 sugerencias más', searching_items:'Buscando artículos…', more_combinations:'Más combinaciones', search_more_partners:'Buscar más artículos de partners', my_creations_caps:'MIS CREACIONES', my_looks:'Mis looks', create_new_look:'CREAR NUEVO LOOK',
  delete_account_q1:'Diese Aktion kann nicht rückgängig gemacht werden. Alle Ihre Daten (Garderobe, Reisen, Looks, Benachrichtigungen, Abonnement) werden dauerhaft gelöscht.', delete_account_q2:'Endgültige Löschung Ihres Kontos bestätigen?', delete_confirm:'Löschen', delete_account_error:'Löschung fehlgeschlagen. Bitte versuchen Sie es später erneut oder kontaktieren Sie den Support.',
},

/* ══════════════════════════════════════════════════════════
 *  PORTUGUÊS (BR)
 * ══════════════════════════════════════════════════════════ */
'pt-BR': {
  nav_home:'Início', nav_looks:'Looks', nav_wardrobe:'Guarda-roupa',
  nav_alerts:'Alertas', nav_profile:'Perfil', nav_travel:'Viagem',
  good_morning:'Bom dia', good_afternoon:'Boa tarde', good_evening:'Boa noite',
  occ_evening:'Noitada', occ_dinner:'Jantar', occ_casual:'Passeio',
  occ_work:'Trabalho', occ_date:'Encontro', occ_travel:'Viagem',
  look_of_day:'Look do dia', suggestions:'Sugestões',
  compatibility:'Compatibilidade', perfect:'Perfeito', excellent:'Excelente', good:'Bom',
  ai_tip:'Dica da IA', complete_outfit:'Completar o look', see_all:'Ver tudo',
  missing_pieces:'A comprar', full_wardrobe:'✓ Tudo no guarda-roupa', to_buy:'Comprar',
  budget:'Orçamento', no_limit:'Sem limite', no_looks_budget:'Nenhum look neste orçamento',
  remove_filter:'Remover filtro', all_occasions:'Todas',
  my_wardrobe:'Meu guarda-roupa', pieces:'peças', search_item:'Buscar peça...',
  add_item:'+ Adicionar', all_categories:'Tudo', all_partners:'Todos',
  cat_dresses:'Vestidos', cat_tops:'Blusas', cat_jackets:'Jaquetas',
  cat_bottoms:'Calças', cat_shoes:'Sapatos', cat_bags:'Bolsas',
  cat_accessories:'Acessórios', cat_jewelry:'Joias',
  cat_swimwear:'Maiôs', cat_sportswear:'Esporte',
  travel_wardrobe:'Guarda-roupa de viagem', my_trips:'Minhas viagens',
  new_trip:'Nova viagem', trip_name:'Nome da viagem',
  destination:'Destino', departure:'Partida', return_date:'Retorno',
  packed_items:'Peças embaladas', outfit_suggestions:'Looks sugeridos',
  weather_dest:'Clima no destino', add_to_bag:'Adicionar à mala',
  whats_in_my_bag:'Na minha mala', travel_looks:'Looks de viagem',
  pack_light:'Viaje leve', dont_forget:'Não esqueça',
  trip_style:'Estilo da viagem', days_count:'dias',
  my_cart:'Meu carrinho', subtotal:'Subtotal', shipping:'Frete',
  free_shipping:'Grátis', total:'Total', secure_payment:'Pagamento seguro',
  order_now:'Pedir agora', delivery_address:'Endereço de entrega',
  empty_cart:'Seu carrinho está vazio',
  alerts_stock:'Alertas e estoque', notifications:'Notificações',
  my_alerts:'Meus alertas', mark_all_read:'Marcar tudo como lido',
  back_in_stock:'De volta ao estoque!', price_drop:'Queda de preço',
  low_stock:'Estoque limitado', view_item:'Ver item →', add_to_cart:'Adicionar ao carrinho',
  watch_item:'Monitorar', in_stock:'Em estoque', out_of_stock:'Fora de estoque',
  my_profile:'Meu perfil', member_since:'Membro desde',
  settings:'Configurações', language:'Idioma', currency:'Moeda',
  region:'Região', sign_out:'Sair',
  loading:'Carregando...', cancel:'Cancelar', confirm:'Confirmar',
  save:'Salvar', edit:'Editar', delete:'Excluir',
  close:'Fechar', back:'Voltar', search:'Buscar',
  filter:'Filtrar', sort:'Ordenar', share:'Compartilhar',
  my_account:'MINHA CONTA', my_style_ai:'MEU ESTILO IA',
  rewards:'RECOMPENSAS', quick_access:'ACESSO RÁPIDO',
  region_language:'REGIÃO E IDIOMA', settings_caps:'CONFIGURAÇÕES',
  my_earnings:'MEUS GANHOS', subscription:'ASSINATURA',
  looks_created:'Looks criados', purchases:'Compras',
  push_notifications:'Notificações push', integrated_weather:'Clima integrado',
  dark_mode:'Modo escuro', daily_prefs:'Preferências do dia',
  edit_profile:'Editar perfil', restore_purchases:'Restaurar compras',
  delete_account:'Excluir minha conta', terms_conditions:'Termos e condições',
  privacy_policy:'Política de privacidade', terms_of_sale:'Condições de venda', help_support:'Ajuda e suporte',
  legal:'Legal', upgrade:'Assinar Premium', current_plan:'Plano atual',
  free_plan:'Grátis', basic_plan:'Basic', premium_plan:'Premium', gold_plan:'Gold',
  my_preferences:'Minhas preferências', favorites:'Favoritos', saved_items:'Itens salvos', cashback_earnings:'Meus ganhos',
  sign_out_q:'Deseja sair?',
  formality:'Formalidade', dominant_palette:'Paleta dominante', detected_styles:'Estilos detectados', top_category:'Categoria top', avg_price:'Preço médio',
  style_empty_title:'Perfil ainda não analisado', style_empty_desc:'Adicione peças ao seu guarda-roupa, AI analisará automaticamente o seu estilo.', go_to_wardrobe:'Ir ao guarda-roupa →',
  ai_stylist:'STYLIST IA', your_wardrobe:'Seu guarda-roupa', view_all:'Ver tudo', categories:'Categorias', ai_analyzed:'Analisadas por IA', boost_style:'Para impulsionar seu estilo', create_wardrobe:'Criar meu guarda-roupa', create_wardrobe_desc:'Adicione suas roupas para sugestões personalizadas', trending_week:'TENDÊNCIAS DA SEMANA', trending_subtitle:'O que está em alta', complete_outfits:'LOOKS COMPLETOS', stylist_selection:'Seleção do stylist', stylist_selection_desc:'Descubra looks pensados para você', loading_outfits:'Carregando looks…', discover_outfit:'DESCOBRIR O LOOK', collapse:'Recolher', catalog_caps:'CATÁLOGO', view_full_catalog:'Ver catálogo completo', navigation_caps:'NAVEGAÇÃO', quick_nav:'Acesso rápido', bought_add_to_wardrobe:'Comprado → Adicionar ao guarda-roupa',
  create:'Crea', add:'Aggiungi', ai_analyzing:'Analisi IA in corso', auto_analysis_bg:'Auto-analisi in background', shopping_ai_caps:'SHOPPING IA', no_suggestions_yet:'Nessun suggerimento ancora', no_suggestions_desc:'Aggiungi più articoli al tuo armadio così l\'IA può generare look da completare', looks_to_shop:'Look da acquistare', looks_to_shop_desc:'Completa i tuoi look con 5-10 articoli selezionati', claude_analyzing:'Claude sta analizzando le tue combinazioni…', cart_caps:'CARRELLO', owned:'Posseduto', view_more_suggestions:'Vedi altri 10 suggerimenti', searching_items:'Ricerca articoli…', more_combinations:'Più combinazioni', search_more_partners:'Cerca più articoli partner', my_creations_caps:'LE MIE CREAZIONI', my_looks:'I miei look', create_new_look:'CREA NUOVO LOOK',
  delete_account_q1:'Esta ação é irreversível. Todos os seus dados (guarda-roupa, viagens, looks, alertas, assinatura) serão excluídos permanentemente.', delete_account_q2:'Confirmar exclusão permanente da sua conta?', delete_confirm:'Excluir', delete_account_error:'A exclusão falhou. Tente novamente mais tarde ou contate o suporte.',
},

/* ══════════════════════════════════════════════════════════
 *  ARABIC (RTL)
 * ══════════════════════════════════════════════════════════ */
ar: {
  nav_home:'الرئيسية', nav_looks:'الأزياء', nav_wardrobe:'خزانة الملابس',
  nav_alerts:'التنبيهات', nav_profile:'الملف الشخصي', nav_travel:'السفر',
  good_morning:'صباح الخير', good_afternoon:'مساء الخير', good_evening:'مساء النور',
  occ_evening:'سهرة', occ_dinner:'عشاء', occ_casual:'خروج',
  occ_work:'عمل', occ_date:'موعد', occ_travel:'سفر',
  look_of_day:'إطلالة اليوم', suggestions:'اقتراحات',
  compatibility:'التوافق', perfect:'مثالي', excellent:'ممتاز', good:'جيد',
  ai_tip:'نصيحة الذكاء الاصطناعي', complete_outfit:'أكمل الإطلالة', see_all:'عرض الكل',
  missing_pieces:'للشراء', full_wardrobe:'✓ كل شيء من خزانة الملابس', to_buy:'للشراء',
  budget:'الميزانية', no_limit:'بدون حد', no_looks_budget:'لا توجد إطلالات في هذه الميزانية',
  remove_filter:'إزالة الفلتر', all_occasions:'الكل',
  my_wardrobe:'خزانة ملابسي', pieces:'قطع', search_item:'البحث عن قطعة...',
  add_item:'+ إضافة', all_categories:'الكل', all_partners:'كل الشركاء',
  cat_dresses:'فساتين', cat_tops:'بلوزات', cat_jackets:'جاكيتات',
  cat_bottoms:'بنطلونات', cat_shoes:'أحذية', cat_bags:'حقائب',
  cat_accessories:'إكسسوارات', cat_jewelry:'مجوهرات',
  cat_swimwear:'ملابس سباحة', cat_sportswear:'رياضة',
  travel_wardrobe:'خزانة ملابس السفر', my_trips:'رحلاتي',
  new_trip:'رحلة جديدة', trip_name:'اسم الرحلة',
  destination:'الوجهة', departure:'المغادرة', return_date:'العودة',
  packed_items:'الملابس المحزومة', outfit_suggestions:'الإطلالات المقترحة',
  weather_dest:'الطقس في الوجهة', add_to_bag:'أضف إلى الحقيبة',
  whats_in_my_bag:'في حقيبتي', travel_looks:'إطلالات السفر',
  pack_light:'سافر بخفة', dont_forget:'لا تنسَ',
  trip_style:'أسلوب الرحلة', days_count:'أيام',
  my_cart:'سلة التسوق', subtotal:'المجموع الفرعي', shipping:'الشحن',
  free_shipping:'مجاني', total:'الإجمالي', secure_payment:'دفع آمن',
  order_now:'اطلب الآن', delivery_address:'عنوان التوصيل',
  empty_cart:'سلة التسوق فارغة',
  alerts_stock:'التنبيهات والمخزون', notifications:'الإشعارات',
  my_alerts:'تنبيهاتي', mark_all_read:'تعليم الكل كمقروء',
  back_in_stock:'عاد إلى المخزون!', price_drop:'انخفاض السعر',
  low_stock:'مخزون محدود', view_item:'عرض المنتج ←', add_to_cart:'أضف إلى السلة',
  watch_item:'مراقبة', in_stock:'متوفر', out_of_stock:'غير متوفر',
  my_profile:'ملفي الشخصي', member_since:'عضو منذ',
  settings:'الإعدادات', language:'اللغة', currency:'العملة',
  region:'المنطقة', sign_out:'تسجيل الخروج',
  loading:'جاري التحميل...', cancel:'إلغاء', confirm:'تأكيد',
  save:'حفظ', edit:'تعديل', delete:'حذف',
  close:'إغلاق', back:'رجوع', search:'بحث',
  filter:'تصفية', sort:'ترتيب', share:'مشاركة',
  my_account:'حسابي', my_style_ai:'أسلوبي الذكي',
  rewards:'المكافآت', quick_access:'وصول سريع',
  region_language:'المنطقة واللغة', settings_caps:'الإعدادات',
  my_earnings:'أرباحي', subscription:'الاشتراك',
  looks_created:'الأزياء المنشأة', purchases:'المشتريات',
  push_notifications:'الإشعارات', integrated_weather:'الطقس المدمج',
  dark_mode:'الوضع الداكن', daily_prefs:'تفضيلات اليوم',
  edit_profile:'تعديل الملف الشخصي', restore_purchases:'استعادة المشتريات',
  delete_account:'حذف حسابي', terms_conditions:'الشروط والأحكام',
  privacy_policy:'سياسة الخصوصية', terms_of_sale:'شروط البيع', help_support:'المساعدة والدعم',
  legal:'قانوني', upgrade:'الترقية إلى بريميوم', current_plan:'الخطة الحالية',
  free_plan:'مجاني', basic_plan:'بيسيك', premium_plan:'بريميوم', gold_plan:'جولد',
  my_preferences:'تفضيلاتي', favorites:'المفضلة', saved_items:'العناصر المحفوظة', cashback_earnings:'أرباحي',
  sign_out_q:'هل تريد تسجيل الخروج؟',
  formality:'الرسمية', dominant_palette:'اللوحة المهيمنة', detected_styles:'الأنماط المكتشفة', top_category:'الفئة الأعلى', avg_price:'متوسط السعر',
  style_empty_title:'لم يتم تحليل الملف بعد', style_empty_desc:'أضف العناصر إلى خزانتك، سيقوم AI بتحليل أسلوبك تلقائياً.', go_to_wardrobe:'اذهب إلى الخزانة ←',
  ai_stylist:'مصمم الأزياء AI', your_wardrobe:'خزانتك', view_all:'عرض الكل', categories:'الفئات', ai_analyzed:'تحليل AI', boost_style:'لتعزيز أسلوبك', create_wardrobe:'إنشاء خزانتي', create_wardrobe_desc:'أضف ملابسك للحصول على اقتراحات مخصصة', trending_week:'موضة الأسبوع', trending_subtitle:'ما هو رائج', complete_outfits:'إطلالات كاملة', stylist_selection:'اختيار المصمم', stylist_selection_desc:'اكتشف إطلالات مصممة لك', loading_outfits:'جاري تحميل الإطلالات…', discover_outfit:'اكتشف الإطلالة', collapse:'تصغير', catalog_caps:'الكتالوج', view_full_catalog:'عرض الكتالوج الكامل', navigation_caps:'التنقل', quick_nav:'وصول سريع', bought_add_to_wardrobe:'تم الشراء ← أضف إلى الخزانة',
  create:'Erstellen', add:'Hinzufügen', ai_analyzing:'KI-Analyse läuft', auto_analysis_bg:'Auto-Analyse im Hintergrund', shopping_ai_caps:'KI-SHOPPING', no_suggestions_yet:'Noch keine Vorschläge', no_suggestions_desc:'Füge mehr Artikel zur Garderobe hinzu, damit die KI Looks zum Vervollständigen erstellt', looks_to_shop:'Looks zum Shoppen', looks_to_shop_desc:'Vervollständige deine Looks mit 5-10 ausgewählten Artikeln', claude_analyzing:'Claude analysiert deine Kombis…', cart_caps:'WARENKORB', owned:'Vorhanden', view_more_suggestions:'10 weitere Vorschläge anzeigen', searching_items:'Artikel suchen…', more_combinations:'Mehr Kombinationen', search_more_partners:'Mehr Partner-Artikel suchen', my_creations_caps:'MEINE KREATIONEN', my_looks:'Meine Looks', create_new_look:'NEUEN LOOK ERSTELLEN',
  delete_account_q1:'هذا الإجراء لا يمكن التراجع عنه. سيتم حذف جميع بياناتك (الخزانة، الرحلات، الإطلالات، التنبيهات، الاشتراك) نهائياً.', delete_account_q2:'تأكيد الحذف النهائي لحسابك؟', delete_confirm:'حذف', delete_account_error:'فشل الحذف. حاول لاحقاً أو اتصل بالدعم.',
},

/* ══════════════════════════════════════════════════════════
 *  РУССКИЙ
 * ══════════════════════════════════════════════════════════ */
ru: {
  nav_home:'Главная', nav_looks:'Образы', nav_wardrobe:'Гардероб',
  nav_alerts:'Уведомления', nav_profile:'Профиль', nav_travel:'Путешествие',
  good_morning:'Доброе утро', good_afternoon:'Добрый день', good_evening:'Добрый вечер',
  occ_evening:'Вечеринка', occ_dinner:'Ужин', occ_casual:'Прогулка',
  occ_work:'Работа', occ_date:'Свидание', occ_travel:'Поездка',
  look_of_day:'Образ дня', suggestions:'Предложения',
  compatibility:'Совместимость', perfect:'Идеально', excellent:'Отлично', good:'Хорошо',
  ai_tip:'Совет ИИ', complete_outfit:'Дополнить образ', see_all:'Смотреть всё',
  missing_pieces:'Купить', full_wardrobe:'✓ Всё есть в гардеробе', to_buy:'Купить',
  budget:'Бюджет', no_limit:'Без ограничений', no_looks_budget:'Нет образов в этом бюджете',
  remove_filter:'Убрать фильтр', all_occasions:'Все',
  my_wardrobe:'Мой гардероб', pieces:'вещей', search_item:'Поиск вещи...',
  add_item:'+ Добавить', all_categories:'Все', all_partners:'Все партнёры',
  cat_dresses:'Платья', cat_tops:'Топы', cat_jackets:'Куртки',
  cat_bottoms:'Брюки', cat_shoes:'Обувь', cat_bags:'Сумки',
  cat_accessories:'Аксессуары', cat_jewelry:'Украшения',
  cat_swimwear:'Купальники', cat_sportswear:'Спорт',
  travel_wardrobe:'Гардероб путешественника', my_trips:'Мои поездки',
  new_trip:'Новая поездка', trip_name:'Название поездки',
  destination:'Направление', departure:'Отъезд', return_date:'Возвращение',
  packed_items:'Вещи в чемодане', outfit_suggestions:'Предложения образов',
  weather_dest:'Погода в пункте назначения', add_to_bag:'Добавить в чемодан',
  whats_in_my_bag:'В моём чемодане', travel_looks:'Дорожные образы',
  pack_light:'Путешествуй налегке', dont_forget:'Не забудь',
  trip_style:'Стиль поездки', days_count:'дней',
  my_cart:'Моя корзина', subtotal:'Подытог', shipping:'Доставка',
  free_shipping:'Бесплатно', total:'Итого', secure_payment:'Безопасная оплата',
  order_now:'Заказать', delivery_address:'Адрес доставки',
  empty_cart:'Корзина пуста',
  alerts_stock:'Уведомления и склад', notifications:'Уведомления',
  my_alerts:'Мои уведомления', mark_all_read:'Отметить всё прочитанным',
  back_in_stock:'Снова в наличии!', price_drop:'Снижение цены',
  low_stock:'Мало в наличии', view_item:'Смотреть товар →', add_to_cart:'Добавить в корзину',
  watch_item:'Следить', in_stock:'В наличии', out_of_stock:'Нет в наличии',
  my_profile:'Мой профиль', member_since:'Участник с',
  settings:'Настройки', language:'Язык', currency:'Валюта',
  region:'Регион', sign_out:'Выйти',
  loading:'Загрузка...', cancel:'Отмена', confirm:'Подтвердить',
  save:'Сохранить', edit:'Изменить', delete:'Удалить',
  close:'Закрыть', back:'Назад', search:'Поиск',
  filter:'Фильтр', sort:'Сортировка', share:'Поделиться',
  my_account:'МОЙ АККАУНТ', my_style_ai:'МОЙ СТИЛЬ ИИ',
  rewards:'НАГРАДЫ', quick_access:'БЫСТРЫЙ ДОСТУП',
  region_language:'РЕГИОН И ЯЗЫК', settings_caps:'НАСТРОЙКИ',
  my_earnings:'МОИ ДОХОДЫ', subscription:'ПОДПИСКА',
  looks_created:'Создано образов', purchases:'Покупки',
  push_notifications:'Push-уведомления', integrated_weather:'Встроенная погода',
  dark_mode:'Тёмный режим', daily_prefs:'Настройки на день',
  edit_profile:'Редактировать профиль', restore_purchases:'Восстановить покупки',
  delete_account:'Удалить аккаунт', terms_conditions:'Условия использования',
  privacy_policy:'Политика конфиденциальности', terms_of_sale:'Условия продажи', help_support:'Помощь и поддержка',
  legal:'Правовая информация', upgrade:'Перейти на Premium', current_plan:'Текущий план',
  free_plan:'Бесплатно', basic_plan:'Basic', premium_plan:'Premium', gold_plan:'Gold',
  my_preferences:'Мои настройки', favorites:'Избранное', saved_items:'Сохранённые товары', cashback_earnings:'Мои доходы',
  sign_out_q:'Вы хотите выйти?',
  formality:'Формальность', dominant_palette:'Доминирующая палитра', detected_styles:'Обнаруженные стили', top_category:'Топ-категория', avg_price:'Средняя цена',
  style_empty_title:'Профиль ещё не проанализирован', style_empty_desc:'Добавьте вещи в гардероб — AI автоматически проанализирует ваш стиль.', go_to_wardrobe:'В гардероб →',
  ai_stylist:'AI-СТИЛИСТ', your_wardrobe:'Ваш гардероб', view_all:'Все', categories:'Категории', ai_analyzed:'AI-анализ', boost_style:'Чтобы улучшить стиль', create_wardrobe:'Создать гардероб', create_wardrobe_desc:'Добавьте одежду для персональных рекомендаций', trending_week:'ТРЕНДЫ НЕДЕЛИ', trending_subtitle:'Что в тренде', complete_outfits:'ГОТОВЫЕ ОБРАЗЫ', stylist_selection:'Выбор стилиста', stylist_selection_desc:'Откройте образы, созданные для вас', loading_outfits:'Загрузка образов…', discover_outfit:'СМОТРЕТЬ ОБРАЗ', collapse:'Свернуть', catalog_caps:'КАТАЛОГ', view_full_catalog:'Весь каталог', navigation_caps:'НАВИГАЦИЯ', quick_nav:'Быстрый доступ', bought_add_to_wardrobe:'Куплено → В гардероб',
  create:'Criar', add:'Adicionar', ai_analyzing:'Análise IA em andamento', auto_analysis_bg:'Auto-análise em segundo plano', shopping_ai_caps:'COMPRAS IA', no_suggestions_yet:'Ainda sem sugestões', no_suggestions_desc:'Adicione mais peças ao guarda-roupa para a IA gerar looks a completar', looks_to_shop:'Looks para comprar', looks_to_shop_desc:'Complete seus looks com 5 a 10 peças selecionadas', claude_analyzing:'Claude está analisando suas combinações…', cart_caps:'CARRINHO', owned:'Possuído', view_more_suggestions:'Ver mais 10 sugestões', searching_items:'Buscando peças…', more_combinations:'Mais combinações', search_more_partners:'Buscar mais peças parceiras', my_creations_caps:'MINHAS CRIAÇÕES', my_looks:'Meus looks', create_new_look:'CRIAR NOVO LOOK',
  delete_account_q1:'Это действие необратимо. Все ваши данные (гардероб, поездки, образы, оповещения, подписка) будут удалены навсегда.', delete_account_q2:'Подтвердить безвозвратное удаление аккаунта?', delete_confirm:'Удалить', delete_account_error:'Удаление не удалось. Попробуйте позже или свяжитесь с поддержкой.',
},

/* ══════════════════════════════════════════════════════════
 *  TÜRKÇE
 * ══════════════════════════════════════════════════════════ */
tr: {
  nav_home:'Ana Sayfa', nav_looks:'Kombiner', nav_wardrobe:'Dolap',
  nav_alerts:'Uyarılar', nav_profile:'Profil', nav_travel:'Seyahat',
  good_morning:'Günaydın', good_afternoon:'İyi öğleden sonralar', good_evening:'İyi akşamlar',
  occ_evening:'Akşam', occ_dinner:'Akşam yemeği', occ_casual:'Çıkış',
  occ_work:'İş', occ_date:'Randevu', occ_travel:'Seyahat',
  look_of_day:'Günün kombini', suggestions:'Öneriler',
  compatibility:'Uyumluluk', perfect:'Mükemmel', excellent:'Harika', good:'İyi',
  ai_tip:'Yapay Zeka İpucu', complete_outfit:'Kombini tamamla', see_all:'Tümünü gör',
  missing_pieces:'Satın alınacak', full_wardrobe:'✓ Tümü dolapta', to_buy:'Satın al',
  budget:'Bütçe', no_limit:'Sınır yok', no_looks_budget:'Bu bütçede kombin yok',
  remove_filter:'Filtreyi kaldır', all_occasions:'Tümü',
  my_wardrobe:'Dolabım', pieces:'parça', search_item:'Parça ara...',
  add_item:'+ Ekle', all_categories:'Tümü', all_partners:'Tüm partnerler',
  cat_dresses:'Elbiseler', cat_tops:'Üstler', cat_jackets:'Ceketler',
  cat_bottoms:'Altlar', cat_shoes:'Ayakkabılar', cat_bags:'Çantalar',
  cat_accessories:'Aksesuarlar', cat_jewelry:'Takılar',
  cat_swimwear:'Mayo', cat_sportswear:'Spor',
  travel_wardrobe:'Seyahat dolabı', my_trips:'Seyahatlerim',
  new_trip:'Yeni seyahat', trip_name:'Seyahat adı',
  destination:'Varış noktası', departure:'Kalkış', return_date:'Dönüş',
  packed_items:'Paketlenen parçalar', outfit_suggestions:'Önerilen kombinler',
  weather_dest:'Varış noktasındaki hava durumu', add_to_bag:'Bavula ekle',
  whats_in_my_bag:'Bavulumda', travel_looks:'Seyahat kombinleri',
  pack_light:'Hafif paketle', dont_forget:'Unutma',
  trip_style:'Seyahat stili', days_count:'gün',
  my_cart:'Sepetim', subtotal:'Ara toplam', shipping:'Kargo',
  free_shipping:'Ücretsiz', total:'Toplam', secure_payment:'Güvenli ödeme',
  order_now:'Şimdi sipariş ver', delivery_address:'Teslimat adresi',
  empty_cart:'Sepetiniz boş',
  alerts_stock:'Uyarılar ve stok', notifications:'Bildirimler',
  my_alerts:'Uyarılarım', mark_all_read:'Tümünü okundu işaretle',
  back_in_stock:'Tekrar stokta!', price_drop:'Fiyat düşüşü',
  low_stock:'Sınırlı stok', view_item:'Ürünü gör →', add_to_cart:'Sepete ekle',
  watch_item:'Takip et', in_stock:'Stokta', out_of_stock:'Stokta yok',
  my_profile:'Profilim', member_since:'Üye tarihi',
  settings:'Ayarlar', language:'Dil', currency:'Para birimi',
  region:'Bölge', sign_out:'Çıkış yap',
  loading:'Yükleniyor...', cancel:'İptal', confirm:'Onayla',
  save:'Kaydet', edit:'Düzenle', delete:'Sil',
  close:'Kapat', back:'Geri', search:'Ara',
  filter:'Filtrele', sort:'Sırala', share:'Paylaş',
  my_account:'HESABIM', my_style_ai:'TARZIM (YZ)',
  rewards:'ÖDÜLLER', quick_access:'HIZLI ERİŞİM',
  region_language:'BÖLGE VE DİL', settings_caps:'AYARLAR',
  my_earnings:'KAZANÇLARIM', subscription:'ABONELİK',
  looks_created:'Oluşturulan kombinler', purchases:'Satın alımlar',
  push_notifications:'Anlık bildirimler', integrated_weather:'Entegre hava durumu',
  dark_mode:'Karanlık mod', daily_prefs:'Günün tercihleri',
  edit_profile:'Profili düzenle', restore_purchases:'Satın alımları geri yükle',
  delete_account:'Hesabımı sil', terms_conditions:'Kullanım koşulları',
  privacy_policy:'Gizlilik politikası', terms_of_sale:'Satış koşulları', help_support:'Yardım ve destek',
  legal:'Yasal', upgrade:'Premium\'a yükselt', current_plan:'Geçerli plan',
  free_plan:'Ücretsiz', basic_plan:'Basic', premium_plan:'Premium', gold_plan:'Gold',
  my_preferences:'Tercihlerim', favorites:'Favoriler', saved_items:'Kaydedilenler', cashback_earnings:'Kazançlarım',
  sign_out_q:'Çıkış yapmak istiyor musunuz?',
  formality:'Resmiyet', dominant_palette:'Baskın palet', detected_styles:'Tespit edilen stiller', top_category:'En çok kategori', avg_price:'Ort. fiyat',
  style_empty_title:'Profil henüz analiz edilmedi', style_empty_desc:'Gardırobunuza ürün ekleyin — AI tarzınızı otomatik olarak analiz edecek.', go_to_wardrobe:'Gardıroba git →',
  ai_stylist:'YZ STYLIST', your_wardrobe:'Gardırobun', view_all:'Tümünü gör', categories:'Kategoriler', ai_analyzed:'YZ analizi', boost_style:'Tarzını yükseltmek için', create_wardrobe:'Gardırobumu oluştur', create_wardrobe_desc:'Kişiselleştirilmiş öneriler için kıyafetlerini ekle', trending_week:'HAFTANIN TRENDLERİ', trending_subtitle:'Trend olan ne', complete_outfits:'KOMPLE KOMBİNLER', stylist_selection:'Stilist seçimi', stylist_selection_desc:'Sana özel kombinleri keşfet', loading_outfits:'Kombinler yükleniyor…', discover_outfit:'KOMBİNİ KEŞFET', collapse:'Daralt', catalog_caps:'KATALOG', view_full_catalog:'Tüm kataloğu gör', navigation_caps:'GEZİNME', quick_nav:'Hızlı erişim', bought_add_to_wardrobe:'Satın alındı → Gardıroba ekle',
  create:'إنشاء', add:'إضافة', ai_analyzing:'تحليل AI قيد التنفيذ', auto_analysis_bg:'تحليل تلقائي في الخلفية', shopping_ai_caps:'تسوق AI', no_suggestions_yet:'لا توجد اقتراحات بعد', no_suggestions_desc:'أضف المزيد من العناصر لخزانتك حتى يولد الذكاء الاصطناعي إطلالات لإكمالها', looks_to_shop:'إطلالات للتسوق', looks_to_shop_desc:'أكمل إطلالاتك بـ 5 إلى 10 عناصر مختارة', claude_analyzing:'Claude يحلل توافيقك…', cart_caps:'السلة', owned:'مملوك', view_more_suggestions:'عرض 10 اقتراحات إضافية', searching_items:'البحث عن العناصر…', more_combinations:'المزيد من التوافيق', search_more_partners:'البحث عن المزيد من عناصر الشركاء', my_creations_caps:'إبداعاتي', my_looks:'إطلالاتي', create_new_look:'إنشاء إطلالة جديدة',
  delete_account_q1:'Bu işlem geri alınamaz. Tüm verileriniz (gardırop, geziler, kombinler, uyarılar, abonelik) kalıcı olarak silinecek.', delete_account_q2:'Hesabınızı kalıcı olarak silmek istediğinize emin misiniz?', delete_confirm:'Sil', delete_account_error:'Silme başarısız. Daha sonra tekrar deneyin veya destek ile iletişime geçin.',
},

};

/* ─── Alias : les langues non complètes pointent vers leur fallback ── */
// Portugais : pt → pt-BR (le pt-BR est la version complète)
translations['pt']     = translations['pt-BR'];

// Variantes espagnoles
translations['es-419'] = translations['es']; // Espagnol Amérique latine
translations['es-MX']  = translations['es'];
translations['es-AR']  = translations['es'];

// Variantes anglaises (toutes vers en)
translations['en-US']  = translations['en'];
translations['en-GB']  = translations['en'];
translations['en-CA']  = translations['en'];
translations['en-AU']  = translations['en'];
translations['en-IN']  = translations['en'];

// Variantes françaises (toutes vers fr)
translations['fr-CA']  = translations['fr'];
translations['fr-BE']  = translations['fr'];
translations['fr-CH']  = translations['fr'];

// Variantes allemandes (toutes vers de)
translations['de-AT']  = translations['de'];
translations['de-CH']  = translations['de'];

// Variantes italiennes (toutes vers it)
translations['it-CH']  = translations['it'];

// Langues non couvertes → fallback sur en (anglais)
// Ces langues seront affichées en anglais en attendant des traductions dédiées
translations['nl']     = translations['en']; // Néerlandais
translations['sv']     = translations['en']; // Suédois
translations['no']     = translations['en']; // Norvégien
translations['nb']     = translations['en'];
translations['nn']     = translations['en'];
translations['da']     = translations['en']; // Danois
translations['fi']     = translations['en']; // Finnois
translations['pl']     = translations['en']; // Polonais
translations['cs']     = translations['en']; // Tchèque
translations['hu']     = translations['en']; // Hongrois
translations['ro']     = translations['en']; // Roumain
translations['ja']     = translations['en']; // Japonais
translations['ko']     = translations['en']; // Coréen
translations['zh-CN']  = translations['en']; // Chinois simplifié
translations['zh-TW']  = translations['en']; // Chinois traditionnel
translations['zh-HK']  = translations['en'];
translations['th']     = translations['en']; // Thaï
translations['vi']     = translations['en']; // Vietnamien
translations['hi']     = translations['en']; // Hindi
translations['id']     = translations['en']; // Indonésien
translations['ms']     = translations['en']; // Malais
